import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import * as PairingConst from '../../../pairing.constants';
import * as PairingHelper from './pairing-step-form-helper.service';
import { CompPrioDetailsModel } from './comp-prio-details.model';

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  FormArray,
  Validators,
} from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PairingStepFormApi } from './pairing-step-form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilsService } from '../../services/utils.service';
import * as FileSaver from 'file-saver';
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DownloadFileService } from '../../services/downloadFile.service';
import { MatTooltip } from '@angular/material/tooltip';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-pairing-step-form',
  templateUrl: './pairing-step-form.component.html',
  styleUrls: ['./pairing-step-form.component.scss'],
  standalone: false
})
export class PairingStepFormComponent implements OnInit {


  @ViewChild("perimeterTooltip") perimeterTooltip: MatTooltip;
  @ViewChild("regionsTooltip") regionsTooltip: MatTooltip;
  @ViewChild("countrysTooltip") countrysTooltip: MatTooltip;
  @ViewChild("plsTooltip") plsTooltip: MatTooltip;
  @ViewChild("blsTooltip") blsTooltip: MatTooltip;
  @ViewChild("michelinBrandsTooltip") michelinBrandsTooltip: MatTooltip;
  @ViewChild("otherBrandsTooltip") otherBrandsTooltip: MatTooltip;
  @ViewChild("excludesMichelinTooltip") excludesMichelinTooltip: MatTooltip;
  @ViewChild("caiFileTooltip") caiFileTooltip: MatTooltip;
  @ViewChild("clusteringsTooltip") clusteringsTooltip: MatTooltip;
  @ViewChild("degradationsTooltip") degradationsTooltip: MatTooltip;
  @ViewChild("sortingInputTooltip") sortingInputTooltip: MatTooltip;
  @ViewChild("priceMonthsTooltip") priceMonthsTooltip: MatTooltip;
  @ViewChild("priceLogicsTooltip") priceLogicsTooltip: MatTooltip;
  @ViewChild("orderPrefrenceTooltip") orderPrefrenceTooltip: MatTooltip;
  @ViewChild("compitiorFileTooltip") compitiorFileTooltip: MatTooltip;
  @ViewChild("validFromTooltip") validFromTooltip: MatTooltip;
  @ViewChild('myDiv') myDiv!: ElementRef;
  step = 0;
  multiStepForm!: FormGroup;
  list: any;
  submitted: boolean = false;
  validFromDateFlag: boolean = false;
  priceDateFlag: boolean = false;

  brands: any = [];

  regions: any = [];
  countries: any = [];
  businessLines: any = [];
  productLines: any = [];
  michelinBrands: any = [];
  otherBrands: any = [];
  otherSeasons: any = [];
  otherTyreUsages: any = [];
  otherTirelines: any = [];
  seasons: any = [];
  tyreUsages: any = [];
  tyreLines: any = [];
  tireLines: any = [];

  clusterings: any = [];
  degradations: any = [];

  priceLogics: any = [];
  orderPreferences: any = [];

  masterdata: any;
  otherMasterData: any;

  selectedCountries: any = [];
  selectedBusinessLine: any = [];
  selectedProductLine: any = [];
  selectedMichelinBrand: any = [];
  selectedOtherBrand: any = [];
  selectedOtherSeason: any = [];
  selectedOtherTyreUsage: any = [];
  selectedOtherTireline: any = [];
  selectedSeason: any = [];
  selectedTyreUsage: any = [];
  selectedTyreLine: any = [];
  selectedClusteringValues: any = [];
  selectedPriceLogic: any = [];
  selectedOrderPreference: any = [];
  selectedProductLineId: any;
  selectedWebsites: any = [];
  websiteLists: any = [];
  selectedSources: any = [];
  sourceLists: any = [];
  alllist: any = [];
  otherAlllist: any = [];

  countryDropdownSettings: IDropdownSettings = {};
  businessLineDropdownSettings: IDropdownSettings = {};
  productLineDropdownSettings: IDropdownSettings = {};
  michelinBrandDropdownSettings: IDropdownSettings = {};
  otherBrandDropdownSettings: IDropdownSettings = {};
  otherSeasonDropdownSettings: IDropdownSettings = {};
  otherTyreUsageDropdownSettings: IDropdownSettings = {};
  otherTirelineDropdownSettings: IDropdownSettings = {};
  seasonDropdownSettings: IDropdownSettings = {};
  michelinTyreUsageDropdownSettings: IDropdownSettings = {};
  michelinTyreLineDropdownSettings: IDropdownSettings = {};
  priceLogicDropdownSettings: IDropdownSettings = {};
  orderPreferenceDropdownSettings: IDropdownSettings = {};
  compBrandsDropdownSettings: IDropdownSettings = {};
  compTirelinesDropdownSettings: IDropdownSettings = {};
  websitesDropdownSettings: IDropdownSettings = {};
  sourcesDropdownSettings: IDropdownSettings = {};

  //params: any;
  storeRegionId: any = null;
  storeRegionCode: string = null;
  getRegions: any = {};
  itemsRemoved: any;
  typeSelected: string;
  getBrandIds: any;
  getOtherBrandIds: any;
  getSeasons: any;
  getUsages: any;
  getOtherUsages: any;
  getAllsubSeasonIdsIn: any;
  getAllOthersubSeasonIdsIn: any;
  getAllusageIdsIn: any;
  getAllOtherusageIdsIn: any;

  getAllBrandIds: any = [];
  getAllselectedSeason: any = [];
  getAllOtherBrandIds: any = [];
  getAllOtherSelectedSeason: any = [];

  isSeasonDisabled: boolean = true;
  isTireUsageDisabled: boolean = true;
  isTireLineDisabled: boolean = true;
  isCompPrioComplete: boolean = false;
  isOtherSeasonDisabled: boolean = true;
  isOtherTireUsageDisabled: boolean = true;
  isOtherTireLineDisabled: boolean = true;
  isWebsiteVisible: boolean = false;

  stepLabelText: string = 'Clustering';

  getSelectedClusteringValues: any = [];
  getSelectedDegradationValues: any = [];

  intersection: any = [];
  Loadintersection: any = [];
  fileToUpload: File = null;

  file: any;
  getFileName: string = null;
  getFileSize: any = null;

  getFileNameCompetitor: string = null;
  getFileSizeCompetitor: any = null;

  getCAIFileName: string = null;
  getCAIFileSize: any = null;

  message: boolean = false;
  showMessage: boolean = false;
  errorFlag: boolean = false;
  error: any = null;
  //errorMessage: boolean = false;
  isDownloadBoxDisabled: boolean = false;

  clusteringData: any;
  degradationData: any;
  fileName = '';
  fileSelectText: string = 'Upload';
  isCompetitorChecked = false;
  isCAIChecked: boolean = false;
  isMichelinBrandsExcluded: boolean = false;

  public files: NgxFileDropEntry[] = [];
  public selectedRowIndices: number[] = []; // Array to hold selected row indices
  public isMultipleDragMode: boolean = false; // Flag to track if multiple rows should be dragged
  isButtonDisabled: boolean = false;

  // Batch processing progress tracking
  public isBatchProcessing: boolean = false;
  public batchProcessingProgress: number = 0;
  public batchProcessingTotal: number = 0;
  public batchProcessingCurrent: number = 0;

  // Competitor Prioritization Operations (Copy/Delete) progress tracking
  public isCompPrioOpsProcessing: boolean = false;
  public compPrioOpsProgress: number = 0;
  public compPrioOpsTotal: number = 0;
  public compPrioOpsCurrent: number = 0;
  public compPrioOpsType: string = ''; // 'COPY' or 'DELETE'

  

  isMonthPickerVisible = false;
  isValidFromDateVisible = false;

  degradationError: string = null;
  errorFlagDeg: boolean = false;
  successMessageDeg: boolean = false;


  competitorError: string = null;
  errorFlagComp: boolean = false;
  successMessageComp: boolean = false;
  isCompetitorFileUploading: boolean = false;

  caiError: string = null;
  errorFlagCAI: boolean = false;
  successMessageCAI: boolean = false;

  priceDate: string = null;

  seasonitems: any = [];
  otherSeasonitems: any = [];

  successDegradationFile: string = '';
  successCompetitorFile: string = '';

  successCAIFile: string = '';

  startDate: string = '';
  endDate: string = '';
  validStartDate: string = '';

  isSubmitedSuccessfully: boolean = false;
  isSavedSuccessfully: boolean = false;

  backupCountryValue: any = [];
  countrySelection: any = [''];

  contentDispositionHeader: string = '';

  isBusinessLineSelected: boolean = false;
  isProductLineSelected: boolean = false;
  isDegradationSelected: boolean = false;
  isPriceLogicValidation: boolean = false;
  isOrderPreferenceValidation: boolean = false;
  isPriceDateValidation: boolean = false;
  isValidFromDateValidation: boolean = false;
  pairingId: any;

  productLineId: any;
  productLineIdOnEdit: any;
  isCountryDisabledOnRegion: boolean = true;
  isRegionSelected: boolean = false;
  CAIListMessage: string = 'CAI List file uploaded successfully';
  MSPNListMessage: string = 'MSPN List file uploaded successfully';
  isCAIFileMissing: boolean = false;
  isMissingCAIDownloadPopup: boolean = false;
  customLabel: string = '';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  getDegradationCheckValues: any[];
  ShowDatePicker = true;

  formSubmitted = false;
  isShow: boolean = false;
  errM: any;
  showBoolean: any;
  getSharingErorr: any;
  isMichelinBrandDisabled: boolean = false;
  isButtonDisabledDeg: boolean = false;

  id: any;
  editMode = false;
  private allowUsageRestore = true;
  private allowOtherUsageRestore = true;
  private allowTirelineRestore = true;
  private allowOtherTirelineRestore = true;
  copyMode = false;
  isCopyRequestGenerated: boolean = false;
  copyStage: string;
  stage: string;
  getDraftRecordById: any;
  maxStep: number;
  isDraftFile: boolean;
  timeInterval: string;
  isSaveDraftPopupShow: boolean = false;
  displayStyle = 'none';
  isToastMsg: any = '';
  isShowErrorMessageWithToast: boolean = false;
  isClickAction: boolean = false;
  updatedDate: any;
  isSaved: boolean = false;
  isMultiStepFormDirty: boolean = false;
  isConfirmationPopupVisibale: boolean = false;
  CLEARALL = 'clearall';
  SAVEDRAFT = 'SAVEDRAFT';
  CLEARCOMPPRIO = 'clearcompprio';
  UNMATCHED_CAI_DOWNLOAD = 'unmatchedCAIDownload';
  currentActionType: any;
  popupMessage: any;
  landHome: boolean = false;
  isClearAllOnPerimeter: boolean = false;
  priceLogicParameterLabel: any;
  orderPreferenceParameterLabel: any;
  isShowError: boolean = false;
  isOrderPrefDisable: boolean = false;
  isPriceMonthDisable: boolean = false;
  isPriceLogicDisable: boolean = false;
  isWebsiteDisabled: boolean = false;
  //isCountryClusteringHidden: boolean = false;
  productLinesParameterLabel: any;
  isProductLineDisabledOnRegion: boolean = true;
  isBusinessLineDisabledOnProductLine: boolean = true;
  isMacroUsageSelected: boolean = false;
  userId: string;
  perimeterPageTooltip: string = 'The Perimeter page defines the data to be considered for Pairing Algorithm. Pairing data can be filtered using the various filters provided or by uploading the CAI/MSPN List.';
  regionTooltip: string = 'In region filter user can select for which region user wants to generate the pairing. User can select only one region at a time';
  countryTooltip: string = 'Country filter shows the countries available as per selected region and allows user to select any number of countries for which user wants to generate pairing';
  plTooltip: string = 'Product Line filter shows the product lines available as per selected region and user rights provided. It allows user to select any one of the product line for which user wants to generate pairing';
  blTooltip: string = 'Business Line filter shows the business lines available as per selected Region and Product Line. It allows user to select any one of the business line for which user wants to generate pairing';
  michelinBrandTooltip: string = 'These filters are available as per the selected product line. Michelin Brand filters shows data only for Michelin brands and are applicable to select/filter the data for Michelin Brands for which user wants to generate the pairing. \r\nNote: These filters will be disabled in case user selects the CAI/MSPN Upload option';
  compitiorTooltip: string = 'These filters are available as per the selected product line. Other Brand filters contains data for both Competitor and Michelin Brands. \r\nNote: Michelin Brands will be removed from the filters when user selects the "Exclude Michelin Brands" checkbox';
  caiTooltip: string = 'This functionality allows user to upload the list of CAIs/MSPNs for which user wants to generate the pairing. These CAIs/MSPNs needs to be uploaded in the provided template only. \r\nNote: CAI/MSPN List functionality is only applicable for Michelin Brands. Michelin Brands filters will be disabled in case user selects the CAI/MSPN Upload option';
  excludeMichelinTooltip: string = 'This functionality enables user to exclude michelin brands from Other Brands selection';

  clusteringPageTooltip: string = 'The clustering is the first step in the pairing rules definition. Clustering defines the parameters which needs to be exactly matched. This means Michelin and the Competitor product would have the same value for the selected clustering parameters'
  degradationPageTooltip: string = 'The Degradation is the Second step in the pairing rules definition. Through degrdation parameters user can define the others required parameters to generate pairing. The degradation rules would be used to generate the exact match as well as the similar matched based on the user defined scores for degradation rules.';
  priceMonthTooltip: string = 'Period of prices collected the user wants to take into account to generate pairing.';
  sortingPageTooltip: string = 'In this final step user can define the type and duration of pricing data to be integrate to generate the pairing result. User can also define Competitor Tirelines to pair in priority';
  priceLogicTooltip: string = 'User can define which prices to be considered to generate the pairing';
  orderPrefTooltip: string = 'The objective is to define a priorization in case there is multiple pairing proposals for a given competitor with the same score. Most popular will focus on product which is the most present on web sites - Most recent will focus on newest product.';
  compPriorTooltip: string = 'Through this functionality user can define per Michelin tirelines what are the competitors tirelines to pair in priority.';
  validFromDateToolTip: string = "This is an user defined field to set the start month for the validity of Pairing. This month can be set as per the user needs and would be available in the 'PriceFx Perimeter' output file";
  isValidFromDateDisable: any;
  valid_from_date: string = null;
  validFromDateValue: string = null;
  dynamicArray: Array<CompPrioDetailsModel> = [];
  compArray: Array<string> = [];
  newDynamic: any = {};
  newCompElement: any = {};
  michelinBrandVar: any = [];
  otherBrandsVar: any = [];
  compErrorArray: Array<string> = [];
  errorIcon = 'assets/images/warning-icon.svg'
  greenChevronSouth = 'assets/images/green-chevron-south.svg'
  editIconBtn = 'assets/images/edit-icon.svg'
  closeIconBtn = 'assets/images/closeIcon-16x16.svg'
  deleteIconBtn = 'assets/images/trash-icon.svg'
  copyIconBtn = 'assets/images/copyIcon.svg'
  removeIconBtn = 'assets/images/closeIcon-16x16.svg'
  newDynamic1: any = {};
  michelinTirelineMap = new Map<string, string[]>();
  otherTirelineMap = new Map<string, string[]>();

  // Filtered arrays per row for virtual scrolling with search
  filteredMichelinBrandsPerRow = new Map<number, any[]>();
  filteredMichelinTirelinesPerRow = new Map<number, any[]>();
  filteredCompetitorBrandsPerRow = new Map<number, any[]>();
  filteredCompetitorTirelinesPerRow = new Map<number, any[]>();

  minValue = 1;
  maxValue = 100;
  numberStep = 1;
  isSuccessToast: boolean = true;
  duplicateError: string;

  constructor(
    private readonly pairingStepFormApi: PairingStepFormApi,
    private readonly spinnerService: NgxSpinnerService,
    private readonly utilService: UtilsService,
    private readonly http: HttpClient,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly downloadFileService: DownloadFileService,
    private readonly elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    this.route.queryParams.subscribe((params: Params) => {
      const token = params.token;
      if (token != undefined) {
        sessionStorage.setItem('parentToken', token);
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.typeSelected = 'ball-clip-rotate-pulse';

  }

  ngOnInit(): void {
    // Eagerly read userId so buildForm() (called synchronously below) always has a value.
    this.userId = sessionStorage.getItem('userId') || '';
    this.utilService.getUserId.subscribe((id: any) => {
      if (id == null || id == '') {
        this.userId = sessionStorage.getItem('userId') || '';
      } else {
        this.userId = id as string;
      }
    });

    // loading spinner show
    this.spinnerService.show();

    this.isSaved = false;
    let urlString = window.location.href;
    this.route.params.subscribe((params: Params) => {
      this.id = +params['id'];
      this.editMode = params['id'] != null;
      if (urlString.indexOf('copy') != -1) {
        this.copyMode = true;
      }
    });

    // on error
    this.pairingStepFormApi.error.subscribe((errorMessage: any) => {
      this.error = errorMessage;
    });

    this.utilService.showPopup.subscribe((res: any) => {
      this.showBoolean = res;
    });

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingErorr = res;
    });

    this.utilService.tosterMessage.subscribe((res: any) => {
      this.isToastMsg = res;
    });

    // regions call
    this.pairingStepFormApi
      .getRegions(
        this.userId,
        this.selectedBusinessLine,
        this.selectedProductLine
      )
      .subscribe(
        (res) => {
          const regionLsts = res;
          this.regions = regionLsts.result;
          this.regions = this.regions.filter(function (el: any) {
            return el !== 'NULL';
          });
          this.showBoolean = false;
        },
        (err) => {
          this.spinnerService.hide();
          this.showBoolean = true;
        }
      );

    this.getRegionDetails();
    if (!this.editMode) {
      this.getProductLineDetails([]);
      this.getBusinessLineDatails([], []);
    }


    //----Setting of form controls---------
    this.countryDropdownSettings = PairingConst.countryDropdownSettings;
    this.businessLineDropdownSettings =
      PairingConst.businessLineDropdownSettings;
    this.productLineDropdownSettings = PairingConst.productLineDropdownSettings;
    this.michelinBrandDropdownSettings =
      PairingConst.michelinBrandDropdownSettings;
    this.seasonDropdownSettings = PairingConst.seasonDropdownSettings;
    this.michelinTyreUsageDropdownSettings =
      PairingConst.michelinTyreUsageDropdownSettings;
    this.michelinTyreLineDropdownSettings =
      PairingConst.michelinTyreLineDropdownSettings;
    this.otherBrandDropdownSettings = PairingConst.otherBrandDropdownSettings;
    this.otherSeasonDropdownSettings = PairingConst.otherSeasonDropdownSettings;
    this.otherTyreUsageDropdownSettings =
      PairingConst.otherTyreUsageDropdownSettings;
    this.otherTirelineDropdownSettings =
      PairingConst.otherTirelineDropdownSettings;
    this.priceLogicDropdownSettings = PairingConst.priceLogicDropdownSettings;
    this.websitesDropdownSettings = PairingConst.websitesDropdownSettings;
    this.sourcesDropdownSettings = PairingConst.websitesDropdownSettings;
    this.orderPreferenceDropdownSettings =
      PairingConst.orderPreferenceDropdownSettings;
    this.compBrandsDropdownSettings = PairingConst.compBrandsDropdownSettings;
    this.compTirelinesDropdownSettings = PairingConst.compTirelinesDropdownSettings;
    this.buildForm();

    if (this.editMode) {
      this.pairingStepFormApi.getDraftRecord(this.id).subscribe(
        (res: any) => {
          const responseData = res;
          this.getDraftRecordById = responseData.result;

          this.stage = this.getDraftRecordById?.stage;
          if (this.copyMode) {
            this.copyStage = this.stage;
            this.multiStepForm.patchValue({
              stage: "PERIMETER"
            });
            this.stage = "PERIMETER";
          }

          this.getTimeInterval();

          // country call
          if (this.editMode) {
            this.isProductLineDisabledOnRegion = false;
            this.isBusinessLineDisabledOnProductLine = false;
            this.storeRegionId = this.getDraftRecordById?.regionId;
            this.checkCountryWW(this.getDraftRecordById?.regionCode);

            this.storeRegionCode = this.getDraftRecordById?.regionCode;
            this.getProductLineDetails(this.getDraftRecordById?.regionCode);
            this.getBusinessLineDatails(
              this.getDraftRecordById?.regionCode,
              this.getDraftRecordById?.productLine ?? []
            );
            this.fetchMichelinBrands();
            this.selectedMichelinBrand = PairingHelper.getSelectedRecords(
              this.michelinBrands,
              this.getDraftRecordById?.brandX ?? [],
              'brandName'
            );
            //----Loading of Other Brands based on isMichelinExcluded flag-----
            this.otherBrands=this.getOtherBrands(
              this.getDraftRecordById?.isMichelinExcluded,
              false
            );
            
            this.getParameterId(this.getDraftRecordById?.productLine[0]);
            this.customLabel = this.getDraftRecordById?.customLabel;
            
            // Set selected values from draft record in edit mode
            this.selectedSeason = this.getDraftRecordById?.seasonX ?? [];
            this.selectedTyreUsage = this.getDraftRecordById?.usageX ?? [];
            this.selectedTyreLine = this.getDraftRecordById?.tirelineX ?? [];
            this.selectedOtherSeason = this.getDraftRecordById?.seasonY ?? [];
            this.selectedOtherTyreUsage = this.getDraftRecordById?.usageY ?? [];
            this.selectedOtherTireline = this.getDraftRecordById?.tirelineY ?? [];
            
            // Enable dropdowns if selected values have data
            if (this.selectedSeason && this.selectedSeason.length > 0) {
              this.isSeasonDisabled = false;
            }
            if (this.selectedTyreUsage && this.selectedTyreUsage.length > 0) {
              this.isTireUsageDisabled = false;
            }
            if (this.selectedTyreLine && this.selectedTyreLine.length > 0) {
              this.isTireLineDisabled = false;
            }
            if (this.selectedOtherSeason && this.selectedOtherSeason.length > 0) {
              this.isOtherSeasonDisabled = false;
            }
            if (this.selectedOtherTyreUsage && this.selectedOtherTyreUsage.length > 0) {
              this.isOtherTireUsageDisabled = false;
            }
            if (this.selectedOtherTireline && this.selectedOtherTireline.length > 0) {
              this.isOtherTireLineDisabled = false;
            }
            
            this.pairingStepFormApi.getCountrys(this.storeRegionId, this.storeRegionCode).subscribe(
              (res) => {
                this.spinnerService.hide();
                const countryLists = res;
                this.countries = countryLists.result;
                this.countries = this.countries.filter(function (el: any) {
                  return el !== 'NULL';
                });
                this.countries = this.flattenCountries(this.countries);
                this.step = new Map(
                  PairingConst.stepMap.map((i) => [
                    i.stage.toUpperCase(),
                    i.step,
                  ])
                ).get(this.stage.toUpperCase());
                this.stepLabelText = this.getCurrentStepLabelText(this.step);
                if (this.copyMode) {
                  this.maxStep = new Map(
                    PairingConst.stepMap.map((i) => [
                      i.stage.toUpperCase(),
                      i.step,
                    ])
                  ).get(this.copyStage.toUpperCase());
                } else {
                  this.maxStep = this.step;
                }
                this.checkCountryWW(this.storeRegionCode);
                this.productLineId = this.productLineIdOnEdit;
                this.getCAIFileName = this.getDraftRecordById?.caiTable;
                this.getFileName = this.getDraftRecordById?.ruleSheet;
                this.isCompetitorChecked =
                  this.getDraftRecordById?.competitorPrioritization;
                this.isCAIChecked = this.getDraftRecordById?.isCAI;
                this.getFileNameCompetitor =
                  this.getDraftRecordById?.competitorsPrioritizationTable;
                this.isMichelinBrandsExcluded =
                  this.getDraftRecordById?.isMichelinExcluded;

                this.setBrandControlOnCAI(this.isCAIChecked);

                if (this.isCompetitorChecked) {
                  this.selectBrandsTirelinesALL();
                }
                if (
                  this.getFileName != null &&
                  this.getFileName != undefined &&
                  this.getFileName != '' &&
                  !this.isMultiStepFormDirty
                ) {
                  this.isDegradationSelected = false;
                  this.isButtonDisabledDeg = false;
                  this.successMessageDeg = true;
                  this.getFileSize = true;
                } else {
                  this.isButtonDisabledDeg = true;
                }

                if (
                  this.getFileNameCompetitor &&
                  this.getFileNameCompetitor != '' &&
                  !this.isMultiStepFormDirty
                ) {
                  //this.successMessageComp = true;
                  this.getFileSizeCompetitor = true;
                }

                if (
                  this.getCAIFileName != null &&
                  this.getCAIFileName != undefined &&
                  !this.isMultiStepFormDirty
                ) {
                  this.successMessageCAI = true;
                  this.getCAIFileSize = true;
                }

                //---Set MultiStepForm for array attributes with FormControls------
                this.multiStepForm = this.fillMultiStepForm(
                  PairingConst.multiStepFormArryAttr
                );

                //------Get selected values of Form Controls-----------
                this.selectedProductLine = PairingHelper.getSelectedRecords(
                  this.productLines,
                  this.getDraftRecordById?.productLine,
                  'code'
                );

                // Adjust product line dropdown settings for CT/MIN multi-select in edit mode
                const editPLCodes = this.getDraftRecordById?.productLine || [];
                if (editPLCodes.includes('CT') || editPLCodes.includes('MIN')) {
                  this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
                }

                this.selectedBusinessLine = PairingHelper.getSelectedRecords(
                  this.businessLines,
                  this.getDraftRecordById?.businessLine,
                  'businessLineName'
                );

                this.selectedCountries = this.restoreSelectedCountries(
                  this.countries,
                  this.getDraftRecordById?.country ?? [],
                  this.getDraftRecordById?.states ?? []
                );
                this.syncCountryStatesForm();

                this.selectedWebsites = PairingHelper.getSelectedRecords(
                  this.websiteLists || [],
                  this.getDraftRecordById?.websites || [],
                  'websites'
                );

                // Populate dropdown data for Michelin brands in edit mode
                if (this.selectedMichelinBrand && this.selectedMichelinBrand.length > 0) {
                  const michelinBrandIds = this.selectedMichelinBrand.map((item: any) => item.brandId);
                  
                  if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
                    // For normal product lines: load seasons (which will cascade to load usages and tire lines)
                    this.pairingStepFormApi.getSubSeasons(michelinBrandIds, this.getPLCodes()).subscribe(
                      (res) => {
                        const seasonLists = res;
                        this.masterdata = seasonLists.result;
                        this.seasons = Object.keys(seasonLists.result.subSeasonMap);
                        
                        // Match selected seasons and trigger cascade to load usages and tire lines
                        if (this.getDraftRecordById?.seasonX && this.getDraftRecordById.seasonX.length > 0) {
                          this.selectedSeason = PairingHelper.getSelectedRecordsFromArry(
                            this.seasons,
                            this.getDraftRecordById.seasonX
                          );
                          if (this.selectedSeason.length > 0) {
                            this.relativeActionOnSeason();
                          }
                        }
                      }
                    );
                  } else if (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN') {
                    // For AG and CT: load tire lines directly
                    this.getMichelinTyreLines(michelinBrandIds, [], []);
                  } else if (this.getPLCode() == '2W') {
                    // For 2W: load usages directly
                    this.getTyreUsage(michelinBrandIds, [], this.getPLCodes());
                  }
                }
                this.getOtherBrands(this.isMichelinBrandsExcluded, false);
                
                if (this.selectedOtherBrand.length > 0)
                // Populate dropdown data for Other brands in edit mode
                if (this.selectedOtherBrand && this.selectedOtherBrand.length > 0) {
                  const otherBrandIds = this.selectedOtherBrand.map((item: any) => item.brandId);
                  
                  if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
                    // For normal product lines: load seasons (which will cascade to load usages and tire lines)
                    this.pairingStepFormApi.getOtherSubSeasons(otherBrandIds, this.getPLCodes()).subscribe(
                      (res) => {
                        const otherSeasonLists = res;
                        this.otherMasterData = otherSeasonLists.result;
                        this.otherSeasons = Object.keys(otherSeasonLists.result.subSeasonMap);
                        
                        // Match selected seasons and trigger cascade to load usages and tire lines
                        if (this.getDraftRecordById?.seasonY && this.getDraftRecordById.seasonY.length > 0) {
                          this.selectedOtherSeason = PairingHelper.getSelectedRecordsFromArry(
                            this.otherSeasons,
                            this.getDraftRecordById.seasonY
                          );
                          if (this.selectedOtherSeason.length > 0) {
                            this.relativeActionOnOtherSeason();
                          }
                        }
                      }
                    );
                  } else if (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN') {
                    // For AG and CT: load tire lines directly
                    this.getOtherTyreLines(otherBrandIds, [], []);
                  } else if (this.getPLCode() == '2W') {
                    // For 2W: load usages directly
                    this.getTyreOtherUsage(otherBrandIds, [], this.getPLCodes());
                  }
                }

                //-------perform Action from Clustering till Until Progress Level----
                this.clusteringAction();

                if (
                  this.getDraftRecordById?.regionCode === 'WW'
                ) {
                  this.applyRegionWW();
                } else {
                  this.applyNonRegionWW();
                }

                if (
                  this.getDraftRecordById?.pricePeriodStart != undefined &&
                  this.getDraftRecordById?.pricePeriodEnd != undefined
                ) {
                  this.priceDate =
                    PairingConst.monthNames[
                    this.getDraftRecordById?.pricePeriodStart.split('-')[1] -
                    1
                    ] +
                    ' ' +
                    this.getDraftRecordById?.pricePeriodStart.split('-')[0] +
                    ' - ' +
                    PairingConst.monthNames[
                    this.getDraftRecordById?.pricePeriodEnd.split('-')[1] - 1
                    ] +
                    ' ' +
                    this.getDraftRecordById?.pricePeriodEnd.split('-')[0];
                }
                if (this.getDraftRecordById?.valid_from_date != undefined) {
                  this.validFromDateValue =
                    PairingConst.monthNames[
                    this.getDraftRecordById?.valid_from_date.split('-')[1] -
                    1
                    ] +
                    ' ' +
                    this.getDraftRecordById?.valid_from_date.split('-')[0];
                }

                this.getWebsites(true);


                this.multiStepForm.patchValue({
                  id: this.id,
                  region: this.getDraftRecordById?.region,
                  regionCode: this.getDraftRecordById?.regionCode,
                  productLine: this.getDraftRecordById?.productLine,
                  businessLine: this.getDraftRecordById?.businessLine,
                  isCAI: this.getDraftRecordById?.isCAI,
                  isMichelinExcluded:
                    this.getDraftRecordById?.isMichelinExcluded,
                  caiTable: this.getDraftRecordById?.caiTable,
                  ruleSheet: this.getDraftRecordById?.ruleSheet,
                  pricePeriodStart: this.getDraftRecordById?.pricePeriodStart,
                  pricePeriodEnd: this.getDraftRecordById?.pricePeriodEnd,
                  priceDate: this.priceDate,
                  mostPopular: this.getDraftRecordById?.mostPopular,
                  mostRecent: this.getDraftRecordById?.mostRecent,
                  competitorPrioritization:
                    this.getDraftRecordById?.competitorPrioritization,
                  competitorsPrioritizationTable:
                    this.getDraftRecordById?.competitorsPrioritizationTable,
                  stage: this.getDraftRecordById?.stage,
                  status: this.getDraftRecordById?.status,
                  updatedDate: this.getDraftRecordById?.updatedDate,
                  valid_from_date: this.getDraftRecordById?.valid_from_date,
                  validFromDateValue: this.validFromDateValue,
                  customLabel: this.getDraftRecordById?.customLabel,
                });

                this.degradationAction();
                if (this.getDraftRecordById?.competitorsPrioritizationTable != undefined &&
                  this.getDraftRecordById?.competitorsPrioritizationTable != '') {
                  this.isCompPrioComplete = true;

                  this.addRow(this.getDraftRecordById?.competitorPrioritizationDetails.length, true);
                }
                //----Set various InputType files-----
                if (this.getDraftRecordById?.ruleSheet != '') {
                  this.setInputFile(this.getDraftRecordById?.ruleSheet, 1);
                }
                if (this.getDraftRecordById?.caiTable !== '') {
                  this.setInputFile(this.getDraftRecordById?.caiTable, 5);
                }
                if (this.priceDate.indexOf('undefined', 0) != -1) {
                  this.priceDate = '';
                }
                if (this.validFromDateValue.indexOf('undefined', 0) != -1) {
                  this.validFromDateValue = '';
                }

                if ((this.getPLCode() === 'TC') || (this.getPLCode() === '2W')) {
                  this.isWebsiteVisible = true;
                }

              },
              (err) => {
                /*console.log(
                  `Fetching countries is failed for regionId: ${this.storeRegionId}` +
                  err
                );*/
                this.spinnerService.hide();
              }
            );
          }
        },
        (err: any) => {
          this.spinnerService.hide();
        }
      );
    } else {
      this.step = 1;
      this.maxStep = this.step;
      this.spinnerService.hide();
    }
  }

  extractAttributeValues(attribute: string, values: any) {
    const extractedValues = values[attribute] || []; // Ensure it returns an array or empty list if missing
    return extractedValues;
  }


  selectBrandsTirelinesOnEdit(michelinBrandList: any, competitorBrandList: any) {

    let payload = {
      "productLine": this.getPLCode(),
      "michelinBrandNames": michelinBrandList,
      "otherBrandNames": competitorBrandList
    }
    this.pairingStepFormApi.getBrandTirelinesValues(payload)
      .subscribe({
        next: (res: any) => {
          for (let [index, item] of michelinBrandList.entries()) {
            this.michelinTirelineMap.set(index, this.extractAttributeValues(michelinBrandList[index], res.result.michelin));
          }
          for (let [index, item] of competitorBrandList.entries()) {
            this.otherTirelineMap.set(index, this.extractAttributeValues(competitorBrandList[index], res.result.others));
          }

          this.spinnerService.hide();
        },
        error: (err) => {
          this.spinnerService.hide();
        }
      });
  }

  selectBrandsTirelinesALL() {

    this.pairingStepFormApi.getBrandTirelinesAllValues(this.getPLCodes())
      .subscribe({
        next: (res: any) => {
          // Clear existing maps
          this.michelinTirelineMap.clear();
          this.otherTirelineMap.clear();

          if (res.result?.michelin) {
            for (const brandName in res.result.michelin) {
              if (res.result.michelin.hasOwnProperty(brandName)) {
                // Remove duplicates using Set and convert back to array
                const uniqueTirelines = [...new Set(res.result.michelin[brandName])] as string[];
                this.michelinTirelineMap.set(brandName, uniqueTirelines);
              }
            }
          }
          if (res.result?.others) {
            for (const brandName in res.result.others) {
              if (res.result.others.hasOwnProperty(brandName)) {
                // Remove duplicates using Set and convert back to array
                const uniqueTirelines = [...new Set(res.result.others[brandName])] as string[];
                this.otherTirelineMap.set(brandName, uniqueTirelines);
              }
            }
          }
          setTimeout(() => {
            this.spinnerService.hide();
          }, 1000);
        },
        error: (err) => {
          setTimeout(() => {
            this.spinnerService.hide();
          }, 1000);
        }
      });
  }



  // regions call
  getRegionDetails() {
    this.pairingStepFormApi
      .getRegions(
        this.userId,
        this.selectedBusinessLine,
        this.selectedProductLine
      )
      .subscribe(
        (res) => {
          const regionLsts = res;
          this.regions = regionLsts.result;
          this.regions = this.regions.filter(function (el: any) {
            return el !== 'NULL';
          });
          this.showBoolean = false;
        },
        (err) => {
          this.spinnerService.hide();
          this.showBoolean = true;
        }
      );
  }

  clearBrandDetails() {
    this.michelinBrands = [];
    this.otherBrands = [];
    this.seasons = [];
    this.otherSeasons = [];
    this.tyreLines = [];
    this.otherTirelines = [];
    this.tyreUsages = [];
    this.otherTyreUsages = [];
    this.selectedMichelinBrand = [];
    this.selectedOtherBrand = [];
    this.selectedSeason = [];
    this.selectedOtherSeason = [];
    this.selectedTyreLine = [];
    this.selectedOtherTireline = [];
    this.selectedTyreUsage = [];
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      brandX: null,
      brandY: null,
      seasonX: null,
      seasonY: null,
      usageX: null,
      usageY: null,
      tirelineX: null,
      tirelineY: null,
    });
    this.onDeSelectAllMichelinBrands();
    this.onDeSelectAllOtherBrands();
    this.onDeSelectAllSeasons();
    this.onDeSelectAllTyreLines();
    this.onDeSelectAllOtherSeasons();
    this.onDeSelectAllOtherTirelines();
  }

  // michelin brand call
  fetchMichelinBrands() {
    this.pairingStepFormApi.getMichelinBrands(this.getPLCodes()).subscribe(
      (res) => {
        const michelinBrandLists = res;
        this.michelinBrands = michelinBrandLists.result;
        this.michelinBrands = this.michelinBrands.filter(function (el: any) {
          return el !== 'NULL';
        });

        this.selectedMichelinBrand = PairingHelper.getSelectedRecords(
          this.michelinBrands,
          this.getDraftRecordById?.brandX ?? [],
          'brandName'
        );
        this.getBrandIds = this.selectedMichelinBrand.map((item: any) => {
          return item.brandId;
        });

        // Sync brandX FormArray with selected brands
        (<FormArray>this.multiStepForm.get('brandX')).clear();
        this.selectedMichelinBrand.forEach((brand: any) => {
          (<FormArray>this.multiStepForm.get('brandX')).push(new FormControl(brand.brandName));
        });

        if (this.selectedMichelinBrand.length > 0)
          this.relativeActionOnMichelinBrand();
      },
      (err) => {
        this.spinnerService.hide();
      }
    );
  }

  // Other brand call
  getOtherBrands(
    isMichelinExcluded: boolean,
    isMichelinExclusionClicked: boolean
  ) {
    this.pairingStepFormApi
      .getOtherBrands(isMichelinExcluded, this.getPLCodes())
      .subscribe(
        (res) => {
          const otherBrandLists = res;
          this.otherBrands = [];
          this.selectedOtherBrand = [];
          this.otherBrands = otherBrandLists.result;
          this.otherBrands = this.otherBrands.filter(function (el: any) {
            return el !== 'NULL';
          });
          if (!(this.isClearAllOnPerimeter || isMichelinExclusionClicked)) {
            this.selectedOtherBrand = PairingHelper.getSelectedRecords(
              this.otherBrands,
              this.getDraftRecordById?.brandY ?? [],
              'brandName'
            );
          }

          // Sync brandY FormArray with selected brands
          (<FormArray>this.multiStepForm.get('brandY')).clear();
          this.selectedOtherBrand.forEach((brand: any) => {
            (<FormArray>this.multiStepForm.get('brandY')).push(new FormControl(brand.brandName));
          });

          if (this.selectedOtherBrand.length > 0)
            this.relativeActionOnOtherBrand();
          return this.otherBrands;

        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  // product Line call
  getProductLineDetails(regionCodeOnEdit: any) {
    this.pairingStepFormApi
      .getProductLines(
        regionCodeOnEdit,
        this.userId.toString(),
        this.selectedBusinessLine
      )
      .subscribe(
        (res) => {
          const productLineLists = res;
          this.productLines = productLineLists.result;
          this.productLines = this.productLines.filter(function (el: any) {
            return el !== 'NULL';
          });
          if (this.editMode) {
            this.isProductLineDisabledOnRegion = false;
            this.selectedProductLine = PairingHelper.getSelectedRecords(
              this.productLines,
              this.getDraftRecordById?.productLine,
              'code'
            );
            // Adjust product line dropdown settings for CT/MIN multi-select in edit mode
            const editPLCodes = this.getDraftRecordById?.productLine || [];
            if (editPLCodes.includes('CT') || editPLCodes.includes('MIN')) {
              this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
            }
          } else {
            this.isProductLineDisabledOnRegion = true;
          }
          return this.productLines;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  // Business Line call
  getBusinessLineDatails(regionCodeOnEdit: any, productLineCodeOnEdit: any = [], preserveSelection: boolean = false) {
    const savedSelection = preserveSelection ? [...this.selectedBusinessLine] : [];

    if (!preserveSelection && this.selectedBusinessLine.length >= 1) {
      this.selectedBusinessLine = [];
      this.businessLines = [];
      this.isMultiStepFormDirty = true;
      (<FormArray>this.multiStepForm.get('businessLine')).clear();
    }
    
    this.pairingStepFormApi
      .getBusinessLines(regionCodeOnEdit, productLineCodeOnEdit, this.userId)
      .subscribe(
        (res) => {
          const businessLineLists = res;
          this.businessLines = businessLineLists.result;
          this.businessLines = this.businessLines.filter(function (el: any) {
            return el !== 'NULL';
          });
          if (preserveSelection && savedSelection.length > 0) {
            // Restore selections that still exist in the newly fetched list
            this.selectedBusinessLine = this.businessLines.filter(
              (bl: any) => savedSelection.some((sel: any) => sel.businessLineName === bl.businessLineName)
            );
            (<FormArray>this.multiStepForm.get('businessLine')).clear();
            this.selectedBusinessLine.forEach((bl: any) => {
              (<FormArray>this.multiStepForm.get('businessLine')).push(
                new FormControl(bl.businessLineName, Validators.required)
              );
            });
          }
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  setInputFile(inputFileName: any, fileTypeId: number) {
    if (inputFileName != undefined && inputFileName != null) {
      this.inputFilesFormControls.push(
        this.fb.group({
          fileName: inputFileName,
          fileTypeId: fileTypeId,
        })
      );
    }
  }

  goToHome(event: any) {
    if (event === 'goToHome') {
      this.landHome = true;
    }
    this.currentActionType = this.SAVEDRAFT;
    this.popupMessage = PairingConst.SAVE_DRAFT_MSG;
    if (!this.checkFormDirtyState(true)) this.router.navigate(['/pairingAsProduct']);
  }

  clearAction() {
    if (this.step == 2) {
      this.stepLabelText = 'Clustering';
    } else if (this.step == 3) {
      this.stepLabelText = 'Degradation';
    }
    this.currentActionType = this.CLEARALL;
    this.popupMessage = PairingConst.CLEARALL_MSG;
    this.checkFormDirtyState(true);
  }

  checkFormDirtyState(clearAll: boolean) {
    if (this.isMultiStepFormDirty) {
      this.isConfirmationPopupVisibale = true;
      this.displayStyle = 'block';
      return true;
    }
    if (clearAll) {
      this.onClear();
    }

    return false;
  }

  onCancel() {
    this.displayStyle = 'none';
    this.isConfirmationPopupVisibale = false;
    if (this.landHome) {
      this.router.navigate(['/pairingAsProduct']);
    }
  }

  onCancelThroughIcon() {
    this.displayStyle = 'none';
    this.isConfirmationPopupVisibale = false;
    this.landHome = false;
  }

  degradationAction() {
    (<FormArray>this.multiStepForm.get('degradation')).clear();
    this.getDraftRecordById?.degradation.forEach((degradation: any) => {
      (<FormArray>this.multiStepForm.get('degradation')).push(
        new FormControl(degradation)
      );
    });

    this.degradationData = this.multiStepForm.get('degradation').value;
    this.stepLabelText = 'Degradation';
    if (this.degradationData.length > 0) {
      this.isDownloadBoxDisabled = true;
    }

    if (this.degradationData.includes('load_index')) {
      this.Loadintersection.push(
        this.getPLCode() === 'AG' ? 'Ply Rating' : 'Load Range'
      );
    } else if (this.degradationData.includes('load_range')) {
      this.Loadintersection.push(
        this.getPLCode() === 'PL' ? 'Load Index Single' : 'Load Index'
      );
    } else if (this.degradationData.includes('tyre_ply_rating')) {
      this.Loadintersection.push('Load Index');
    } else {
      this.Loadintersection = [];
    }

    this.relativeActionOnDegradationPopulation();
  }

  clusteringAction() {
    (<FormArray>this.multiStepForm.get('clustering')).clear();
    this.getDraftRecordById?.clustering.forEach((cluster: any) => {
      (<FormArray>this.multiStepForm.get('clustering')).push(
        new FormControl(cluster)
      );
    });
    this.stepLabelText = 'Clustering';
    this.clusteringData = this.multiStepForm.get('clustering').value;
    if (this.getPLCode() === 'TC') {
      if (this.clusteringData.includes('usage')) {
        //this.intersection.push('macro_usage');
        this.isMacroUsageSelected = false;
      } else if (this.clusteringData.includes('macro_usage')) {
        //this.intersection.push('usage');
        this.isMacroUsageSelected = true;
      }
    }
    this.relativeActionOnClusteringPopulation();
  }

  fillMultiStepForm(attrs: string[]): FormGroup {
    for (let attr of attrs) {
      if (this.getDraftRecordById?.hasOwnProperty(attr)) {
        (<FormArray>this.multiStepForm.get(attr)).clear();
        for (let atrObj of this.getDraftRecordById[attr]) {
          (<FormArray>this.multiStepForm.get(attr)).push(
            new FormControl(atrObj)
          );
        }
      }
    }

    return this.multiStepForm;
  }

  logRange(event: any) {
    const getString = event.split(':')[1].replace('to', '-');

    const Month = PairingConst.Month;
    const indexMonth = PairingConst.IndexMonth;

    const monthNumber1 =
      indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1]
      )
      ];

    const monthNumber2 =
      indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[1].split(' ')[1]
      )
      ];

    const month1 = new Date();
    month1.setDate(1);
    const month2 = new Date();
    month2.setDate(1);
    month1.setMonth(monthNumber1 - 1);
    month2.setMonth(monthNumber2 - 1);

    let m1;
    let m2;

    if (
      event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1] ==
      event.split(':')[1].replace('to', '-').split('-')[1].split(' ')[1]
    ) {
      m2 = getString.replaceAll(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1],
        month1.toLocaleString('en-US', { month: 'long' })
      );
    } else {
      m1 = getString.replace(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1],
        month1.toLocaleString('en-US', { month: 'long' })
      );
      m2 = m1.replace(
        event.split(':')[1].replace('to', '-').split('-')[1].split(' ')[1],
        month2.toLocaleString('en-US', { month: 'long' })
      );
    }

    this.priceDate = m2.trimStart();

    const m3 = month1.toLocaleString('en-US', { month: '2-digit' });
    const m4 = month2.toLocaleString('en-US', { month: '2-digit' });
    const year1 = this.priceDate.split(' ')[1];
    const year2 = this.priceDate.split(' ')[4];
    this.startDate = year1 + '-' + m3;
    this.endDate = year2 + '-' + m4;
    this.multiStepForm.patchValue({
      pricePeriodStart: this.startDate,
      pricePeriodEnd: this.endDate,
    });
    if (this.selectedPriceLogic.parameterName === 'sell_in') {
      this.onDeSelectAllWebsites();
      this.isWebsiteDisabled = true;
      this.isOrderPrefDisable = true;
    } else {
      this.getWebsites(false);
      this.isWebsiteDisabled = false;
      this.isOrderPrefDisable = false;
    }
  }

  logRange2(event: any) {
    const getString = event.split(':')[1].replace('to', '-');

    const Month = PairingConst.Month;
    const indexMonth = PairingConst.IndexMonth;
    const monthNumber3 = indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1]
      )
    ];
    const monthNumber1 =
      indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1]
      )
      ];

    const month1 = new Date();
    month1.setDate(1);
    month1.setMonth(monthNumber1 - 1);

    let m1;
    let m2;
    m1 = getString.replace(
      event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1],
      month1.toLocaleString('en-US', { month: 'long' })
    );

    this.valid_from_date = m1.trimStart();

    const m3 = month1.toLocaleString('en-US', { month: '2-digit' });
    const year1 = this.valid_from_date.split(' ')[1];
    this.validStartDate = year1 + '-' + m3;
    this.multiStepForm.patchValue({
      valid_from_date: this.validStartDate,
      validFromDateValue: this.valid_from_date,
    });
  }



  onMonthPickerOpen(type: string) {
    if (!this.isPriceMonthDisable && type === 'monthRange') {
      this.validFromDateFlag = false;
      this.priceDateFlag = true;
      this.isPriceDateValidation = true;
      this.isMonthPickerVisible = !this.isMonthPickerVisible;
      this.utilService.isCalendarPopUpOpen.subscribe(
        (res) => {
          const checkResValue = res;
          if (checkResValue) {
            this.isMonthPickerVisible = true;
          } else {
            this.isMonthPickerVisible = false;
          }
        },
        (err: any) => {
          this.spinnerService.hide();
          //console.log(err);
        }
      );
    }
    else if (type === 'valid_from_date') {
      this.validFromDateFlag = true;
      this.priceDateFlag = false;
      this.isValidFromDateValidation = true;
      this.isValidFromDateVisible = !this.isValidFromDateVisible;
      this.utilService.isCalendarPopUpOpen.subscribe(
        (res) => {
          const checkResValue = res;
          if (checkResValue) {
            this.isValidFromDateVisible = true;
          } else {
            this.isValidFromDateVisible = false;
          }
        },
        (err: any) => {
          this.spinnerService.hide();
        }
      );
    }
  }

  getWebsites(isEdit: boolean) {
    const resolvedStart = this.startDate || this.getDraftRecordById?.pricePeriodStart;
    const resolvedEnd = this.endDate || this.getDraftRecordById?.pricePeriodEnd;
    if (!resolvedStart || !resolvedEnd) {
      this.spinnerService.hide();
      return;
    }
    const selectedCountryNames = [
      ...new Set(this.selectedCountries.map((country: any) => {
        const full = this.countries.find((c: any) => c.countryNamePfx === country.countryNamePfx) ?? country;
        return full._parentCountry ?? full.countryNamePfx;
      }))
    ];
    const selectedStateNames: string[] = this.selectedCountries
      .map((country: any) => {
        const full = this.countries.find((c: any) => c.countryNamePfx === country.countryNamePfx) ?? country;
        return full._state ?? null;
      })
      .filter((s: string | null) => s !== null) as string[];
    this.pairingStepFormApi.getWebsites(resolvedStart,
      resolvedEnd,
      this.storeRegionCode, selectedCountryNames, selectedStateNames).subscribe(
        (res) => {
          this.spinnerService.hide();
          if (!isEdit) {
            this.onDeSelectAllWebsites();
            this.onDeSelectAllSources();
          }
          const resultList = (res.result ?? []).filter((el: any) => el !== 'NULL');
          if (this.storeRegionCode === 'AMS') {
            this.sourceLists = resultList;
            this.websiteLists = [];
          } else {
            this.websiteLists = resultList;
            this.sourceLists = [];
          }
          if (isEdit && this.editMode && this.getDraftRecordById?.websites?.length) {
            const draftWebsites = this.getDraftRecordById.websites;
            this.selectedWebsites = draftWebsites;
            const websitesFormArray = this.multiStepForm.get('websites') as FormArray;
            websitesFormArray.clear();
            this.selectedWebsites.forEach((website: any) => {
              websitesFormArray.push(new FormControl(website));
            });
          }
          if (isEdit && this.editMode && this.getDraftRecordById?.sources?.length) {
            const draftSources = this.getDraftRecordById.sources;
            this.selectedSources = draftSources;
            const sourcesFormArray = this.multiStepForm.get('sources') as FormArray;
            sourcesFormArray.clear();
            this.selectedSources.forEach((source: any) => {
              sourcesFormArray.push(new FormControl(source));
            });
          }
          
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  onWebsiteSelect() {
    this.isMultiStepFormDirty = true;
    const websitesFormArray = this.multiStepForm.get('websites') as FormArray;
    websitesFormArray.clear();

    // Push each selected website as a FormControl
    this.selectedWebsites.forEach((website: any) => {
      websitesFormArray.push(new FormControl(website));
    });

  }

  onWebsiteDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('websites')).controls.forEach(
      (l: any) => {
        if (l.value == item) {
          (<FormArray>this.multiStepForm.get('websites')).removeAt(i);
          return;
        }
        i++;
      }
    );
  }

  onSelectAllWebsites(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('websites')).clear();
    for (let key of items) {
      const controls = new FormControl(key);
      (<FormArray>this.multiStepForm.get('websites')).push(controls);
    }
  }

  onDeSelectAllWebsites() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('websites')).clear();
    this.selectedWebsites = [];
  }

  onSourceSelect() {
    this.isMultiStepFormDirty = true;
    const sourcesFormArray = this.multiStepForm.get('sources') as FormArray;
    sourcesFormArray.clear();
    this.selectedSources.forEach((source: any) => {
      sourcesFormArray.push(new FormControl(source));
    });
  }

  onSourceDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('sources')).controls.forEach(
      (l: any) => {
        if (l.value == item) {
          (<FormArray>this.multiStepForm.get('sources')).removeAt(i);
          return;
        }
        i++;
      }
    );
  }

  onSelectAllSources(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('sources')).clear();
    for (let key of items) {
      const controls = new FormControl(key);
      (<FormArray>this.multiStepForm.get('sources')).push(controls);
    }
  }

  onDeSelectAllSources() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('sources')).clear();
    this.selectedSources = [];
  }

  onRegionId(regionId: number, regionCode: string) {
    this.spinnerService.show();
    this.isMultiStepFormDirty = true;
    this.storeRegionId = regionId;
    this.storeRegionCode = regionCode;
    this.isBusinessLineDisabledOnProductLine = true;
    this.isProductLineDisabledOnRegion = false;
    this.isRegionSelected = true;
    this.setBrandControlOnCAI(false);
    this.multiStepForm.patchValue({
      regionCode: this.storeRegionCode,
    });
    if (this.storeRegionCode === 'WW') {
      this.applyRegionWW();
    } else {
      this.applyNonRegionWW();
    }

    this.checkCountryWW(this.storeRegionCode);

    if (this.selectedCountries.length >= 1) {
      this.selectedCountries = [];
      this.countries = [];
      this.onDeSelectAllCountys();
    }

    if (this.selectedProductLine.length >= 1) {
      this.selectedProductLine = [];
      this.productLines = [];
      this.isMultiStepFormDirty = true;
      (<FormArray>this.multiStepForm.get('productLine')).clear();
    }

    if (this.selectedBusinessLine.length >= 1) {
      this.selectedBusinessLine = [];
      this.businessLines = [];
      this.isMultiStepFormDirty = true;
      (<FormArray>this.multiStepForm.get('businessLine')).clear();
    }

    // product Line call
    this.pairingStepFormApi
      .getProductLines(
        this.storeRegionCode,
        this.userId,
        this.selectedBusinessLine
      )
      .subscribe(
        (res) => {
          const productLineLists = res;
          this.productLines = productLineLists.result;
          this.productLines = this.productLines.filter(function (el: any) {
            return el !== 'NULL';
          });
        },
        (err) => {
          this.spinnerService.hide();
        }
      );

    this.pairingStepFormApi.getCountrys(regionId, regionCode).subscribe(
      (res) => {
        this.spinnerService.hide();
        const countryLists = res;
        this.countries = countryLists.result;
        this.countries = this.countries.filter(function (el: any) {
          return el !== 'NULL';
        });
        this.countries = this.flattenCountries(this.countries);
      },
      (err) => {
        this.spinnerService.hide();
      }
    );

    if (this.storeRegionCode && this.getFileName !== null) {
      this.onClearDegradation();
    }

  }

  // get clustering values
  onParameter() {
    let plCode = this.getPLCodes();
    this.pairingStepFormApi
      .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const clusteringLists = res;
          this.clusterings = clusteringLists.result;
          this.clusterings = this.clusterings.filter(function (el: any) {
            return el !== 'NULL';
          });
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  onChecked(e: any) {
    this.isMultiStepFormDirty = true;
    this.isCompetitorChecked = e.target.checked;
    this.clearCompPrio(this.isCompetitorChecked);
    this.deselectAllRows();
    this.successMessageComp = false;
    this.errorFlagComp = false;
    this.getFileNameCompetitor = null;
    this.getFileNameCompetitor = null;
    this.competitorError = null;
    this.compErrorArray = [];
    if (this.isCompetitorChecked) {
      this.selectBrandsTirelinesALL();
    }
  }



  private resetCompetitorFields() {
    this.multiStepForm.patchValue({
      competitorsPrioritizationTable: null,
    });
    this.successMessageComp = false;
    this.getFileNameCompetitor = null;
    this.getFileSizeCompetitor = null;
  }

  onCheckedCAI(e: any) {
    this.isMultiStepFormDirty = true;
    this.isCAIChecked = e.target.checked;
    this.setBrandControlOnCAI(this.isCAIChecked);
  }

  setBrandControlOnCAI(flag: boolean) {
    if (flag) {
      this.disableControls();
      this.clearFormArrays(['brandX', 'seasonX', 'usageX', 'tirelineX']);
    } else {
      this.enableControls();
      this.clearCAIFileData();
      this.removeFilesByType(5);
    }

  }

  private disableControls() {
    if (this.getCAIFileName === null || this.getCAIFileName == '') {
      this.isButtonDisabled = true;
    }
    this.isMichelinBrandDisabled = true;
    this.isSeasonDisabled = true;
    this.isTireUsageDisabled = true;
    this.isTireLineDisabled = true;
  }

  private enableControls() {
    this.isCAIChecked = false;
    this.isMichelinBrandDisabled = false;
    this.isButtonDisabled = false;
    this.successMessageCAI = false;
    this.isCAIFileMissing = false;
    this.errorFlagCAI = false;
  }

  private clearFormArrays(fields: string[]) {
    fields.forEach((field) => {
      (<FormArray>this.multiStepForm.get(field)).clear();
      this.multiStepForm.patchValue({ [field]: null });

      switch (field) {
        case 'brandX':
          this.selectedMichelinBrand = [];
          break;
        case 'seasonX':
          this.selectedSeason = [];
          this.seasons = [];
          break;
        case 'usageX':
          this.selectedTyreUsage = [];
          this.tyreUsages = [];
          break;
        case 'tirelineX':
          this.selectedTyreLine = [];
          this.tyreLines = [];
          break;
      }
    });
  }

  private clearCAIFileData() {
    this.getCAIFileName = null;
    this.getCAIFileSize = null;
    this.caiError = null;
  }

  private removeFilesByType(fileTypeId: number) {
    const inputFiles = this.multiStepForm.get('inputFiles').value;

    inputFiles.forEach((file: any, index: number) => {
      if (file.fileTypeId === fileTypeId) {
        this.inputFilesFormControls.removeAt(index);
      }
    });
  }

  buildForm() {
    this.multiStepForm = this.fb.group({
      id: new FormControl(),
      userId: new FormControl(this.userId?.toString() ?? ''),
      region: new FormControl(),
      regionCode: new FormControl(),
      country: new FormArray([]),
      states: new FormArray([]),
      productLine: new FormArray([]),
      businessLine: new FormArray([]),
      brandX: new FormArray([]),
      seasonX: new FormArray([]),
      usageX: new FormArray([]),
      tirelineX: new FormArray([]),
      isCAI: new FormControl(false),
      caiTable: new FormControl(),
      brandY: new FormArray([]),
      seasonY: new FormArray([]),
      usageY: new FormArray([]),
      tirelineY: new FormArray([]),
      isMichelinExcluded: new FormControl(false),

      clustering: new FormArray([]),
      degradation: new FormArray([], Validators.required),
      ruleSheet: new FormControl(),
      priceDate: new FormControl(null, Validators.required),
      pricePeriodStart: new FormControl(null),
      pricePeriodEnd: new FormControl(null),
      mostPopular: new FormControl('False'),
      mostRecent: new FormControl('False'),
      priceLogic: new FormArray([]),
      orderPreference: new FormArray([]),
      websites: new FormArray([]),
      sources: new FormArray([]),
      competitorPrioritization: new FormControl(false),
      competitorsPrioritizationTable: new FormControl(),
      stage: new FormControl(),
      status: new FormControl(),
      inputFiles: new FormArray([]),
      updatedDate: new FormControl(),
      valid_from_date: new FormControl(null),
      validFromDateValue: new FormControl(null, Validators.required),
      competitorPrioritizationDetails: new FormArray([]),
      customLabel: new FormControl(''),
    });
  }

  get f() {
    return this.multiStepForm.controls['productLine'] as FormArray;
  }

  get inputFilesFormControls(): FormArray {
    return <FormArray>this.multiStepForm.get('inputFiles');
  }

  get priceLogic(): FormArray {
    return this.multiStepForm.get('priceLogic') as FormArray;
  }

  get orderPreference(): FormArray {
    return this.multiStepForm.get('orderPreference') as FormArray;
  }

  get productLine(): FormArray {
    return this.multiStepForm.get('productLine') as FormArray;
  }

  get businessLine(): FormArray {
    return this.multiStepForm.get('businessLine') as FormArray;
  }

  get clusteringValuesControl() {
    return this.multiStepForm.get('clustering') as FormArray;
  }

  get degradationValuesControl() {
    return this.multiStepForm.get('degradation') as FormArray;
  }

  get compPrioFormControls(): FormArray {
    return <FormArray>this.multiStepForm.get('competitorPrioritizationDetails');
  }

  onTyreUsageSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.usageName);
    (<FormArray>this.multiStepForm.get('usageX')).push(control);

    this.multiStepForm.patchValue({
      usageX: this.selectedTyreUsage.usageName,
    });

    this.relativeActionOnTyreUsage();
  }

  onTyreUsageDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    
    let i = 0;
    (<FormArray>this.multiStepForm.get('usageX')).controls.forEach((l: any) => {
      if (l.value == item.usageName) {
        (<FormArray>this.multiStepForm.get('usageX')).removeAt(i);
        return;
      }
      i++;
    });

    // received usages
    let usagesData = this.selectedTyreUsage;
    this.getUsages = usagesData.map((item: any) => {
      return item.usageId;
    });

    // received brands
    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedSeason;

    this.alllist = [];

    for (let j of data2) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    if (this.alllist.length !== 0) {
      for (const element of this.alllist) {
        this.checkElementNotNull(element);
        this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
          return item.subSeasonId;
        });
      }
    } else {
      this.getAllsubSeasonIdsIn = [];
    }

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getMichelinTyreLines(
        this.getBrandIds,
        this.getAllsubSeasonIdsIn,
        this.getUsages
      );
    } else if (this.getPLCode() == '2W') {
      this.getMichelinTyreLines(this.getBrandIds, [], this.getUsages);
    }

    if (this.editMode) {
      this.allowTirelineRestore = false;
    } else {
      // Keep tireline enabled when usage is deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isTireLineDisabled = false;
      }
    }
  }

  onSelectAllTyreUsages(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageX')).clear();
    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    for (let key of items) {
      const controls = new FormControl(key.usageName);
      (<FormArray>this.multiStepForm.get('usageX')).push(controls);
    }

    this.isTireLineDisabled = false;

    let usageStore: any = [];
    for (let key of items) {
      const controls = new FormControl(key.usageId);
      usageStore.push(controls.value);
    }
    this.selectedTyreUsage = usageStore;

    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    this.alllist = [];

    for (let j of this.seasonitems) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    for (const element of this.alllist) {
      this.checkElementNotNull(element);
      this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    // Extract usage IDs from selectedTyreUsage objects
    let usageIds = this.selectedTyreUsage.map((item: any) => {
      return typeof item === 'object' && item !== null ? item.usageId : item;
    });

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getMichelinTyreLines(
        this.getBrandIds,
        this.getAllsubSeasonIdsIn,
        usageIds
      );
    } else if (this.getPLCode() == '2W') {
      this.getMichelinTyreLines(this.getBrandIds, [], usageIds);
    }
  }

  onDeSelectAllTyreUsages(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageX')).clear();
    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.tyreLines = [];
    this.selectedTyreLine = null;
    this.multiStepForm.patchValue({
      tirelineX: this.selectedTyreLine?.categoryName,
    });

    if (this.editMode) {
      this.allowTirelineRestore = false;
      this.isTireLineDisabled = true;
    } else {
      // Keep tireline enabled when all usages are deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isTireLineDisabled = false;
      } else {
        this.isTireLineDisabled = true;
      }
    }

    let arr: any = [];

    for (let key of items) {
      const controls = new FormControl(key.usageId);
      arr.push(JSON.stringify(controls.value));
    }
    this.selectedTyreUsage = arr;

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getMichelinTyreLines(
        this.getAllBrandIds,
        this.getAllselectedSeason,
        this.selectedTyreUsage
      );
    } else if (this.getPLCode() == '2W') {
      this.getMichelinTyreLines(
        this.getAllBrandIds,
        [],
        this.selectedTyreUsage
      );
    }
  }

  onTyreLineSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.categoryName);
    (<FormArray>this.multiStepForm.get('tirelineX')).push(control);

    this.multiStepForm.patchValue({
      tirelineX: this.selectedTyreLine.categoryName,
    });
  }

  onTyreLineDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('tirelineX')).controls.forEach(
      (l: any) => {
        if (l.value == item.categoryName) {
          (<FormArray>this.multiStepForm.get('tirelineX')).removeAt(i);
          return;
        }
        i++;
      }
    );
  }

  onSelectAllTyreLines(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    for (let key of items) {
      const controls = new FormControl(key.categoryName);
      (<FormArray>this.multiStepForm.get('tirelineX')).push(controls);
    }
  }

  onDeSelectAllTyreLines() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.selectedTyreLine = [];
  }

  onSeasonSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item);
    (<FormArray>this.multiStepForm.get('seasonX')).push(control);

    
    this.relativeActionOnSeason();
  }

  relativeActionOnSeason() {
    this.isSeasonDisabled = false;
    if (
      this.multiStepForm.get('seasonX').value.length > 0 &&
      this.getPLCode() != 'AG' && this.getPLCode() != '2W'
      && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isTireUsageDisabled = false;
    }

    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    this.alllist = [];

    let data2 = this.selectedSeason;
    for (let j of data2) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    for (const element of this.alllist) {
      this.checkElementNotNull(element);
      this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    this.spinnerService.show();

    if (this.getPLCode() != '2W' && this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      // get tyre usage
      this.getTyreUsage(
        this.getBrandIds,
        this.getAllsubSeasonIdsIn,
        this.getPLCodes()
      );
    }

    this.alllist = [];
  }

  relativeActionOnTyreUsage() {
    this.isTireUsageDisabled = false;
    if (
      this.multiStepForm.get('usageX').value.length > 0 &&
      this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isTireLineDisabled = false;
    }

    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedSeason;

    this.alllist = [];

    for (let j of data2) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    for (const element of this.alllist) {
      this.checkElementNotNull(element);
      this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    let data4 = this.selectedTyreUsage;
    this.getAllusageIdsIn = data4.map((item: any) => {
      return item.usageId;
    });

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getMichelinTyreLines(
        this.getBrandIds,
        this.getAllsubSeasonIdsIn,
        this.getAllusageIdsIn
      );
    } else if (this.getPLCode() == '2W') {
      this.getMichelinTyreLines(this.getBrandIds, [], this.getAllusageIdsIn);
    }
    this.alllist = [];
  }

  onSeasonDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageX')).clear();
    this.selectedTyreUsage = [];
    this.multiStepForm.patchValue({
      usageX: null,
    });
    this.tyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    this.tyreLines = [];
    this.isTireLineDisabled = true;

    let i = 0;
    (<FormArray>this.multiStepForm.get('seasonX')).controls.forEach(
      (l: any) => {
        if (l.value == item) {
          (<FormArray>this.multiStepForm.get('seasonX')).removeAt(i);
          return;
        }
        i++;
      }
    );

    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedSeason;

    this.alllist = [];

    for (let j of data2) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    if (this.alllist.length !== 0) {
      for (const element of this.alllist) {
        this.checkElementNotNull(element);
        this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
          return item.subSeasonId;
        });
      }
    } else {
      this.getAllsubSeasonIdsIn = [];
    }

    if (this.editMode) {
      // In edit mode, disable usage and tireline when a season is unchecked
      this.isTireUsageDisabled = true;
      this.allowUsageRestore = false;
      this.allowTirelineRestore = false;
    } else {
      // Keep usage enabled when season is deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isTireUsageDisabled = false;
      }

      this.spinnerService.show();

      if (this.getPLCode() != '2W' && this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        // get tyre usage
        this.getTyreUsage(
          this.getBrandIds,
          this.getAllsubSeasonIdsIn,
          this.getPLCodes()
        );
      }
    }
  }

  onSelectAllSeasons(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('seasonX')).clear();
    (<FormArray>this.multiStepForm.get('usageX')).clear();

    for (const element of items) {
      const control = new FormControl(element);

      (<FormArray>this.multiStepForm.get('seasonX')).push(control);
    }

    //** */
    (<FormArray>this.multiStepForm.get('usageX')).clear();
    this.selectedTyreUsage = [];
    this.multiStepForm.patchValue({
      usageX: null,
    });
    this.tyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    this.tyreLines = [];
    //** */

    if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isTireUsageDisabled = false;
    }

    let data = this.selectedMichelinBrand;

    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    this.seasonitems = items;

    this.alllist = [];

    for (let j of items) {
      let data3 = this.masterdata.subSeasonMap[j];
      for (const element of data3) {
        this.alllist.push(element);
      }
    }

    for (const element of this.alllist) {
      this.checkElementNotNull(element);
      this.getAllsubSeasonIdsIn = this.alllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    this.spinnerService.show();

    if (this.getPLCode() != '2W' && this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      // get tyre usage
      this.getTyreUsage(
        this.getBrandIds,
        this.getAllsubSeasonIdsIn,
        this.getPLCodes()
      );
    }
  }

  onDeSelectAllSeasons() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('seasonX')).clear();
    this.selectedSeason = [];

    (<FormArray>this.multiStepForm.get('usageX')).clear();
    this.tyreUsages = [];
    this.selectedTyreUsage = [];
    this.multiStepForm.patchValue({
      usageX: null,
    });
    if (this.editMode) {
      // In edit mode, disable usage and tireline when all seasons are unchecked
      this.isTireUsageDisabled = true;
      this.allowUsageRestore = false;
      this.allowTirelineRestore = false;
    } else {
      // Keep usage enabled when all seasons are deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isTireUsageDisabled = false;
      } else {
        this.isTireUsageDisabled = true;
      }
    }

    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.tyreLines = [];
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    this.isTireLineDisabled = true;
  }

  onBusinessLineSelect(item: any) {
    this.isMultiStepFormDirty = true;
    this.isBusinessLineSelected = true;
    const control = new FormControl(item.businessLineName, Validators.required);
    (<FormArray>this.multiStepForm.get('businessLine')).push(control);
  }

  onBusinessLineDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('businessLine')).controls.forEach(
      (l: any) => {
        if (l.value == item.businessLineName) {
          (<FormArray>this.multiStepForm.get('businessLine')).removeAt(i);
          this.isBusinessLineSelected = true;
          return;
        }
        i++;
      }
    );
  }

  onProductLineSelect(item: any) {
    this.isMultiStepFormDirty = true;
    this.isProductLineSelected = true;
    this.isBusinessLineDisabledOnProductLine = false;

    const isCTOrMIN = item.code === 'CT' || item.code === 'MIN';
    const currentPLCodes = (<FormArray>this.multiStepForm.get('productLine')).value;
    const currentHasCTOrMIN = currentPLCodes.length > 0 && (currentPLCodes.includes('CT') || currentPLCodes.includes('MIN'));

    if (isCTOrMIN && currentHasCTOrMIN && !currentPLCodes.includes(item.code)) {
      // Adding MIN to CT or CT to MIN — keep existing and add the new one
      const control = new FormControl(item.code, Validators.required);
      (<FormArray>this.multiStepForm.get('productLine')).push(control);
      this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
    } else if (isCTOrMIN) {
      // First CT or MIN selection — clear any non-CT/MIN selections and switch to multi-select mode
      (<FormArray>this.multiStepForm.get('productLine')).clear();
      const control = new FormControl(item.code, Validators.required);
      (<FormArray>this.multiStepForm.get('productLine')).push(control);
      this.selectedProductLine = [item];
      this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
    } else {
      // Single selection for other product lines
      (<FormArray>this.multiStepForm.get('productLine')).clear();
      const control = new FormControl(item.code, Validators.required);
      (<FormArray>this.multiStepForm.get('productLine')).push(control);
      this.selectedProductLine = [item];
      this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
    }

    this.getParameterId(item.code);

    // When adding MIN to CT or CT to MIN, business lines are shared — preserve current selection
    const isCTMINAddition = isCTOrMIN && currentHasCTOrMIN && !currentPLCodes.includes(item.code);
    const selectedCodes = (<FormArray>this.multiStepForm.get('productLine')).value;

    if (!isCTMINAddition) {
      // Clear old selected business lines
      (<FormArray>this.multiStepForm.get('businessLine')).clear();
      this.businessLines = [];
      this.selectedBusinessLine = [];
    }

    this.getBusinessLineDatails(this.storeRegionCode, selectedCodes, isCTMINAddition);
    this.isDownloadBoxDisabled = false;
    // Show Website div when TC or 2W is selected
    if (item.code === 'TC' || item.code === '2W') {
      this.isWebsiteVisible = true;
    } else {
      this.isWebsiteVisible = false;
    }
    this.clearBrandDetails();
    this.clearClustering();
    this.clearDegradation();

    if (this.editMode && this.getDraftRecordById) {
      this.getDraftRecordById.brandX = [];
      this.getDraftRecordById.brandY = [];
    }

    this.errorFlagDeg = false;
    this.successMessageDeg = false;
    this.fetchMichelinBrands();
    this.getFileName = undefined;
    this.getFileSize = false;
    this.setBrandControlOnCAI(false);
    // other brands call

    this.getOtherBrands(this.isMichelinBrandsExcluded, false);

    // Season is enabled only when a brand is selected (relativeActionOnMichelinBrand / relativeActionOnOtherBrand)
    // Usage is enabled only when a season is selected (relativeActionOnSeason / relativeActionOnOtherSeason)
    this.isSeasonDisabled = true;
    this.isOtherSeasonDisabled = true;
    this.isTireUsageDisabled = true;
    this.isOtherTireUsageDisabled = true;
  }

  onProductLineDeselect(item: any) {
    this.getPriceLogicParameterLabel(item);
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('productLine')).controls.forEach(
      (l: any) => {
        if (l.value == item.code) {
          (<FormArray>this.multiStepForm.get('productLine')).removeAt(i);
          this.isProductLineSelected = true;
          return;
        }
        i++;
      }
    );

    // Update dropdown settings after deselection
    const remainingCodes = (<FormArray>this.multiStepForm.get('productLine')).value;
    const remainingHasCTOrMIN = remainingCodes.includes('CT') || remainingCodes.includes('MIN');
    if (remainingHasCTOrMIN) {
      this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
    } else {
      this.productLineDropdownSettings = Object.assign({}, this.productLineDropdownSettings, { singleSelection: false, limitSelection: -1 });
    }

    this.isWebsiteVisible = false;

    // Repopulate business lines for any remaining selected product lines
    if (remainingCodes.length > 0) {
      this.isBusinessLineDisabledOnProductLine = false;
      if (remainingHasCTOrMIN) {
        // CT and MIN share the same business lines — preserve current BL selection
        this.getBusinessLineDatails(this.storeRegionCode, remainingCodes, true);
        // Reload brand APIs with the updated remaining product line codes
        this.clearBrandDetails();
        this.fetchMichelinBrands();
        this.getOtherBrands(this.isMichelinBrandsExcluded, false);
        // Keep season/sub-season disabled until a brand is selected
        this.isSeasonDisabled = true;
        this.isOtherSeasonDisabled = true;
        // Refresh comp prio dropdowns for the remaining product line
        if (this.isCompetitorChecked) {
          this.selectBrandsTirelinesALL();
        }
      } else {
        (<FormArray>this.multiStepForm.get('businessLine')).clear();
        this.businessLines = [];
        this.selectedBusinessLine = [];
        this.multiStepForm.patchValue({ businessLine: null });
        this.getBusinessLineDatails(this.storeRegionCode, remainingCodes);
      }
    } else {
      (<FormArray>this.multiStepForm.get('businessLine')).clear();
      this.businessLines = [];
      this.selectedBusinessLine = [];
      this.multiStepForm.patchValue({ businessLine: null });
      this.isBusinessLineDisabledOnProductLine = true;
    }
  }

  onMichelinBrandSelect(item: any) {
    this.spinnerService.show();
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.brandName);
    (<FormArray>this.multiStepForm.get('brandX')).push(control);


    this.multiStepForm.patchValue({
      brandX: this.selectedMichelinBrand.brandName,
      /* usageX: null,
        tirelineX: null, */
    });

    this.relativeActionOnMichelinBrand();
  }

  relativeActionOnMichelinBrand() {
    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    if (
      this.multiStepForm.get('brandX').value.length > 0 &&
      this.getPLCode() != 'AG' && this.getPLCode() != '2W'
      && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isSeasonDisabled = false;
      // // season call
      this.pairingStepFormApi
        .getSubSeasons(this.getBrandIds, this.getPLCodes())
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const seasonLists = res;
            const data = seasonLists.result;
            this.masterdata = seasonLists.result;
            this.seasons = Object.keys(data.subSeasonMap);

            //------For SeasonX-----------
            // Only restore old values on initial load, not after user has made changes
            if (this.editMode && !this.isMultiStepFormDirty) {
              this.selectedSeason = PairingHelper.getSelectedRecordsFromArry(
                this.seasons,
                this.getDraftRecordById?.seasonX ?? []
              );
              if (this.selectedSeason.length > 0) this.relativeActionOnSeason();
            }
          },
          (err: any) => {
            this.spinnerService.hide();
          }
        );
    } else if (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN') {
      this.isTireLineDisabled = false;
      this.isSeasonDisabled = true;
      this.isTireUsageDisabled = true;
      this.getMichelinTyreLines(this.getBrandIds, [], []);
    } else if (this.getPLCode() == '2W') {
      this.isTireLineDisabled = true;
      this.isSeasonDisabled = true;
      this.isTireUsageDisabled = false;
      this.getTyreUsage(this.getBrandIds, [], this.getPLCodes());
    }
  }

  onOtherBrandSelect(item: any) {
    this.spinnerService.show();
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.brandName);
    (<FormArray>this.multiStepForm.get('brandY')).push(control);

    
    this.multiStepForm.patchValue({
      brandY: this.selectedOtherBrand.brandName,
    });

    this.relativeActionOnOtherBrand();
  }

  relativeActionOnOtherBrand() {
    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    if (
      this.multiStepForm.get('brandY').value.length > 0 &&
      this.getPLCode() != 'AG' && this.getPLCode() != '2W'
      && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isOtherSeasonDisabled = false;

      // other season call
      this.pairingStepFormApi
        .getOtherSubSeasons(this.getOtherBrandIds, this.getPLCodes())
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const otherSeasonLists = res;
            const data = otherSeasonLists.result;
            this.otherMasterData = otherSeasonLists.result;
            this.otherSeasons = Object.keys(data.subSeasonMap);

            //------For SeasonY-----------
            // Only restore old values on initial load, not after user has made changes
            if (
              this.editMode &&
              this.otherSeasons != undefined &&
              !this.isClearAllOnPerimeter &&
              !this.isMultiStepFormDirty
            ) {
              this.selectedOtherSeason =
                PairingHelper.getSelectedRecordsFromArry(
                  this.otherSeasons,
                  this.getDraftRecordById?.seasonY ?? []
                );
              if (this.selectedOtherSeason.length > 0)
                this.relativeActionOnOtherSeason();
            }
          },
          (err: any) => {
            this.spinnerService.hide();
            //console.log(err);
          }
        );
    } else if (this.multiStepForm.get('brandY').value.length > 0 &&
      (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN')) {
      this.isOtherTireLineDisabled = false;
      this.isOtherSeasonDisabled = true;
      this.isOtherTireUsageDisabled = true;
      this.getOtherTyreLines(this.getOtherBrandIds, [], []);
    } else if (
      this.multiStepForm.get('brandY').value.length > 0 &&
      this.getPLCode() == '2W'
    ) {
      this.isOtherTireLineDisabled = true;
      this.isOtherSeasonDisabled = true;
      this.isOtherTireUsageDisabled = false;
      this.getTyreOtherUsage(this.getOtherBrandIds, [], this.getPLCodes());
    }
  }

  onMichelinBrandDeselect(item: any) {
    this.isMultiStepFormDirty = true;

    let i = 0;
    (<FormArray>this.multiStepForm.get('brandX')).controls.forEach((l: any) => {
      if (l.value == item.brandName) {
        (<FormArray>this.multiStepForm.get('brandX')).removeAt(i);
        return;
      }
      i++;
    });

    let data = this.selectedMichelinBrand;
    this.getBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    if (this.getBrandIds.length === 0) {
      // Clear all dependent dropdowns
      (<FormArray>this.multiStepForm.get('seasonX')).clear();
      this.seasons = [];
      this.selectedSeason = [];
      this.multiStepForm.patchValue({
        seasonX: null,
      });

      (<FormArray>this.multiStepForm.get('usageX')).clear();
      this.tyreUsages = [];
      this.selectedTyreUsage = [];
      this.multiStepForm.patchValue({
        usageX: null,
      });

      (<FormArray>this.multiStepForm.get('tirelineX')).clear();
      this.tyreLines = [];
      this.selectedTyreLine = [];
      this.multiStepForm.patchValue({
        tirelineX: null,
      });

      // In editMode disable season too; otherwise keep it enabled
      this.isSeasonDisabled = this.editMode ? true : false;
      this.isTireUsageDisabled = true;
      this.isTireLineDisabled = true;
    } else {
      this.relativeActionOnMichelinBrand();
    }

  }

  onOtherBrandDeselect(item: any) {
    this.isMultiStepFormDirty = true;
  
    let i = 0;
    (<FormArray>this.multiStepForm.get('brandY')).controls.forEach((l: any) => {
      if (l.value == item.brandName) {
        (<FormArray>this.multiStepForm.get('brandY')).removeAt(i);
        return;
      }
      i++;
    });

    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    if (this.getOtherBrandIds.length === 0) {
      // Clear all dependent dropdowns
      (<FormArray>this.multiStepForm.get('seasonY')).clear();
      this.otherSeasons = [];
      this.selectedOtherSeason = [];
      this.multiStepForm.patchValue({
        seasonY: null,
      });

      (<FormArray>this.multiStepForm.get('usageY')).clear();
      this.otherTyreUsages = [];
      this.selectedOtherTyreUsage = [];
      this.multiStepForm.patchValue({
        usageY: null,
      });

      (<FormArray>this.multiStepForm.get('tirelineY')).clear();
      this.otherTirelines = [];
      this.selectedOtherTireline = [];
      this.multiStepForm.patchValue({
        tirelineY: null,
      });

      // In editMode disable season too; otherwise keep it enabled
      this.isOtherSeasonDisabled = this.editMode ? true : false;
      this.isOtherTireUsageDisabled = true;
      this.isOtherTireLineDisabled = true;
    } else {
      this.relativeActionOnOtherBrand();
    }
  }

  onOtherTirelineSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.categoryName);
    (<FormArray>this.multiStepForm.get('tirelineY')).push(control);
    this.multiStepForm.patchValue({
      tirelineY: this.selectedOtherTireline.categoryName,
    });
  }

  onOtherTirelineDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('tirelineY')).controls.forEach(
      (l: any) => {
        if (l.value == item.categoryName) {
          (<FormArray>this.multiStepForm.get('tirelineY')).removeAt(i);
          return;
        }
        i++;
      }
    );
  }

  onSelectAllOtherTirelines(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    for (let key of items) {
      const controls = new FormControl(key.categoryName);
      (<FormArray>this.multiStepForm.get('tirelineY')).push(controls);
    }
  }

  onDeSelectAllOtherTirelines() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
  }

  onCountrySelect(item: any) {
    this.isMultiStepFormDirty = true;
    this.onDeSelectAllWebsites();
    this.priceDate = null;
    this.multiStepForm.patchValue({
      priceDate: null,
      pricePeriodStart: null,
      pricePeriodEnd: null,
    });
    this.syncCountryStatesForm();
  }

  // Deselect dropdown values methods
  onCountryDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    this.onDeSelectAllWebsites();
    this.priceDate = null;
    this.multiStepForm.patchValue({
      priceDate: null,
      pricePeriodStart: null,
      pricePeriodEnd: null,
    });
    this.syncCountryStatesForm();
  }

  onSelectAllCountrys(items: any) {
    this.isMultiStepFormDirty = true;
    this.onDeSelectAllWebsites();
    this.priceDate = null;
    this.multiStepForm.patchValue({
      priceDate: null,
      pricePeriodStart: null,
      pricePeriodEnd: null,
    });
    this.syncCountryStatesForm();
  }

  onDeSelectAllCountys() {
    this.isMultiStepFormDirty = true;
    this.onDeSelectAllWebsites();
    this.priceDate = null;
    this.multiStepForm.patchValue({
      priceDate: null,
      pricePeriodStart: null,
      pricePeriodEnd: null,
    });
    (<FormArray>this.multiStepForm.get('country')).clear();
    (<FormArray>this.multiStepForm.get('states')).clear();
  }

  onSelectAllMichelinBrands(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('seasonX')).clear();
    this.selectedSeason = [];
    this.multiStepForm.patchValue({
      seasonX: null,
    });
    this.seasons = [];

    (<FormArray>this.multiStepForm.get('usageX')).clear();
    this.selectedTyreUsage = [];
    this.multiStepForm.patchValue({
      usageX: null,
    });
    this.tyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    this.tyreLines = [];

    for (let key of items) {
      const controls = new FormControl(key.brandName);
      (<FormArray>this.multiStepForm.get('brandX')).push(controls);
    }

    let arr: any = [];

    for (let key of items) {
      const controls = new FormControl(key.brandId);
      arr.push(JSON.stringify(controls.value));
    }
    this.selectedMichelinBrand = arr;

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isSeasonDisabled = false;

      this.pairingStepFormApi
        .getSubSeasons(this.selectedMichelinBrand, this.getPLCodes())
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const seasonLists = res;
            const data = seasonLists.result;
            this.masterdata = seasonLists.result;
            this.seasons = Object.keys(data.subSeasonMap);
          },
          (err: any) => {
            this.spinnerService.hide();
          }
        );
    } else if (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN') {
      this.isTireLineDisabled = false;
      this.isSeasonDisabled = true;
      this.isTireUsageDisabled = true;
      this.getMichelinTyreLines(this.selectedMichelinBrand, [], []);
    } else if (this.getPLCode() == '2W') {
      this.isTireLineDisabled = true;
      this.isSeasonDisabled = true;
      this.isTireUsageDisabled = false;
      this.getTyreUsage(this.selectedMichelinBrand, [], this.getPLCodes());
    }

    this.getAllBrandIds = this.selectedMichelinBrand;
  }

  onDeSelectAllMichelinBrands() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('brandX')).clear();

    (<FormArray>this.multiStepForm.get('seasonX')).clear();
    this.seasons = [];
    this.selectedSeason = [];
    this.multiStepForm.patchValue({
      seasonX: null,
    });
    // In editMode or when CAI is checked, disable season; otherwise keep it enabled
    this.isSeasonDisabled = (this.editMode || this.isCAIChecked) ? true : false;

    (<FormArray>this.multiStepForm.get('usageX')).clear();
    this.tyreUsages = [];
    this.selectedTyreUsage = [];
    this.multiStepForm.patchValue({
      usageX: null,
    });
    this.isTireUsageDisabled = true;

    (<FormArray>this.multiStepForm.get('tirelineX')).clear();
    this.tyreLines = [];
    this.selectedTyreLine = [];
    this.multiStepForm.patchValue({
      tirelineX: null,
    });
    this.isTireLineDisabled = true;
  }

  onExcludingMichelinBrands(e: any) {
    this.isMultiStepFormDirty = true;
    if (e.target.checked) this.isMichelinBrandsExcluded = true;
    else this.isMichelinBrandsExcluded = false;

    this.getOtherBrands(this.isMichelinBrandsExcluded, true);
    this.relativeActionOnExcludeMichelinBrand();
  }

  relativeActionOnExcludeMichelinBrand() {
    (<FormArray>this.multiStepForm.get('brandY')).clear();
    (<FormArray>this.multiStepForm.get('seasonY')).clear();
    (<FormArray>this.multiStepForm.get('usageY')).clear();
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();

    this.selectedOtherBrand = [];
    this.selectedOtherSeason = [];
    this.selectedOtherTyreUsage = [];
    this.selectedOtherTireline = [];

    this.isOtherSeasonDisabled = true;
    this.isOtherTireUsageDisabled = true;
    this.isOtherTireLineDisabled = true;

    this.multiStepForm.patchValue({
      brandY: null,
      tirelineY: null,
      seasonY: null,
      usageY: null,
      isMichelinExcluded: this.isMichelinBrandsExcluded,
    });
  }

  onSelectAllOtherBrands(items: any) {
    this.isMultiStepFormDirty = true;
    let arr: any = [];
    // **
    (<FormArray>this.multiStepForm.get('seasonY')).clear();
    this.selectedOtherSeason = [];
    this.multiStepForm.patchValue({
      seasonY: null,
    });
    this.otherSeasons = [];

    (<FormArray>this.multiStepForm.get('usageY')).clear();
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      usageY: null,
    });
    this.otherTyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });
    this.otherTirelines = [];

    for (let key of items) {
      const brandnames = new FormControl(key.brandName);
      const brandIds = new FormControl(key.brandId);
      arr.push(JSON.stringify(brandIds.value));
      (<FormArray>this.multiStepForm.get('brandY')).push(brandnames);
    }
    this.selectedOtherBrand = arr;

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isOtherSeasonDisabled = false;
      this.spinnerService.show();

      this.pairingStepFormApi
        .getOtherSubSeasons(this.selectedOtherBrand, this.getPLCodes())
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const otherSeasonLists = res;
            const data = otherSeasonLists.result;
            this.otherMasterData = otherSeasonLists.result;
            this.otherSeasons = Object.keys(data.subSeasonMap);
          },
          (err: any) => {
            this.spinnerService.hide();
          }
        );
    } else if (this.getPLCode() == 'AG' || this.getPLCode() == 'CT' || this.getPLCode() == 'MIN') {
      this.isOtherTireLineDisabled = false;
      this.isOtherSeasonDisabled = true;
      this.isOtherTireUsageDisabled = true;
      this.getOtherTyreLines(this.selectedOtherBrand, [], []);
    } else if (this.getPLCode() == '2W') {
      this.isOtherTireLineDisabled = true;
      this.isOtherSeasonDisabled = true;
      this.isOtherTireUsageDisabled = false;
      this.getTyreOtherUsage(this.selectedOtherBrand, [], this.getPLCodes());
    }

    this.getAllOtherBrandIds = this.selectedOtherBrand;
  }

  onDeSelectAllOtherBrands() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('brandY')).clear();

    (<FormArray>this.multiStepForm.get('seasonY')).clear();
    this.otherSeasons = [];
    this.selectedOtherSeason = [];
    this.multiStepForm.patchValue({
      seasonY: null,
    });
    // In editMode disable season too; otherwise keep it enabled
    this.isOtherSeasonDisabled = this.editMode ? true : false;

    (<FormArray>this.multiStepForm.get('usageY')).clear();
    this.otherTyreUsages = [];
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      usageY: null,
    });
    this.isOtherTireUsageDisabled = true;

    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.otherTirelines = [];
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });
    this.isOtherTireLineDisabled = true;
  }

  /* Step 1 other brands section */
  onOtherSeasonSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item);
    (<FormArray>this.multiStepForm.get('seasonY')).push(control);

    this.relativeActionOnOtherSeason();
  }

  relativeActionOnOtherSeason() {
    this.isOtherSeasonDisabled = false;
    if (
      this.multiStepForm.get('seasonY').value.length > 0 &&
      this.getPLCode() != 'AG' && this.getPLCode() != '2W'
      && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isOtherTireUsageDisabled = false;
    }

    this.otherTirelines = [];
    //** */

    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    this.otherAlllist = [];

    let data2 = this.selectedOtherSeason;
    for (let j of data2) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    for (const element of this.otherAlllist) {
      this.checkElementNotNull(element);
      this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getTyreOtherUsage(
        this.getOtherBrandIds,
        this.getAllOthersubSeasonIdsIn,
        this.getPLCodes()
      );
    }

    this.otherAlllist = [];
  }

  relativeActionOnOtherTyreUsage() {
    this.isOtherTireUsageDisabled = false;
    if (this.multiStepForm.get('usageY').value.length > 0) {
      this.isOtherTireLineDisabled = false;
    }

    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedOtherSeason;

    this.otherAlllist = [];

    for (let j of data2) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    for (const element of this.otherAlllist) {
      this.checkElementNotNull(element);
      this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    let data4 = this.selectedOtherTyreUsage;
    this.getAllOtherusageIdsIn = data4.map((item: any) => {
      return item.usageId;
    });

    this.spinnerService.show();

    // other tyre lines call
    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getOtherTyreLines(
        this.getOtherBrandIds,
        this.getAllOthersubSeasonIdsIn,
        this.getAllOtherusageIdsIn
      );
    } else if (this.getPLCode() == '2W') {
      this.getOtherTyreLines(
        this.getOtherBrandIds,
        [],
        this.getAllOtherusageIdsIn
      );
    }

    this.otherAlllist = [];
  }

  onOtherSeasonDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageY')).clear();
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      usageY: null,
    });
    this.otherTyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });
    this.otherTirelines = [];
    this.isOtherTireLineDisabled = true;
  
    let i = 0;
    (<FormArray>this.multiStepForm.get('seasonY')).controls.forEach(
      (l: any) => {
        if (l.value == item) {
          (<FormArray>this.multiStepForm.get('seasonY')).removeAt(i);
          return;
        }
        i++;
      }
    );

    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedOtherSeason;

    this.otherAlllist = [];

    for (let j of data2) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    if (this.otherAlllist.length !== 0) {
      for (const element of this.otherAlllist) {
        this.checkElementNotNull(element);
        this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
          return item.subSeasonId;
        });
      }
    } else {
      this.getAllOthersubSeasonIdsIn = [];
    }

    if (this.editMode) {
      // In edit mode, disable usage and tireline when a season is unchecked
      this.isOtherTireUsageDisabled = true;
      this.allowOtherUsageRestore = false;
      this.allowOtherTirelineRestore = false;
    } else {
      // Keep usage enabled when season is deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isOtherTireUsageDisabled = false;
      }

      this.spinnerService.show();

      if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.getTyreOtherUsage(
          this.getOtherBrandIds,
          this.getAllOthersubSeasonIdsIn,
          this.getPLCodes()
        );
      }
    }
  }

  onSelectAllOtherSeasons(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('seasonY')).clear();
    (<FormArray>this.multiStepForm.get('usageY')).clear();

    for (const element of items) {
      const control = new FormControl(element);

      (<FormArray>this.multiStepForm.get('seasonY')).push(control);
    }

    //** */
    (<FormArray>this.multiStepForm.get('usageY')).clear();
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      usageY: null,
    });
    this.otherTyreUsages = [];

    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });
    this.otherTirelines = [];
    //** */

    if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.isOtherTireUsageDisabled = false;
    }

    let data = this.selectedOtherBrand;

    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    this.otherSeasonitems = items;
    this.otherAlllist = [];

    for (let j of items) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    for (const element of this.otherAlllist) {
      this.checkElementNotNull(element);
      this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getTyreOtherUsage(
        this.getOtherBrandIds,
        this.getAllOthersubSeasonIdsIn,
        this.getPLCodes()
      );
    }
  }

  onDeSelectAllOtherSeasons() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('seasonY')).clear();
    this.selectedOtherSeason = [];

    (<FormArray>this.multiStepForm.get('usageY')).clear();
    this.otherTyreUsages = [];
    this.selectedOtherTyreUsage = [];
    this.multiStepForm.patchValue({
      usageY: null,
    });
    if (this.editMode) {
      // In edit mode, disable usage and tireline when all other seasons are unchecked
      this.isOtherTireUsageDisabled = true;
      this.allowOtherUsageRestore = false;
      this.allowOtherTirelineRestore = false;
    } else {
      // Keep usage enabled when all other seasons are deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isOtherTireUsageDisabled = false;
      } else {
        this.isOtherTireUsageDisabled = true;
      }
    }

    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.otherTirelines = [];
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });
    this.isOtherTireLineDisabled = true;
  }

  onOtherTyreUsageSelect(item: any) {
    this.isMultiStepFormDirty = true;
    const control = new FormControl(item.usageName);
    (<FormArray>this.multiStepForm.get('usageY')).push(control);

    this.multiStepForm.patchValue({
      usageY: this.selectedOtherTyreUsage.usageName,
    });

    this.relativeActionOnOtherTyreUsage();
  }

  onOtherTyreUsageDeselect(item: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.selectedOtherTireline = [];
    this.multiStepForm.patchValue({
      tirelineY: null,
    });

    let i = 0;
    (<FormArray>this.multiStepForm.get('usageY')).controls.forEach((l: any) => {
      if (l.value == item.usageName) {
        (<FormArray>this.multiStepForm.get('usageY')).removeAt(i);
        return;
      }
      i++;
    });

    // received usages
    let usagesData = this.selectedOtherTyreUsage;
    this.getOtherUsages = usagesData.map((item: any) => {
      return item.usageId;
    });

    // received brands
    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    let data2 = this.selectedOtherSeason;

    this.otherAlllist = [];

    for (let j of data2) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    if (this.otherAlllist.length !== 0) {
      for (const element of this.otherAlllist) {
        this.checkElementNotNull(element);
        this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
          return item.subSeasonId;
        });
      }
    } else {
      this.getAllOthersubSeasonIdsIn = [];
    }

    this.spinnerService.show();

    // other tyre lines call
    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getOtherTyreLines(
        this.getOtherBrandIds,
        this.getAllOthersubSeasonIdsIn,
        this.getOtherUsages
      );
    } else if (this.getPLCode() == '2W') {
      this.getOtherTyreLines(this.getOtherBrandIds, [], this.getOtherUsages);
    }

    if (this.editMode) {
      this.allowOtherTirelineRestore = false;
    } else {
      // Keep tireline enabled when usage is deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isOtherTireLineDisabled = false;
      }
    }
  }

  onSelectAllOtherTyreUsages(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageY')).clear();
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    for (let key of items) {
      const controls = new FormControl(key.usageName);
      (<FormArray>this.multiStepForm.get('usageY')).push(controls);
    }

    this.isOtherTireLineDisabled = false;

    let usageStore: any = [];
    for (let key of items) {
      const controls = new FormControl(key.usageId);
      usageStore.push(controls.value);
    }
    this.selectedOtherTyreUsage = usageStore;

    let data = this.selectedOtherBrand;
    this.getOtherBrandIds = data.map((item: any) => {
      return item.brandId;
    });

    for (let j of this.otherSeasonitems) {
      let data3 = this.otherMasterData.subSeasonMap[j];
      for (const element of data3) {
        this.otherAlllist.push(element);
      }
    }

    this.otherAlllist = [];

    for (const element of this.otherAlllist) {
      this.checkElementNotNull(element);
      this.getAllOthersubSeasonIdsIn = this.otherAlllist.map((item: any) => {
        return item.subSeasonId;
      });
    }

    // Extract usage IDs from selectedOtherTyreUsage objects
    let usageIds = this.selectedOtherTyreUsage.map((item: any) => {
      return typeof item === 'object' && item !== null ? item.usageId : item;
    });

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getOtherTyreLines(
        this.getOtherBrandIds,
        this.getAllOthersubSeasonIdsIn,
        usageIds
      );
    } else if (this.getPLCode() == '2W') {
      this.getOtherTyreLines(
        this.getOtherBrandIds,
        [],
        usageIds
      );
    }
  }

  onDeSelectAllOtherTyreUsages(items: any) {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('usageY')).clear();
    (<FormArray>this.multiStepForm.get('tirelineY')).clear();
    this.otherTirelines = [];
    this.selectedOtherTireline = null;
    this.multiStepForm.patchValue({
      tirelineY: this.selectedOtherTireline?.categoryName,
    });

    if (this.editMode) {
      this.allowOtherTirelineRestore = false;
      this.isOtherTireLineDisabled = true;
    } else {
      // Keep tireline enabled when all other usages are deselected
      if (this.getPLCode() != 'AG' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
        this.isOtherTireLineDisabled = false;
      } else {
        this.isOtherTireLineDisabled = true;
      }
    }

    let arr: any = [];

    for (let key of items) {
      const controls = new FormControl(key.usageId);
      arr.push(JSON.stringify(controls.value));
    }
    this.selectedOtherTyreUsage = arr;

    this.spinnerService.show();

    if (this.getPLCode() != 'AG' && this.getPLCode() != '2W' && this.getPLCode() != 'CT' && this.getPLCode() != 'MIN') {
      this.getOtherTyreLines(
        this.getAllOtherBrandIds,
        this.getAllOtherSelectedSeason,
        this.selectedOtherTyreUsage
      );
    } else if (this.getPLCode() == '2W') {
      this.getOtherTyreLines(
        this.getAllOtherBrandIds,
        [],
        this.selectedOtherTyreUsage
      );
    }
  }

  /* Step 1 end Other Brand section */

  /* Step 4 data */
  onPriceLogicSelect(item: any) {
    (<FormArray>this.multiStepForm.get('priceLogic')).clear();
    this.getPriceLogicParameterLabel(item);
    this.isMultiStepFormDirty = true;
    this.isPriceLogicValidation = true;
    const control = new FormControl(
      this.priceLogicParameterLabel,
      Validators.required
    );

    (<FormArray>this.multiStepForm.get('priceLogic')).push(control);
    this.multiStepForm.patchValue({
      priceLogic: this.selectedPriceLogic.parameterName,
    });
    if (this.selectedPriceLogic.parameterName === 'sell_in') {
      this.onDeSelectAllWebsites();
      this.isWebsiteDisabled = true;
      this.isOrderPrefDisable = true;
    } else {
      this.getWebsites(false);
      this.isWebsiteDisabled = false;
      this.isOrderPrefDisable = false;
    }
    this.checkPriceLogiclabel();
  }

  getPriceLogicParameterLabel(item: any) {
    for (let key of this.priceLogics) {
      if (item.parameterName === key.parameterName) {
        this.priceLogicParameterLabel = key.parameterLabel;
      }
    }
  }

  onPriceLogicDeselect(item: any) {
    this.getPriceLogicParameterLabel(item);
    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('priceLogic')).controls.forEach(
      (l: any) => {
        if (l.value == this.priceLogicParameterLabel) {
          (<FormArray>this.multiStepForm.get('priceLogic')).removeAt(i);
          this.isOrderPrefDisable = false;
          this.isWebsiteDisabled = false;
          return;
        }
        i++;
      }
    );
  }

  onSelectAllPriceLogics(items: any) {
    this.isMultiStepFormDirty = true;
    this.isPriceLogicValidation = true;
    (<FormArray>this.multiStepForm.get('priceLogic')).clear();
    for (let priceLogic of this.priceLogics) {
      this.priceLogicParameterLabel = priceLogic.parameterLabel;
      const controls = new FormControl(this.priceLogicParameterLabel);
      (<FormArray>this.multiStepForm.get('priceLogic')).push(controls);
    }
    this.checkPriceLogiclabel();
  }

  onDeSelectAllPriceLogic() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('priceLogic')).clear();
    this.checkPriceLogiclabel();
    this.selectedPriceLogic = [];
  }

  onOrderPreferenceSelect(item: any) {
    (<FormArray>this.multiStepForm.get('orderPreference')).clear();
    this.getOrderPreferenceParameterLabel(item);
    this.isMultiStepFormDirty = true;
    this.isOrderPreferenceValidation = true;
    const control = new FormControl(
      this.orderPreferenceParameterLabel,
      Validators.required
    );
    (<FormArray>this.multiStepForm.get('orderPreference')).push(control);
    this.multiStepForm.patchValue({
      orderPreference: this.selectedOrderPreference.parameterName,
    });
    this.checkOrderPreferencelabel();
  }

  getOrderPreferenceParameterLabel(item: any) {
    for (let key of this.orderPreferences) {
      if (item.parameterName === key.parameterName) {
        this.orderPreferenceParameterLabel = key.parameterLabel;
      }
    }
  }

  checkOrderPreferencelabel() {
    if (this.orderPreferenceParameterLabel === 'most_popular') {
      this.multiStepForm.patchValue({
        mostPopular: 'True',
        mostRecent: 'False',
      });
    } else if (this.orderPreferenceParameterLabel === 'most_recent') {
      this.multiStepForm.patchValue({
        mostRecent: 'True',
        mostPopular: 'False',
      });
    }
  }

  checkPriceLogiclabel() {
    if (this.priceLogicParameterLabel === 'sell_in') {
      this.selectedOrderPreference = [];
      this.onOrderPreferenceDeselect(null);
      this.onDeSelectAllOrderPreferences();
      (<FormArray>this.multiStepForm.get('orderPreference')).clear();
      this.isOrderPrefDisable = true;
      this.isWebsiteDisabled = true;
      this.multiStepForm.patchValue({
        orderPreference: null,
        mostPopular: 'False',
        mostRecent: 'False',
      });
    }
  }

  onOrderPreferenceDeselect(item: any) {
    if (item != null) {
      this.getOrderPreferenceParameterLabel(item);
    }

    this.isMultiStepFormDirty = true;
    let i = 0;
    (<FormArray>this.multiStepForm.get('orderPreference')).controls.forEach(
      (l: any) => {
        if (l.value == this.orderPreferenceParameterLabel) {
          (<FormArray>this.multiStepForm.get('orderPreference')).removeAt(i);
          if (this.orderPreferenceParameterLabel === 'most_popular') {
            this.multiStepForm.patchValue({
              mostPopular: 'False',
            });
          } else if (this.orderPreferenceParameterLabel === 'most_recent') {
            this.multiStepForm.patchValue({
              mostRecent: 'False',
            });
          }
          return;
        }
        i++;
      }
    );
  }

  onSelectAllOrderPreferences(items: any) {
    this.isMultiStepFormDirty = true;
    this.isOrderPreferenceValidation = true;
    (<FormArray>this.multiStepForm.get('orderPreference')).clear();

    for (let orderPreference of this.orderPreferences) {
      this.orderPreferenceParameterLabel = orderPreference.parameterLabel;
      const controls = new FormControl(this.orderPreferenceParameterLabel);
      (<FormArray>this.multiStepForm.get('orderPreference')).push(controls);
      this.checkOrderPreferencelabel();
    }
  }

  onDeSelectAllOrderPreferences() {
    this.isMultiStepFormDirty = true;
    (<FormArray>this.multiStepForm.get('orderPreference')).clear();
    this.checkOrderPreferencelabel();
    this.selectedOrderPreference = [];
  }

  /* End Step 4 data */

  handleClusterValues(e: any, parameterLabel: any) {
    this.isMultiStepFormDirty = true;

    //----reset Degrardation file attributes----
    this.getFileName = undefined;
    this.isButtonDisabledDeg = true;
    this.successMessageDeg = false;
    this.getFileSize = false;
    this.errorFlagDeg = false;

    const control = new FormControl(parameterLabel, Validators.required);

    if (e.target.checked) {
      (<FormArray>this.multiStepForm.get('clustering')).push(control);
      this.clusteringData = this.multiStepForm.get('clustering').value;

      for (let key of this.clusterings) {
        if (e.target.value === key.parameterName) {
          key.isSelected = true;
        }
      }
      this.utilService.getClusteringCheckValues(this.clusteringData);
    } else {
      for (let key of this.clusterings) {
        if (e.target.value === key.parameterName) {
          key.isSelected = false;
        }
      }
      let i = 0;
      (<FormArray>this.multiStepForm.get('clustering')).controls.forEach(
        (val: any) => {
          if (val.value == parameterLabel) {
            (<FormArray>this.multiStepForm.get('clustering')).removeAt(i);
            return;
          }
          i++;
        }
      );

      this.clusteringData = this.multiStepForm.get('clustering').value;
      this.utilService.getClusteringCheckValues(this.clusteringData);
    }

    const commonItems = this.clusteringData.filter((item: any) =>
      new Set(this.degradationData).has(item)
    );

    this.degradationData = this.degradationData.filter(
      (val: any) => this.clusteringData.indexOf(val) == -1
    );
    if (this.getPLCode() === 'TC') {
      if (this.clusteringData.includes('usage')) {
        //this.intersection.push('macro_usage');
        this.isMacroUsageSelected = false;
      } else if (this.clusteringData.includes('macro_usage')) {
        //this.intersection.push('usage');
        this.isMacroUsageSelected = true;
      }
    }

    let i = 0;
    (<FormArray>this.multiStepForm.get('degradation')).controls.forEach(
      (val: any) => {
        if (val.value == commonItems) {
          (<FormArray>this.multiStepForm.get('degradation')).removeAt(i);
          return;
        }
        i++;
      }
    );

    this.removeDegradationFile();
    this.multiStepForm.patchValue({
      ruleSheet: null,
    });
  }

  handleDegradationValues(e: any, parameterLabel: any) {
    this.setInitialDegradationState();

    if (e.target.checked) {
      this.addDegradation(parameterLabel, e.target.value);
    } else {
      this.removeDegradation(parameterLabel, e.target.value);
    }

    this.updateLoadIntersection(parameterLabel);
  }

  private setInitialDegradationState() {
    this.isMultiStepFormDirty = true;
    this.isButtonDisabledDeg = true;
    this.successMessageDeg = false;
    this.getFileName = null;
    this.getFileSize = null;
    this.multiStepForm.patchValue({ ruleSheet: null });
  }

  private addDegradation(parameterLabel: string, targetValue: string) {
    const control = new FormControl(parameterLabel, Validators.required);
    (<FormArray>this.multiStepForm.get('degradation')).push(control);

    this.updateDegradationData();
    this.selectDegradation(targetValue, true);
    this.removeDegradationFile();
  }

  private removeDegradation(parameterLabel: string, targetValue: string) {
    this.selectDegradation(targetValue, false);
    this.removeDegradationControl(parameterLabel);

    this.removeDegradationFile();
    this.updateDegradationData();
    this.relativeActionOnDegradationDataLength();
  }

  private updateDegradationData() {
    this.degradationData = this.multiStepForm.get('degradation').value;
    this.utilService.getDegradationCheckValues(this.degradationData);
  }

  private selectDegradation(targetValue: string, isSelected: boolean) {
    for (let key of this.degradations) {
      if (targetValue === key.parameterName) {
        if (isSelected) {
          key.isSelected = true;
          this.isDownloadBoxDisabled = true;
        } else {
          key.isSelected = false;
          this.degradationData.pop(key.parameterName);
        }
      }
    }
  }

  private removeDegradationControl(parameterLabel: string) {
    const degradationArray = <FormArray>this.multiStepForm.get('degradation');
    degradationArray.controls.forEach((val: any, i: number) => {
      if (val.value === parameterLabel) {
        degradationArray.removeAt(i);
        return;
      }
    });
  }

  private updateLoadIntersection(parameterLabel: string) {
    if (parameterLabel === 'load_index') {
      this.updateLoadIndexIntersection();
    }

    if (
      parameterLabel === 'load_range' ||
      parameterLabel === 'tyre_ply_rating'
    ) {
      this.updateLoadRangeIntersection();
    }
  }

  private updateLoadIndexIntersection() {
    if (this.degradationData.includes('load_index')) {
      this.Loadintersection.push(
        this.getPLCode() === 'AG' ? 'Ply Rating' : 'Load Range'
      );
    } else {
      this.Loadintersection.pop();
    }
  }

  private updateLoadRangeIntersection() {
    if (
      this.degradationData.includes('load_range') ||
      this.degradationData.includes('tyre_ply_rating')
    ) {
      this.Loadintersection.push(
        this.getPLCode() === 'PL' ? 'Load Index Single' : 'Load Index'
      );
    } else {
      this.Loadintersection.pop();
    }
  }

  relativeActionOnDegradationDataLength() {
    this.isButtonDisabledDeg = true;
    this.isDownloadBoxDisabled = true;

    if (this.degradationData.length < 1) {
      this.isDownloadBoxDisabled = false;
      this.isDegradationSelected = true;
      this.isButtonDisabledDeg = true;
      this.successMessageDeg = false;
      this.getFileName = null;
      this.getFileSize = null;

      this.removeDegradationFile();
    }
  }

  downloadDegradationFile() {
    this.spinnerService.show();
    const clustering1 = this.clusteringData;
    const degradation1 = this.degradationData;

    const clustering = JSON.parse(JSON.stringify(clustering1));
    const degradation = JSON.parse(JSON.stringify(degradation1));

    const userId: any = this.userId?.toString() ?? '';
    const regionId = this.storeRegionId;

    let formData = new FormData();
    formData.append('userId', userId);

    this.pairingStepFormApi
      .getDegradationFile(
        userId,
        clustering,
        degradation,
        regionId,
        this.getPLCodes()
      )
      .subscribe(
        (response: HttpResponse<Blob>) => {
          this.spinnerService.hide();

          const contentDispositionHeader: string = response.headers
            .get('Content-Disposition')
            .split('filename=')[1]
            .split(';')[0];

          const blob = new Blob([response.body], {
            type: 'application/vnd.ms-excel',
          });
          const file = new File([blob], contentDispositionHeader, {
            type: 'application/vnd.ms-excel',
          });
          const url = window.URL.createObjectURL(blob);
          FileSaver.saveAs(blob, contentDispositionHeader);
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
  }

  downloadCompetitorFile() {
    this.spinnerService.show();
    const userId: any = this.id.toString();

    let formData = new FormData();
    formData.append('productLineCodes', this.getPLCodes().join(','));

    this.pairingStepFormApi.getCompetitorFile(formData, userId).subscribe(
      (response: HttpResponse<any>) => {
        this.spinnerService.hide();

        // const contentDispositionHeader: string = response.headers
        this.contentDispositionHeader = response.headers
          .get('Content-Disposition')
          .split('filename=')[1]
          .split(';')[0];

        const blob = new Blob([response.body], {
          type: 'application/vnd.ms-excel',
        });
        const file = new File([blob], this.contentDispositionHeader, {
          type: 'application/vnd.ms-excel',
        });
        const url = window.URL.createObjectURL(blob);
        FileSaver.saveAs(blob, this.contentDispositionHeader);
       
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }


  downloadCAIFile() {
    const isMultiplePL = this.getPLCodes().length > 1;
    this.downloadFileService.downloadCAIFile(this.userId, isMultiplePL, this.storeRegionCode);
  }

  public droppedDegradationFile(files: NgxFileDropEntry[]) {
    if (files.length > 1) {
      return;
    }
    this.isMultiStepFormDirty = true;
    const file = files[0];
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file

          this.getFileName = file.name;
          this.getFileSize = file.size;

          this.spinnerService.show();
          let formData = new FormData();
          formData.append('file', file);
          formData.append('clustering', this.clusteringData);
          formData.append('degradation', this.degradationData);
          formData.append('regionId', this.storeRegionId);
          formData.append('productLineCodes', this.getPLCode());

          this.pairingStepFormApi
            .uploadDegradationFile(formData, this.userId)
            .subscribe(
              (res: any) => {
                this.spinnerService.hide();
                const getFileResponse: any = res;

                if (getFileResponse.message === 'OK') {
                  const degFileResult = getFileResponse.result;
                  this.successDegradationFile = degFileResult;
                  this.multiStepForm.patchValue({
                    ruleSheet: this.successDegradationFile,
                  });

                  this.removeDegradationFile();

                  this.inputFilesFormControls.push(
                    this.fb.group({
                      fileName: this.successDegradationFile,
                      fileTypeId: 1,
                    })
                  );
                  this.isDegradationSelected = false;
                  this.isButtonDisabledDeg = false;
                  this.successMessageDeg = true;
                  this.errorFlagDeg = false;
                }
              },
              (error: any) => {
                this.spinnerService.hide();
                const degradationError = this.getSharingErorr;
                this.utilService.SharingData.next(null);
                this.errorFlagDeg = true;
                this.degradationError = degradationError;
                this.successMessageDeg = false;
                this.isButtonDisabledDeg = true;
                this.isDegradationSelected = true;
              }
            );
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        
      }
    }
  }

  removeDegradationFile() {
    for (
      let i = 0;
      i < this.multiStepForm.get('inputFiles').value.length;
      i++
    ) {
      if (
        i == 0 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(0);
      }
      if (
        i == 1 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(1);
      }
      if (
        i == 2 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(2);
      }
    }
  }

  public droppedCompetitorFile(files: NgxFileDropEntry[]) {
    if (files.length > 1) {
      return;
    }
    this.isMultiStepFormDirty = true;
    const file = files[0];
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file

          this.getFileNameCompetitor = file.name;
          this.getFileSizeCompetitor = file.size;
          if (!this.getFileNameCompetitor.startsWith('Competitor_Prioritization')) {
            this.errorFlagComp = true;
            this.competitorError = PairingConst.COMP_PRIO_INVALID_MSG;
            this.spinnerService.hide();
            this.successMessageComp = false;
            this.isButtonDisabled = true;
          }

          this.spinnerService.show();
          this.isCompetitorFileUploading = true;
          let formData = new FormData();
          formData.append('file', file);
          formData.append('productLineCodes', this.getPLCodes().join(','));

          this.pairingStepFormApi
            .uploadCompetitorFile(formData, this.userId)
            .subscribe(
              (res: any) => {
                this.spinnerService.hide();
                const getFileResponse: any = res;
                if (getFileResponse.message === 'OK') {
                  this.successCompetitorFile = getFileResponse.result.fileName;
                  const competitorPriorityDtoList = getFileResponse.result.competitorPriorityDtoList;

                  // Sort the list: rows with errorMessage first
                  competitorPriorityDtoList.sort((a: any, b: any) => {
                    const aHasError = a.errorMessage && a.errorMessage.trim() !== '';
                    const bHasError = b.errorMessage && b.errorMessage.trim() !== '';

                    // If one has error and other doesn't, prioritize the one with error
                    if (aHasError && !bHasError) return -1;
                    if (!aHasError && bHasError) return 1;

                    return 0;
                  });
                   

                  if (this.compArray[0] === undefined) {
                    this.dynamicArray.splice(0, 1);
                    this.compPrioFormControls.removeAt(0);
                    this.compArray.splice(0, 1);
                    this.reindexTirelineMapsAfterDeletion(0);
                    this.checkAllCompPrioComplete(0);
                    this.refreshcompArray(0);
                  }

                  // Process rows in batches to prevent browser from freezing
                  this.processCompPrioRowsInBatches(competitorPriorityDtoList, 0, 100).then(() => {

                    this.multiStepForm.patchValue({
                      competitorsPrioritizationTable: this.successCompetitorFile,
                    });

                    for (
                      let i = 0;
                      i < this.multiStepForm.get('inputFiles').value.length;
                      i++
                    ) {
                      if (
                        i == 0 &&
                        this.multiStepForm.get('inputFiles').value.at(i)
                          .fileTypeId == 2
                      ) {
                        this.inputFilesFormControls.removeAt(0);
                      }
                      if (
                        i == 1 &&
                        this.multiStepForm.get('inputFiles').value.at(i)
                          .fileTypeId == 2
                      ) {
                        this.inputFilesFormControls.removeAt(1);
                      }
                      if (
                        i == 2 &&
                        this.multiStepForm.get('inputFiles').value.at(i)
                          .fileTypeId == 2
                      ) {
                        this.inputFilesFormControls.removeAt(2);
                      }
                    }

                    this.isButtonDisabled = false;
                    this.isCompetitorFileUploading = false;
                    this.successMessageComp = true;
                    this.errorFlagComp = false;
                    this.cdr.detectChanges();
                  });
                }
              },
              (error: any) => {
                this.spinnerService.hide();
                this.isCompetitorFileUploading = false;
                const competitorUploadError = this.getSharingErorr;
                this.utilService.SharingData.next(null);
                this.errorFlagComp = true;
                if (!this.competitorError) {
                  this.competitorError = competitorUploadError;
                }
                this.successMessageComp = false;
                this.isButtonDisabled = true;
              }
            );
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  public droppedCAIFile(files: NgxFileDropEntry[]) {
    if (files.length > 1) {
      return;
    }

    this.isMultiStepFormDirty = true;

    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file

          this.getCAIFileName = file.name;
          this.getCAIFileSize = file.size;

          const userId: any = this.userId?.toString() ?? '';

          this.spinnerService.show();
          let formData = new FormData();

          formData.append('file', file);
          formData.append('userId', userId);
          formData.append('regionCode', this.storeRegionCode);
          formData.append('productLineCodes', this.getPLCodes().join(','));

          this.pairingStepFormApi.uploadCAIFile(formData).subscribe(
            (response: any) => {
              this.spinnerService.hide();
              const getFileResponse: any = response;
              if (
                getFileResponse.body.message === 'OK' &&
                getFileResponse.body.totalCount === 2
              ) {
                this.successCAIFile = getFileResponse.body.result;

                this.currentActionType = this.UNMATCHED_CAI_DOWNLOAD;
                if(this.storeRegionCode === 'AMN' || this.storeRegionCode === 'AMC'){
                  this.popupMessage = PairingConst.UNMATCHED_MSPN_DOWNLOAD_MSG;
                } else {
                  this.popupMessage = PairingConst.UNMATCHED_CAI_DOWNLOAD_MSG;
                }
                this.isMissingCAIDownloadPopup = true;
                this.displayStyle = 'block';
                let caiFileName = this.successCAIFile.replace('_Missing', '');
                this.multiStepForm.patchValue({
                  caiTable: caiFileName,
                });

                this.setUpdatedCommonFile();

                this.inputFilesFormControls.push(
                  this.fb.group({
                    fileName: caiFileName,
                    fileTypeId: 5,
                  })
                );

                this.isCAIFileMissing = false;
                this.isButtonDisabled = false;
                this.successMessageCAI = true;
                this.errorFlagCAI = false;
              } else if (getFileResponse.body.message === 'OK') {
                this.successCAIFile = getFileResponse.body.result;

                this.multiStepForm.patchValue({
                  caiTable: this.successCAIFile,
                });

                this.setUpdatedCommonFile();

                this.inputFilesFormControls.push(
                  this.fb.group({
                    fileName: this.successCAIFile,
                    fileTypeId: 5,
                  })
                );

                this.isButtonDisabled = false;
                this.successMessageCAI = true;
                this.errorFlagCAI = false;
                this.isCAIFileMissing = false;
              }
            },
            (error: any) => {
              this.spinnerService.hide();
              const caiError = this.getSharingErorr;
              this.utilService.SharingData.next(null);
              this.errorFlagCAI = true;
              this.caiError = caiError;
              this.successMessageCAI = false;
              this.isButtonDisabled = true;
              this.isCAIFileMissing = false;
            }
          );
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  setUpdatedCommonFile() {
    for (
      let i = 0;
      i < this.multiStepForm.get('inputFiles').value.length;
      i++
    ) {
      if (
        i == 0 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 5
      ) {
        this.inputFilesFormControls.removeAt(0);
      }
      if (
        i == 1 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 5
      ) {
        this.inputFilesFormControls.removeAt(1);
      }
      if (
        i == 2 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 5
      ) {
        this.inputFilesFormControls.removeAt(2);
      }
    }
  }

  caiFileDownload() {
    this.displayStyle = 'none';
    this.isMissingCAIDownloadPopup = false;
    this.isCAIFileMissing = false;
    this.downloadFileService.downloadMissingCAI(this.successCAIFile);
  }

  public fileOver(event: any) {
    //console.log(event);
  }

  public fileLeave(event: any) {
    //console.log(event);
  }

  goBack() {
    this.step = this.step - 1;
    if (this.step > this.maxStep) this.maxStep = this.step;

    this.stepLabelText = this.getCurrentStepLabelText(this.step);
    this.onSaveDraft(false);
  }

  getCurrentStepLabelText(_step: number) {
    return new Map(PairingConst.stepMap.map((i) => [i.step, i.stage])).get(
      _step
    );
  }

  goNext() {
    this.isClickAction = true;
    this.formSubmitted = true;
    this.step = this.step + 1;

    if (this.step == 1) {
      this.submitted = true;
    }
    if (this.step == 2) {
      if (!this.clusteringData) {
        this.clusterings.forEach((cluster: any) => {
          if (cluster.isDefaultSelected) {
            this.clusteringData.push(cluster.parameterLabel);
          }
        });
      }
      this.spinnerService.show();

      // getting selected clustering values
      this.stepLabelText = 'Clustering';
      this.relativeActionOnClusteringPopulation();
    }

    if (this.step == 3) {
      this.spinnerService.show();

      // getting clustering selected values
      this.utilService.clusteringDataSource.subscribe((res) => {
        this.getSelectedClusteringValues = res;
        this.getSelectedClusteringValues = this.clusteringData;
      });

      this.stepLabelText = 'Degradation';
      if (!this.copyMode) {
        this.isDegradationSelected = false;
      }
      this.relativeActionOnDegradationPopulation();
    }

    if (this.step == 4) {
      this.priceAndPreferenceData();
    }
    if (this.step > this.maxStep) this.maxStep = this.step;
  }

  priceAndPreferenceData() {
    let plCode = this.getPLCodes();
    if (this.multiStepForm.get('priceLogic')) {
      this.stepLabelText = 'Price Type';
      this.pairingStepFormApi
        .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const priceLogicLists = res;
            this.priceLogics = priceLogicLists.result;

            this.priceLogics = this.priceLogics.filter(function (el: any) {
              return el !== 'NULL';
            });

            if (this.editMode && this.storeRegionCode != 'WW') {
              this.selectedPriceLogic = PairingHelper.getSelectedRecords(
                this.priceLogics,
                this.getDraftRecordById?.priceLogic ?? [],
                'parameterLabel'
              );
              if (this.selectedPriceLogic[0].parameterLabel !== undefined)
                this.priceLogicParameterLabel = this.selectedPriceLogic[0].parameterLabel;
              this.checkPriceLogiclabel();
            } else if (this.storeRegionCode == 'WW') {
              this.priceLogicParameterLabel = [];
            }
          },
          (err: any) => {
            this.spinnerService.hide();
            //console.log(err);
          }
        );
    }
    if (this.multiStepForm.get('orderPreference')) {
      this.stepLabelText = 'Order Preference';
      let plCode = this.getPLCodes();
      this.pairingStepFormApi
        .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            const orderPreferenceLists = res;
            this.orderPreferences = orderPreferenceLists.result;

            this.orderPreferences = this.orderPreferences.filter(function (
              el: any
            ) {
              return el !== 'NULL';
            });

            if (this.editMode && this.storeRegionCode != 'WW') {
              this.selectedOrderPreference = PairingHelper.getSelectedRecords(
                this.orderPreferences,
                this.getDraftRecordById?.orderPreference ?? [],
                'parameterLabel'
              );
            } else if (this.storeRegionCode == 'WW') {
              this.selectedOrderPreference = [];
            }
            if (this.isClickAction) this.onSaveDraft(false);
          },
          (err: any) => {
            this.spinnerService.hide();
            //console.log(err);
          }
        );
    }
  }

  relativeActionOnDegradationPopulation() {
    let plCode = this.getPLCodes();
    this.pairingStepFormApi
      .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          this.degradations = res.result;

          if (this.editMode) {
            this.loadClusteringValues();
          }

          this.collectDegradationValues();
          this.updateIntersection();
          this.updateDegradationSelection();

          if (this.editMode) {
            this.handleEditMode();
          }

          if (this.isClickAction) {
            this.onSaveDraft(false);
          }
        },
        () => {
          this.spinnerService.hide();
        }
      );
  }

  private loadClusteringValues() {
    this.utilService.clusteringDataSource.subscribe((res) => {
      this.getSelectedClusteringValues = this.clusteringData = res;
    });
  }

  private collectDegradationValues() {
    this.getSelectedDegradationValues = this.degradations.map(
      (key: { parameterLabel: any }) =>
        new FormControl(key.parameterLabel).value
    );
  }

  private updateIntersection() {
    this.intersection = this.getSelectedClusteringValues.filter(
      (element: any) => this.getSelectedDegradationValues.includes(element)
    );
    this.intersection.forEach((item: any, index: string | number) => {
      const degradation = this.degradations.find(
        (degrad: { parameterLabel: any }) => degrad.parameterLabel === item
      );
      if (degradation) {
        this.intersection[index] = degradation.parameterName;
      }
    });
  }

  private updateDegradationSelection() {
    if (this.degradationData) {
      this.degradations.forEach(
        (degrad: { isSelected: any; parameterLabel: any }) => {
          degrad.isSelected = this.degradationData.includes(
            degrad.parameterLabel
          );
        }
      );
    }

    if (this.intersection) {
      this.degradations.forEach(
        (degrad: { parameterName: any; isSelected: boolean }) => {
          if (this.intersection.includes(degrad.parameterName)) {
            degrad.isSelected = false;
          }
        }
      );
    }
  }

  private handleEditMode() {
    if (this.degradationData) {
      this.utilService.getDegradationCheckValues(this.degradationData);
    }
    if (this.step == 4) {
      this.priceAndPreferenceData();
    }
  }

  relativeActionOnClusteringPopulation() {
    let plCode = this.getPLCodes();
    this.pairingStepFormApi
      .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
      .subscribe(
        (res: any) => {
          this.spinnerService.hide();
          this.processClusteringResponse(res);
        },
        (err: any) => {
          this.spinnerService.hide();
          //console.log(err);
        }
      );
  }

  private processClusteringResponse(res: any) {
    this.clusterings = res.result;
    this.populateClusteringValues();
    this.updateClusteringData();
    this.markSelectedClusterings();
    this.handleClusteringEditMode();
    if (this.isClickAction) this.onSaveDraft(false);
  }

  private populateClusteringValues() {
    this.clusterings.forEach((cluster: any) => {
      const control = new FormControl(cluster.parameterLabel);
      this.getSelectedClusteringValues.push(control.value);
      if (this.shouldAddClusterToForm(cluster)) {
        (<FormArray>this.multiStepForm.get('clustering')).push(control);
      }
    });
  }

  private shouldAddClusterToForm(cluster: any): boolean {
    return cluster.isDefaultSelected &&
      (!this.clusteringData ||
        (this.clusteringData && !this.clusteringData.includes(cluster.parameterLabel)));
  }

  private updateClusteringData() {
    this.clusteringData = this.multiStepForm.get('clustering').value;
  }

  private markSelectedClusterings() {
    if (this.clusteringData) {
      this.clusteringData.forEach((key: any) => {
        const clustering = this.clusterings.find((clust: { parameterLabel: any; }) =>
          clust.parameterLabel === key);
        if (clustering) {
          clustering.isSelected = true;
        }
      });
    }
  }

  private handleClusteringEditMode() {
    if (this.editMode) {
      if (this.clusteringData) {
        this.utilService.getClusteringCheckValues(this.clusteringData);
      }
      if (this.step >= 3) {
        this.degradationAction();
      }
    }
  }


  actionOnConfirmation() {
    if (this.currentActionType == this.SAVEDRAFT) this.onSaveDraft(true);
    else if (this.currentActionType == this.CLEARALL) {
      this.onClear();
      this.displayStyle = 'none';
      this.isMultiStepFormDirty = false;
      this.isConfirmationPopupVisibale = false;
    }
    else if (this.currentActionType == this.CLEARCOMPPRIO) {
      this.clearCompPrio(true);
      this.displayStyle = 'none';
      this.isMultiStepFormDirty = false;
      this.isConfirmationPopupVisibale = false;
    }
  }

  onClear() {
    switch (this.step) {
      case 1:
        this.clearStepOne();
        break;
      case 2:
        this.clearAllStepTwo();
        break;
      case 3:
        this.clearAllStepThree();
        break;
      case 4:
        this.clearAllStepfour();
        break;
      default:
        console.warn('Unknown step:', this.step);
    }
  }

  private clearStepOne() {
    this.clearFormArrays([
      'country', 'businessLine', 'productLine', 'brandX', 'seasonX', 'usageX',
      'tirelineX', 'brandY', 'seasonY', 'usageY', 'tirelineY'
    ]);

    this.clearSelectedOptions();
    this.resetFlagsAndMessages();
    this.clearFormValues();
    this.clearCAIInputFiles();
    this.getOtherBrands(false, false);
  }

  private clearFormsArrays(fields: string[]) {
    fields.forEach(field => {
      (<FormArray>this.multiStepForm.get(field)).clear();
    });
  }

  private clearSelectedOptions() {
    this.selectedCountries = [];
    this.selectedBusinessLine = [];
    this.selectedProductLine = [];
    this.selectedMichelinBrand = [];
    this.selectedSeason = [];
    this.selectedTyreUsage = [];
    this.selectedTyreLine = [];
    this.selectedOtherBrand = [];
    this.selectedOtherSeason = [];
    this.selectedOtherTyreUsage = [];
    this.selectedOtherTireline = [];
  }

  private resetFlagsAndMessages() {
    this.isTireLineDisabled = true;
    this.isTireUsageDisabled = true;
    this.isSeasonDisabled = true;
    this.isBusinessLineSelected = false;
    this.isProductLineSelected = false;
    this.isOtherSeasonDisabled = true;
    this.isOtherTireUsageDisabled = true;
    this.isOtherTireLineDisabled = true;
    this.isRegionSelected = false;
    this.isCountryDisabledOnRegion = true;
    this.isProductLineDisabledOnRegion = true;
    this.isBusinessLineDisabledOnProductLine = true;
    this.successMessageCAI = false;
    this.getCAIFileName = null;
    this.getCAIFileSize = null;
    this.errorFlagCAI = null;
    this.caiError = null;
    this.isCAIChecked = false;
    this.isCAIFileMissing = false;
    this.CAIListMessage = '';
    this.MSPNListMessage = '';
    this.isMichelinBrandsExcluded = false;
    this.isClearAllOnPerimeter = true;
  }

  private clearFormValues() {
    this.multiStepForm.patchValue({
      region: null,
      regionCode: null,
      country: null,
      businessLine: null,
      productLine: null,
      brandX: null,
      seasonX: null,
      usageX: null,
      tirelineX: null,
      brandY: null,
      tirelineY: null,
      seasonY: null,
      usageY: null,
      caiTable: null,
      isMichelinExcluded: this.isMichelinBrandsExcluded,
    });
  }

  private clearCAIInputFiles() {
    const inputFiles = this.multiStepForm.get('inputFiles').value;
    for (let i = 0; i < inputFiles.length; i++) {
      if (inputFiles[i].fileTypeId == 5) {
        this.inputFilesFormControls.removeAt(i);
      }
    }
  }

  clearAllStepThree() {
    this.stepLabelText = 'Degradation';
    this.spinnerService.show();
    let plCode = this.getPLCodes();
    this.pairingStepFormApi
      .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const clusteringLists = res;
          this.degradations = clusteringLists.result;
        },
        (err: any) => {
          this.spinnerService.hide();
          //console.log(err);
        }
      );

    this.onClearDegradation();
  }

  clearAllStepfour() {
    (<FormArray>this.multiStepForm.get('priceLogic')).clear();
    (<FormArray>this.multiStepForm.get('orderPreference')).clear();
    (<FormArray>this.multiStepForm.get('competitorPrioritizationDetails')).clear();
    (<FormArray>this.multiStepForm.get('websites')).clear();
    this.compErrorArray = [];
    this.dynamicArray = [];
    this.compArray = [];
    this.selectedPriceLogic = [];
    this.selectedOrderPreference = [];
    this.selectedWebsites = [];

    this.isCompPrioComplete = false;
    this.multiStepForm.patchValue({
      priceDate: null,
      pricePeriodStart: null,
      pricePeriodEnd: null,
      priceLogic: null,
      orderPreference: null,
      websites: null,
      competitorsPrioritizationTable: null,
      valid_from_date: null,
      validFromDateValue: null,
      competitorPrioritizationDetails: null
    });

    for (
      let i = 0;
      i < this.multiStepForm.get('inputFiles').value.length;
      i++
    ) {
      if (
        i == 0 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 2
      ) {
        this.inputFilesFormControls.removeAt(0);
      }
      if (
        i == 1 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 2
      ) {
        this.inputFilesFormControls.removeAt(1);
      }
      if (
        i == 2 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 2
      ) {
        this.inputFilesFormControls.removeAt(2);
      }
    }

    this.isPriceLogicValidation = false;
    this.isOrderPreferenceValidation = false;
    this.isPriceDateValidation = false;
    if (this.storeRegionCode != 'WW') {
      this.isOrderPrefDisable = false;
      this.isPriceMonthDisable = false;
      this.isPriceLogicDisable = false;
      this.isWebsiteDisabled = false;
      this.isValidFromDateDisable = false;
    } else {
      this.onDeSelectAllWebsites();
      this.onDeSelectAllPriceLogic();
    }
    this.customLabel = '';
    this.isCompetitorChecked = false;
    this.competitorError = null;
    this.errorFlagComp = false;
    this.successMessageComp = false;
    this.getFileNameCompetitor = null;
    this.getFileSizeCompetitor = null;
    this.isMonthPickerVisible = false;
    this.isValidFromDateValidation = false;
    this.isValidFromDateVisible = false;
  }

  clearAllStepTwo() {
    this.clusteringData = this.multiStepForm.get('clustering').value;
    if (this.clusteringData) {
      this.utilService.getClusteringCheckValues([]);
    }

    this.spinnerService.show();
    let plCode = this.getPLCodes();
    this.pairingStepFormApi
      .getClusteringValues(this.storeRegionId, this.stepLabelText, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const clusteringLists = res;
          this.clusterings = clusteringLists.result;
          this.clusterings = this.clusterings.filter(function (el: any) {
            return el !== 'NULL';
          });
        },
        (err: any) => {
          this.spinnerService.hide();
          //console.log(err);
        }
      );

    for (let key of this.clusterings) {
      if (!key.isDefaultSelected) {
        let i = 0;
        (<FormArray>this.multiStepForm.get('clustering')).controls.forEach(
          (val: any) => {
            if (val.value == key.parameterLabel) {
              (<FormArray>this.multiStepForm.get('clustering')).removeAt(i);
              return;
            }
            i++;
          }
        );
      }
    }
    this.clusteringData = this.multiStepForm.get('clustering').value;

    this.removeDegradationFile();
    this.multiStepForm.patchValue({
      ruleSheet: null,
    });
    this.isDegradationSelected = false;
    this.isButtonDisabledDeg = true;
    this.degradationError = null;
    this.errorFlagDeg = false;
    this.successMessageDeg = false;
    this.getFileName = null;
    this.getFileSize = null;
  }

  onClearDegradation() {
    this.isDownloadBoxDisabled = false;
    (<FormArray>this.multiStepForm.get('degradation')).clear();
    this.multiStepForm.patchValue({
      degradation: null,
      ruleSheet: null,
    });

    for (
      let i = 0;
      i < this.multiStepForm.get('inputFiles').value.length;
      i++
    ) {
      if (
        i == 0 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(0);
      }
      if (
        i == 1 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(1);
      }
      if (
        i == 2 &&
        this.multiStepForm.get('inputFiles').value.at(i).fileTypeId == 1
      ) {
        this.inputFilesFormControls.removeAt(2);
      }
    }

    this.degradationData = [];
    this.Loadintersection = [];
    this.isDegradationSelected = false;
    this.isButtonDisabledDeg = false;
    this.degradationError = null;
    this.errorFlagDeg = false;
    this.successMessageDeg = false;
    this.getFileName = null;
    this.getFileSize = null;
  }

  onSubmit() {
    
    this.spinnerService.show();
                  
    if (this.step == 4) {
      if (this.copyMode && !sessionStorage.getItem('copyRequestId')) {
        this.multiStepForm.removeControl('id');
      }
      this.multiStepForm.addControl('customLabel', new FormControl(this.customLabel));
      // Ensure country/states FormArrays reflect the current selectedCountries before submitting
      this.syncCountryStatesForm();
      this.rebuildCompPrioFormControls();
      this.pairingStepFormApi
        .onSubmit(this.multiStepForm.value, this.userId)
        .subscribe(
          (res: any) => {
            this.spinnerService.hide();
            const submitRes = res;
            this.pairingId = submitRes.result.pairingRequestId;
            const that = this;
            this.isSubmitedSuccessfully = true;
            this.isShowError = false;
            if (this.copyMode) {
              sessionStorage.removeItem('copyRequestId');
            }

            this.utilService.goToTop();
          },
          (err: any) => {
            this.spinnerService.hide();
            this.isSubmitedSuccessfully = false;
            //console.log(err);
            this.isShowError = true;
            const that = this;
            setTimeout(function () {
              that.isShowError = false;
              that.router.navigateByUrl('/', { replaceUrl: true }).then(() =>
                that.router.navigate(['../pairingAsProduct']));
            }, 5000);

            this.utilService.goToTop();
          }
        );
    }
  }

  validateSubmit() {
    // Validate submission conditions to prevent unwanted submission
    if (this.isBatchProcessing) {
      this.showValidationError('Cannot submit while batch processing is in progress. Please wait for the process to complete.');
      return;
    }

    if (this.isCompetitorChecked && !this.isCompPrioComplete) {
      this.showValidationError('Competitor Prioritization is incomplete. Please complete all required fields.');
      return;
    }

    if (this.isCompetitorChecked && this.hasCompPrioErrors()) {
      this.showValidationError('Competitor Prioritization contains errors. Please fix all errors before submitting.');
      return;
    }

    if (!this.isPriceLogicDisable && (!this.selectedPriceLogic || this.selectedPriceLogic.length === 0)) {
      this.showValidationError('Price Logic is required. Please select a valid Price Logic.');
      return;
    }

    if (!this.isOrderPrefDisable && (!this.selectedOrderPreference || this.selectedOrderPreference.length === 0)) {
      this.showValidationError('Order Preference is required. Please select a valid Order Preference.');
      return;
    }

    if (!this.multiStepForm.get('priceDate').valid && !this.isPriceMonthDisable) {
      this.showValidationError('Price Month is required. Please select a valid Price Month.');
      return;
    }

    if (this.multiStepForm.get('ruleSheet').value == '') {
      this.showValidationError('Degradation Rule Sheet is required. Please upload the rule sheet.');
      return;
    }
  }
  onSaveDraft(isShowPopupMessage: boolean) {
    this.spinnerService.show();
    this.stepLabelText = this.getCurrentStepLabelText(this.maxStep);
    if (this.editMode) {
      this.handleEditMode1(this.maxStep);
    } else {
      this.handleNonEditMode(this.maxStep);
    }

    this.updateMultiStepForm();
    this.saveDraft(isShowPopupMessage);
  }

  private handleEditMode1(maxStep: number) {
    if (maxStep === 1 && (this.isStepOneInvalid() || this.isRuleSheetInvalid())) {
      this.stepLabelText = 'PERIMETER';
      this.clearForPerimeter();
    } else if (this.isRuleSheetInvalid() && this.step === 4) {
      this.stepLabelText = 'DEGRADATION';
      this.clearAllStepfour();
      this.updateCompetitorPrioritization();
    }
  }

  private handleNonEditMode(maxStep: number) {
    if (maxStep === 1 && this.isStepOneInvalid()) {
      this.stepLabelText = 'PERIMETER';
      this.clearForPerimeter();
    } else if (maxStep === 3 && (this.isStepThreeInvalid() || this.isRuleSheetInvalid())) {
      this.stepLabelText = 'DEGRADATION';
      this.clearAllStepfour();
    }
  }

  private isStepOneInvalid(): boolean {
    return this.step === 1 &&
      (!this.multiStepForm.get('regionCode').value ||
        !this.multiStepForm.get('productLine').value.length ||
        !this.multiStepForm.get('businessLine').value.length);
  }

  private isRuleSheetInvalid(): boolean {
    const ruleSheetValue = this.multiStepForm.get('ruleSheet').value;
    return ruleSheetValue === null || ruleSheetValue === undefined;
  }

  private isStepThreeInvalid(): boolean {
    return this.step === 3 && this.isRuleSheetInvalid();
  }


  private clearForPerimeter() {
    this.onClearDegradation();
    this.clearAllStepfour();
    this.updateCompetitorPrioritization();
  }

  private updateCompetitorPrioritization() {
    const ruleSheetValue = this.multiStepForm.get('ruleSheet').value;
    this.isCompetitorChecked = ruleSheetValue !== null && ruleSheetValue !== undefined;
    this.multiStepForm.patchValue({
      competitorPrioritization: this.isCompetitorChecked,
    });
  }

  private updateMultiStepForm() {
    // Ensure country/states FormArrays reflect the current selectedCountries before saving
    this.syncCountryStatesForm();
    this.multiStepForm.patchValue({
      id: this.id,
      stage: this.stepLabelText.toUpperCase(),
      status: 'DRAFT',
    });
    this.isDraftFile = true;
    this.isSaved = true;
  }

  private saveDraft(isShowPopupMessage: boolean) {
    if (this.copyMode && !sessionStorage.getItem('copyRequestId')) {
      this.multiStepForm.removeControl('id');
    } else if (this.copyMode && sessionStorage.getItem('copyRequestId')) {
      this.multiStepForm.removeControl('id');
      this.id = sessionStorage.getItem('copyRequestId');
      this.multiStepForm.addControl('id', new FormControl(this.id));
    }
    this.multiStepForm.addControl('customLabel', new FormControl(this.customLabel));
    if (this.compArray.length == 0 && this.isCompetitorChecked) {
      this.utilService.goToTop();
      this.isShowErrorMessageWithToast = true;
      this.isShowError = true;
      this.isMultiStepFormDirty = false;
      let errorMsg = 'Please add at least one Competitor Prioritization detail or uncheck the Competitor Prioritization option to proceed.';
      this.handlePopupErrorMessage(true, errorMsg);
      this.getSharingErorr = 'Please add at least one Competitor Prioritization detail or uncheck the Competitor Prioritization option to proceed.';
      const that = this;
      setTimeout(function () {
        that.isShowError = false;
        that.spinnerService.hide();
      }, 5000);
    } else {
      this.rebuildCompPrioFormControls();
      this.pairingStepFormApi
        .onSaveDraft(this.multiStepForm.value, this.userId)
        .subscribe(
          (res: any) => this.handleSaveSuccess(res, isShowPopupMessage),
          (err: any) => this.handleSaveError(err)
        );
    }

  }

  private rebuildCompPrioFormControls(): void {
    this.compPrioFormControls.clear();
    for (let i = 0; i < this.dynamicArray.length; i++) {
      const item = this.dynamicArray[i];
      if (item.michelinBrand && item.michelinBrand[0]?.brandName &&
          item.michelinTireline && item.michelinTireline[0]?.categoryName &&
          item.competitorBrand && item.competitorBrand[0]?.brandName &&
          item.competitorTireline && item.competitorTireline[0]?.categoryName) {
        this.compPrioFormControls.push(this.fb.group({
          michelinBrand: item.michelinBrand[0].brandName,
          michelinTireline: item.michelinTireline[0].categoryName,
          competitorBrand: item.competitorBrand[0].brandName,
          competitorTireline: item.competitorTireline[0].categoryName,
          priority: item.priority,
          errorMessage: item.errorMessage
        }));
      }
    }
  }

  private handlePopupErrorMessage(isShowPopupMessage: boolean, errorMsg: string) {
    if (isShowPopupMessage) {
      this.displayStyle = 'none';
      this.isConfirmationPopupVisibale = false;
      this.utilService.isTosterVisible(true, errorMsg);
      setTimeout(() => {
        this.isShowErrorMessageWithToast = false;
        this.utilService.isTosterVisible(false, '');
        this.spinnerService.hide();
      }, 5000);

    } else {
      this.isShowErrorMessageWithToast = false;
    }
  }

  private handleSaveSuccess(res: any, isShowPopupMessage: boolean) {
    this.spinnerService.hide();
    const submitRes = res;
    this.id = submitRes.result.requestId;
    this.updatedDate = submitRes.result.updatedDate;
    this.isSavedSuccessfully = true;
    this.utilService.goToTop();
    this.isShowErrorMessageWithToast = true;
    this.isMultiStepFormDirty = false;
    this.isCopyRequestGenerated = true;
    if (this.copyMode) {
      sessionStorage.setItem('copyRequestId', this.id);
    }
    if (this.isConfirmationPopupVisibale && this.currentActionType === this.SAVEDRAFT) {
      this.router.navigate([this.router.url]);
    }

    if (isShowPopupMessage) {
      sessionStorage.removeItem('copyRequestId');
    }
    this.getTimeInterval();
    this.handlePopupMessage(isShowPopupMessage);
  }

  private handleSaveError(err: any) {
    this.isSavedSuccessfully = false;
    this.spinnerService.hide();
  }

  private handlePopupMessage(isShowPopupMessage: boolean) {
    if (isShowPopupMessage) {
      this.displayStyle = 'none';
      this.isConfirmationPopupVisibale = false;
      this.utilService.isTosterVisible(
        true,
        `Request ID ${this.id} has been updated successfully.`
      );
      setTimeout(() => {
        this.isShowErrorMessageWithToast = false;
        this.utilService.isTosterVisible(false, '');
        this.router.navigateByUrl('/', { replaceUrl: true }).then(() =>
          this.router.navigate(['../pairingAsProduct']));
      }, 5000);

    } else {
      this.isShowErrorMessageWithToast = false;
    }
  }


  getTimeInterval() {
    let that = this;
    if (this.getDraftRecordById != undefined && this.updatedDate == undefined)
      this.updatedDate = this.getDraftRecordById?.updatedDate;
    let id = setInterval(function () {
      if (that.id) {
        let date = new Date(that.updatedDate);
        let current = new Date();
        let currentUtc = new Date(
          current.getUTCFullYear(),
          current.getUTCMonth(),
          current.getUTCDate(),
          current.getUTCHours(),
          current.getUTCMinutes(),
          current.getUTCSeconds()
        );
        let diff = Math.abs(currentUtc.getTime() - date.getTime());
        let timegap = Math.ceil(diff / 1000);

        if (timegap / 3600 < 1 && timegap / 60 > 1)
          that.timeInterval = Math.ceil(timegap / 60).toString() + ' minutes ';
        else if (timegap / 60 < 1)
          that.timeInterval = Math.ceil(timegap / 60).toString() + ' seconds ';
        else if (timegap / (3600 * 24) < 1 && timegap / 3600 > 1)
          that.timeInterval = Math.ceil(timegap / 3600).toString() + ' hours ';
        else if (timegap / (3600 * 24) > 1)
          that.timeInterval =
            Math.ceil(timegap / (3600 * 24)).toString() + ' days ';
      } else {
        clearInterval(id);
      }
    }, 5000);
  }

  checkElementNotNull(element: any) {
    if (element == null) {
      console.error(element);
    }
  }

  applyRegionWW() {
    this.isOrderPrefDisable = true;
    this.isPriceMonthDisable = true;
    this.isPriceLogicDisable = true;
    this.isWebsiteDisabled = true;
    this.isMultiStepFormDirty = true;
      this.onDeSelectAllWebsites();
      this.onDeSelectAllPriceLogic();
      this.onDeSelectAllOrderPreferences();
      this.priceDate = '';
      this.multiStepForm.patchValue({
        orderPreference: null,
        mostPopular: 'False',
        mostRecent: 'False',
        priceDate: null,
        pricePeriodStart: null,
        pricePeriodEnd: null,
        priceLogic: null,
        valid_from_date: null,
        validFromDateValue: null,
        websites: null,
      });

  }

  applyNonRegionWW() {
    this.isOrderPrefDisable = false;
    this.isPriceMonthDisable = false;
    this.isPriceLogicDisable = false;
    this.isWebsiteDisabled = false;
    this.isMultiStepFormDirty = false;
    if (!this.editMode) {
      this.onDeSelectAllWebsites();
      this.onDeSelectAllPriceLogic();
      this.onDeSelectAllOrderPreferences();
      this.priceDate = '';
      this.multiStepForm.patchValue({
        orderPreference: null,
        mostPopular: 'False',
        mostRecent: 'False',
        priceDate: null,
        pricePeriodStart: null,
        pricePeriodEnd: null,
        priceLogic: null,
        valid_from_date: null,
        validFromDateValue: null,
        websites: null,
      });
    }
  }

  getParameterId(code: any) {
    this.productLines.forEach((productLine: any) => {
      if (code === productLine.code) {
        this.productLineId = productLine.productLineId;
      }
    });
  }

  getPLCode() {
    if (undefined != this.multiStepForm) {
      let PLArray = (<FormArray>this.multiStepForm.get('productLine')).value;
      if (PLArray.length > 0) {
        return PLArray[0];
      } else {
        return this.getDraftRecordById?.productLine.length > 0
          ? this.getDraftRecordById?.productLine[0]
          : 'TC';
      }
    }
  }

  getPLCodes(): string[] {
    if (undefined != this.multiStepForm) {
      let PLArray = (<FormArray>this.multiStepForm.get('productLine')).value;
      if (PLArray.length > 0) {
        return PLArray;
      } else {
        return this.getDraftRecordById?.productLine.length > 0
          ? this.getDraftRecordById?.productLine
          : ['TC'];
      }
    }
    return ['TC'];
  }



  checkCountryWW(regionCode: any) {
    if (regionCode != 'WW') {
      this.isCountryDisabledOnRegion = false;
    } else {
      this.isCountryDisabledOnRegion = true;
    }
  }

  /**
   * Flattens the raw country list from the API.
   * Countries with states are expanded into one entry per state (e.g. BRAZIL-Rio, BRAZIL-Amazonas).
   * Countries without states remain as a single entry.
   * Each entry carries _parentCountry and _state for later use.
   */
  private flattenCountries(rawCountries: any[]): any[] {
    const flat: any[] = [];
    for (const c of rawCountries) {
      if (c.states && c.states.length > 0) {
        for (const state of c.states) {
          flat.push({
            countryId: `${c.countryId}_${state}`,
            countryNamePfx: `${c.countryNamePfx} - ${state}`,
            countryNameEn: c.countryNameEn,
            _parentCountry: c.countryNamePfx,
            _state: state,
          });
        }
      } else {
        flat.push({
          ...c,
          _parentCountry: c.countryNamePfx,
          _state: null,
        });
      }
    }
    return flat;
  }

  /**
   * Syncs the `country` and `states` FormArrays from the current selectedCountries.
   * - country FormArray stores unique parent country names (e.g. BRAZIL, PERU).
   * - states FormArray stores [{country, states:[]}] only when at least one
   *   selected entry has an associated state; otherwise it stays empty.
   */
  private syncCountryStatesForm(): void {
    const countryFormArray = this.multiStepForm.get('country') as FormArray;
    const statesFormArray = this.multiStepForm.get('states') as FormArray;
    countryFormArray.clear();
    statesFormArray.clear();

    const statesByCountry = new Map<string, string[]>();
    let anyHasState = false;

    for (const item of this.selectedCountries) {
      // ng-multiselect-dropdown strips custom properties from selected items,
      // so look up the full object from this.countries by countryNamePfx.
      const fullItem = this.countries.find(
        (c: any) => c.countryNamePfx === item.countryNamePfx
      ) ?? item;

      const parent: string = fullItem._parentCountry ?? fullItem.countryNamePfx;
      const state: string | null = fullItem._state ?? null;
      if (!statesByCountry.has(parent)) {
        statesByCountry.set(parent, []);
      }
      if (state) {
        statesByCountry.get(parent)!.push(state.toUpperCase());
        anyHasState = true;
      }
    }

    for (const countryName of statesByCountry.keys()) {
      countryFormArray.push(new FormControl(countryName));
    }

    if (anyHasState) {
      for (const [country, states] of statesByCountry) {
        statesFormArray.push(new FormControl({ country, states }));
      }
    }
  }

  /**
   * Restores selectedCountries from a saved draft's country + states arrays.
   * Matches each saved country/state pair back to an entry in the flattened countries list.
   */
  private restoreSelectedCountries(
    flatCountries: any[],
    savedCountries: string[],
    savedStates: { country: string; states: string[] }[]
  ): any[] {
    const result: any[] = [];
    for (const countryName of savedCountries) {
      const stateEntry = savedStates.find(
        (s) => s.country.toUpperCase() === countryName.toUpperCase()
      );
      const savedStateList = stateEntry?.states ?? [];

      if (savedStateList.length > 0) {
        // Restore one entry per saved state
        for (const savedState of savedStateList) {
          if (!savedState) continue;
          const match = flatCountries.find(
            (c) =>
              (c._parentCountry ?? c.countryNamePfx).toUpperCase() ===
                countryName.toUpperCase() &&
              c._state &&
              c._state.toUpperCase() === savedState.toUpperCase()
          );
          if (match) result.push(match);
        }
      } else {
        // Restore the country entry with no state
        const match = flatCountries.find(
          (c) =>
            (c._parentCountry ?? c.countryNamePfx).toUpperCase() ===
              countryName.toUpperCase() && !c._state
        );
        if (match) result.push(match);
      }
    }
    return result;
  }

  clearClustering() {
    this.clusterings = [];
    this.clusteringData = [];
    (<FormArray>this.multiStepForm.get('clustering')).clear();
  }

  clearDegradation() {
    this.degradations = [];
    this.degradationData = [];
    (<FormArray>this.multiStepForm.get('degradation')).clear();
  }

  getMichelinTyreLines(brandIds: any, subSeasonIds: any, usageIds: any) {
    this.pairingStepFormApi
      .getMichelinTyreLines(brandIds, subSeasonIds, usageIds, this.getPLCodes())
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const tyreLinesLists = res;
          this.tyreLines = tyreLinesLists.result;
          if (this.editMode && this.tyreLines != undefined && this.allowTirelineRestore) {
            this.selectedTyreLine = PairingHelper.getSelectedRecords(
              this.tyreLines,
              this.getDraftRecordById?.tirelineX ?? [],
              'categoryName'
            );
          }
          this.tyreLines = this.tyreLines.filter(function (el: any) {
            return el !== 'NULL';
          });
        },
        (err: any) => {
          this.spinnerService.hide();
        }
      );
  }

  getOtherTyreLines(brandIds: any, subSeasonIds: any, usageIds: any) {
    let type = this.isMichelinBrandsExcluded ? 'ExcludeMichelin'  : 'All';
    this.pairingStepFormApi
      .getOtherTyreLines(brandIds, subSeasonIds, usageIds, this.getPLCodes(), type)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const otherTyreLineLists = res;
          this.otherTirelines = otherTyreLineLists.result;
          if (this.otherTirelines.length == 0) {
            this.isOtherTireLineDisabled = true;
          }
          this.otherTirelines = this.otherTirelines.filter(function (el: any) {
            return el !== 'NULL';
          });
          if (this.editMode && this.otherTirelines != undefined && this.allowOtherTirelineRestore) {
            this.selectedOtherTireline = PairingHelper.getSelectedRecords(
              this.otherTirelines,
              this.getDraftRecordById?.tirelineY ?? [],
              'categoryName'
            );
          }
        },
        (err: any) => {
          this.spinnerService.hide();
          //console.log(err);
        }
      );
  }

  getTyreUsage(brandIdList: any, allSeasonIdList: any, plCode: any) {
    // get tyre usage
    this.pairingStepFormApi
      .getTyreUsage(brandIdList, allSeasonIdList, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const tyreUsageLists = res;
          this.tyreUsages = tyreUsageLists.result;
          this.tyreUsages = this.tyreUsages.filter(function (el: any) {
            return el !== 'NULL';
          });
          // Only restore old values on initial load, not after user has manually deselected a season
          if (this.editMode && this.tyreUsages != undefined && this.allowUsageRestore) {
            this.selectedTyreUsage = PairingHelper.getSelectedRecords(
              this.tyreUsages,
              this.getDraftRecordById?.usageX ?? [],
              'usageName'
            );
            if (this.selectedTyreUsage.length > 0)
              this.relativeActionOnTyreUsage();
          }
        },
        (err: any) => {
          this.spinnerService.hide();
        }
      );
    this.alllist = [];
  }

  getTyreOtherUsage(brandIdList: any, allSeasonIdList: any, plCode: any) {
    // get other tyre usage
    this.pairingStepFormApi
      .getOtherTyreUsage(brandIdList, allSeasonIdList, plCode)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          const OtherTyreUsageLists = res;
          this.otherTyreUsages = OtherTyreUsageLists.result;
          this.otherTyreUsages = this.otherTyreUsages.filter(function (
            el: any
          ) {
            return el !== 'NULL';
          });
          // Only restore old values on initial load, not after user has manually deselected a season
          if (this.editMode && this.otherTyreUsages != undefined && this.allowOtherUsageRestore) {
            this.selectedOtherTyreUsage = PairingHelper.getSelectedRecords(
              this.otherTyreUsages,
              this.getDraftRecordById?.usageY ?? [],
              'usageName'
            );
            if (this.selectedOtherTyreUsage.length > 0)
              this.relativeActionOnOtherTyreUsage();
          }
        },
        (err: any) => {
          this.spinnerService.hide();
        }
      );
  }

  // Helper method to get sub season IDs from selected Michelin seasons
  private getSubSeasonIds(selectedSeasons: any[]): any[] {
    if (!this.masterdata || !this.masterdata.subSeasonMap || !selectedSeasons || selectedSeasons.length === 0) {
      return [];
    }
    
    const subSeasonList: any[] = [];
    for (const season of selectedSeasons) {
      const subSeasons = this.masterdata.subSeasonMap[season];
      if (subSeasons) {
        for (const subSeason of subSeasons) {
          if (subSeason && subSeason.subSeasonId) {
            subSeasonList.push(subSeason);
          }
        }
      }
    }
    
    return subSeasonList.map((item: any) => item.subSeasonId);
  }

  // Helper method to get sub season IDs from selected Other/Competitor seasons
  private getOtherSubSeasonIds(selectedSeasons: any[]): any[] {
    if (!this.otherMasterData || !this.otherMasterData.subSeasonMap || !selectedSeasons || selectedSeasons.length === 0) {
      return [];
    }
    
    const subSeasonList: any[] = [];
    for (const season of selectedSeasons) {
      const subSeasons = this.otherMasterData.subSeasonMap[season];
      if (subSeasons) {
        for (const subSeason of subSeasons) {
          if (subSeason && subSeason.subSeasonId) {
            subSeasonList.push(subSeason);
          }
        }
      }
    }
    
    return subSeasonList.map((item: any) => item.subSeasonId);
  }

  public displayTooltip(tooltipObject: MatTooltip) {
    tooltipObject.disabled = false;
    tooltipObject.show()
    setTimeout(() => {
      tooltipObject.disabled = true;
    }, 10000);
  }


  addRow(additionalRowSize: any, onload: boolean) {
    this.isCompPrioComplete = false;
    let rowSize: number = Number(additionalRowSize.value);
    if (isNaN(rowSize)) {
      rowSize = additionalRowSize;
    }

    // If we're in edit mode and loading, first get the competitor prioritization details from file
    if (this.editMode && onload === true && this.getDraftRecordById?.competitorsPrioritizationTable) {
      this.getCompPrioDetailsFromFile(this.getDraftRecordById.competitorsPrioritizationTable, rowSize);
    } else {
      // If not loading from file, process rows immediately
      this.processRowCreation(rowSize, onload);
    }
    return true;
  }

  private processRowCreation(rowSize: number, onload: boolean): Promise<void> {

    if (this.editMode && onload === true && this.getDraftRecordById?.competitorsPrioritizationTable) {
      rowSize = this.getDraftRecordById?.competitorPrioritizationDetails.length;
    }

    // Process rows in batches if there are many rows to prevent browser freezing
    if (rowSize > 100 && this.editMode && onload === true &&
      this.getDraftRecordById?.competitorPrioritizationDetails != undefined) {
      return this.processRowCreationInBatches(rowSize, 0, 100);
    } else {
      // Process all rows synchronously for small datasets or non-edit mode
      for (let i = 0; i < rowSize; i++) {
        if (this.editMode && onload === true &&
          this.getDraftRecordById?.competitorPrioritizationDetails != undefined) {
          let michelinBrandArray: { brandId: number, brandName: string }[] = [{ brandId: 0, brandName: this.getDraftRecordById?.competitorPrioritizationDetails[i].michelinBrand }];
          let michelinTirelineArray: { categoryName: string }[] = [{ categoryName: this.getDraftRecordById?.competitorPrioritizationDetails[i].michelinTireline }];
          let otherBrandArray: { brandId: number, brandName: string }[] = [{ brandId: 0, brandName: this.getDraftRecordById?.competitorPrioritizationDetails[i].competitorBrand }];
          let otherTirelineArray: { categoryName: string }[] = [{ categoryName: this.getDraftRecordById?.competitorPrioritizationDetails[i].competitorTireline }];
          let priorityNumber: number = this.getDraftRecordById?.competitorPrioritizationDetails[i].priority;
          let errorMessage = this.getDraftRecordById?.competitorPrioritizationDetails[i].errorMessage ?? "";
          if (priorityNumber == null || priorityNumber == undefined) {
            priorityNumber = 1;
          }
          this.dynamicArray.push({
            michelinBrand: michelinBrandArray,
            michelinTireline: michelinTirelineArray,
            competitorBrand: otherBrandArray,
            competitorTireline: otherTirelineArray,
            priority: priorityNumber,
            errorMessage: errorMessage
          });

          this.compArray[i] = this.dynamicArray[i].michelinBrand[0]['brandName'] + '-' +
            this.dynamicArray[i].michelinTireline[0]['categoryName'] + '-' +
            this.dynamicArray[i].competitorBrand[0]['brandName'] + '-' +
            this.dynamicArray[i].competitorTireline[0]['categoryName'];
          this.pushDatainCompArray(i);
          this.isCompPrioComplete = true;
        } else {
          this.dynamicArray.push({ michelinBrand: "", michelinTireline: "", competitorBrand: "", competitorTireline: "", priority: 1, errorMessage: "" });
        }
      }
      return Promise.resolve();
    }
  }

  /**
   * Process row creation in batches to prevent browser freezing when loading from draft
   * @param rowSize Total number of rows to create
   * @param startIndex Starting index for processing
   * @param batchSize Number of rows to process in each batch
   * @returns Promise that resolves when all rows are processed
   */
  private processRowCreationInBatches(rowSize: number, startIndex: number, batchSize: number): Promise<void> {
    return new Promise((resolve) => {
      // Initialize progress tracking
      this.isBatchProcessing = true;
      this.batchProcessingTotal = rowSize;
      this.batchProcessingCurrent = 0;
      this.batchProcessingProgress = 0;

      const processBatch = (index: number) => {
        const endIndex = Math.min(index + batchSize, rowSize);

        // Process a batch of rows
        for (let i = index; i < endIndex; i++) {
          if (this.editMode && this.getDraftRecordById?.competitorPrioritizationDetails != undefined) {
            let michelinBrandArray: { brandId: number, brandName: string }[] =
              [{ brandId: 0, brandName: this.getDraftRecordById?.competitorPrioritizationDetails[i].michelinBrand }];
            let michelinTirelineArray: { categoryName: string }[] =
              [{ categoryName: this.getDraftRecordById?.competitorPrioritizationDetails[i].michelinTireline }];
            let otherBrandArray: { brandId: number, brandName: string }[] =
              [{ brandId: 0, brandName: this.getDraftRecordById?.competitorPrioritizationDetails[i].competitorBrand }];
            let otherTirelineArray: { categoryName: string }[] =
              [{ categoryName: this.getDraftRecordById?.competitorPrioritizationDetails[i].competitorTireline }];
            let priorityNumber: number = this.getDraftRecordById?.competitorPrioritizationDetails[i].priority;
            let errorMessage = this.getDraftRecordById?.competitorPrioritizationDetails[i].errorMessage ?? "";

            if (priorityNumber == null || priorityNumber == undefined) {
              priorityNumber = 1;
            }

            this.dynamicArray.push({
              michelinBrand: michelinBrandArray,
              michelinTireline: michelinTirelineArray,
              competitorBrand: otherBrandArray,
              competitorTireline: otherTirelineArray,
              priority: priorityNumber,
              errorMessage: errorMessage
            });

            this.compArray[i] = this.dynamicArray[i].michelinBrand[0]['brandName'] + '-' +
              this.dynamicArray[i].michelinTireline[0]['categoryName'] + '-' +
              this.dynamicArray[i].competitorBrand[0]['brandName'] + '-' +
              this.dynamicArray[i].competitorTireline[0]['categoryName'];
            this.pushDatainCompArray(i);
            this.isCompPrioComplete = true;
          }
        }

        // Update progress
        this.batchProcessingCurrent = endIndex;
        this.batchProcessingProgress = Math.round((endIndex / rowSize) * 100);

        // Trigger change detection after each batch
        this.cdr.detectChanges();

        // If there are more rows to process, schedule the next batch
        if (endIndex < rowSize) {
          setTimeout(() => processBatch(endIndex), 0);
        } else {
          // All rows processed - hide progress bar
          this.isBatchProcessing = false;
          this.batchProcessingProgress = 100;
          this.cdr.detectChanges();
          resolve();
        }
      };

      // Start processing from the startIndex
      processBatch(startIndex);
    });
  }

  deleteRow(index: number) {
    if (this.dynamicArray.length == 1) {
      alert("Can't delete the row when there is only one row");
      return false;
    } else {
      
      this.dynamicArray.splice(index, 1);
      this.compPrioFormControls.removeAt(index);
      this.compArray.splice(index, 1);

      this.reindexTirelineMapsAfterDeletion(index);

      //this.checkAllCompPrioComplete(index);
      this.checkDuplicates();
      this.rebuildConnectorClasses();
      this.refreshcompArray(index);
      return true;
    }
  }

  /**
   * Reindexes the tireline maps after a row deletion
   * @param deletedIndex The index of the deleted row
   * Note: Since maps are now keyed by brand name instead of index, no reindexing is needed
   */
  private reindexTirelineMapsAfterDeletion(deletedIndex: number) {
    // Maps are keyed by brand name, not row index, so no reindexing is needed
  }

  copyRow(index: number, isMultiple: boolean) {
    // Validate that all required fields are defined before copying
    if (!this.dynamicArray[index]?.michelinBrand?.[0]?.brandName ||
        !this.dynamicArray[index]?.michelinTireline?.[0]?.categoryName ||
        !this.dynamicArray[index]?.competitorBrand?.[0]?.brandName ||
        !this.dynamicArray[index]?.competitorTireline?.[0]?.categoryName) {
      console.warn('Skipping copy: One or more required fields are undefined at index', index);
      return;
    }

    let arr = this.dynamicArray;
    let nextIndex: number;
    if (isMultiple) {
      nextIndex = this.dynamicArray.length;
    } else {
      nextIndex = index + 1;
    }
    
    let michelinBrandArray: { brandId: number, brandName: string }[] = [{ brandId: 0, brandName: (this.dynamicArray[index].michelinBrand[0].brandName) }];
    let michelinTirelineArray: { categoryName: string }[] = [{ categoryName: this.dynamicArray[index].michelinTireline[0].categoryName }];
    let otherBrandArray: { brandId: number, brandName: string }[] = [{ brandId: 0, brandName: this.dynamicArray[index].competitorBrand[0].brandName }];
    let otherTirelineArray: { categoryName: string }[] = [{ categoryName: this.dynamicArray[index].competitorTireline[0].categoryName }];
    let priorityNumber: number = this.dynamicArray[index].priority;
    let errorMessage: string = this.dynamicArray[index].errorMessage;

    // Check if the combination already exists in compArray
    const newCombination = michelinBrandArray[0].brandName + '-' +
      michelinTirelineArray[0].categoryName + '-' +
      otherBrandArray[0].brandName + '-' +
      otherTirelineArray[0].categoryName;
    
    // Find all indices where this combination exists
    const duplicateIndices: number[] = [];
    this.compArray.forEach((combo, idx) => {
      if (combo === newCombination) {
        duplicateIndices.push(idx);
      }
    });
    
    // If duplicates exist, adjust nextIndex to be after the last duplicate
    if (duplicateIndices.length > 0) {
      if (!isMultiple) {
        nextIndex = duplicateIndices[duplicateIndices.length - 1] + 1;
      }
    }

    if (index !== -1) {
      arr.splice(nextIndex, 0, {
        michelinBrand: michelinBrandArray,
        michelinTireline: michelinTirelineArray,
        competitorBrand: otherBrandArray,
        competitorTireline: otherTirelineArray,
        priority: priorityNumber,
        errorMessage: errorMessage
      });
    }

    // Reindex the tireline maps after inserting the new row
    this.reindexTirelineMapsAfterInsertion(nextIndex);
    this.compArray[nextIndex] = this.dynamicArray[nextIndex].michelinBrand[0]['brandName'] + '-' +
      this.dynamicArray[nextIndex].michelinTireline[0]['categoryName'] + '-' +
      this.dynamicArray[nextIndex].competitorBrand[0]['brandName'] + '-' +
      this.dynamicArray[nextIndex].competitorTireline[0]['categoryName'];
    this.refreshcompArray(nextIndex);

    // Copy the tireline data from the original row to the new row - brand names are already set
    // No need to copy map entries as they're keyed by brand name, not row index
    this.selectBrandsTirelinesOnEdit([this.dynamicArray[nextIndex].michelinBrand[0]['brandName']],
      [this.dynamicArray[nextIndex].competitorBrand[0]['brandName']]);
    this.cdr.detectChanges();
    if (this.checkDuplicates()) {
      this.isCompPrioComplete = false;
    }
    this.rebuildConnectorClasses();
  }

  /**
   * Reindexes the tireline maps after a row insertion
   * @param insertedIndex The index where the new row was inserted
   * Note: Since maps are now keyed by brand name instead of index, no reindexing is needed
   */
  private reindexTirelineMapsAfterInsertion(insertedIndex: number) {
    // Maps are keyed by brand name, not row index, so no reindexing is needed
  }


  checkAllCompPrioComplete(index: number) {
    const dom: HTMLElement = this.elementRef.nativeElement;
    let elementsLeft = dom.querySelectorAll('.left').length;
    let elementsRight = dom.querySelectorAll('.right').length;
    let elementsDone = dom.querySelectorAll('.done').length;
    let currentElements = dom.querySelectorAll('.con' + index);
    let totalCount = (elementsLeft + elementsRight) - 4;

    
    // Check if the current row is unique in compArray
    const currentRowValue = this.compArray[index];
    const occurrenceCount = this.compArray.filter(str => str === currentRowValue).length;
    
    for (let i = 0; i < currentElements.length; i++) {
      if (currentElements[i].classList.contains('done')) {
        // Only remove 'done' class if the row is not unique (occurs more than once)
        if (occurrenceCount > 1) {
          currentElements[i].classList.remove('done');
          elementsDone = elementsDone - 2;
        }
      }
    }
    if (this.checkDuplicates() && elementsDone != 0) {
      this.isCompPrioComplete = false;
    } else {
      if ((totalCount === elementsDone) && elementsDone > 0) {
        this.isCompPrioComplete = true;
      }
    }
  }
  validateCompRow(index: number) {
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.con' + index);

    //if any of the values are blank
    if (this.dynamicArray[index].michelinBrand == '' ||
      this.dynamicArray[index].michelinTireline == '' ||
      this.dynamicArray[index].competitorBrand == '' ||
      this.dynamicArray[index].competitorTireline == '') {
      this.isCompPrioComplete = false;
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('done');
      }
    }
    else {
      //this line of code is a temporary fix to the issue there only in some scenarios the tireline value is coming inside category name
      this.dynamicArray[index].competitorTireline[0] = typeof this.dynamicArray[index].competitorTireline[0] === 'string'
        ? { categoryName: this.dynamicArray[index].competitorTireline[0] }
        : this.dynamicArray[index].competitorTireline[0];

      this.dynamicArray[index].michelinTireline[0] = typeof this.dynamicArray[index].michelinTireline[0] === 'string'
        ? { categoryName: this.dynamicArray[index].michelinTireline[0] }
        : this.dynamicArray[index].michelinTireline[0];

      const currentRow = this.dynamicArray[index].michelinBrand[0]['brandName'] + '-' + this.dynamicArray[index].michelinTireline[0]['categoryName'] + '-' +
        this.dynamicArray[index].competitorBrand[0]['brandName'] + '-' + this.dynamicArray[index].competitorTireline[0]['categoryName'];

      // Check if all values exist in the respective maps and clear errorMessage if they do
      const michelinBrandName = this.dynamicArray[index].michelinBrand[0]['brandName'];
      const michelinTirelineName = this.dynamicArray[index].michelinTireline[0]['categoryName'];
      const competitorBrandName = this.dynamicArray[index].competitorBrand[0]['brandName'];
      const competitorTirelineName = this.dynamicArray[index].competitorTireline[0]['categoryName'];

      const michelinBrandExists = this.michelinBrands.some((b: { brandName: any; }) => b.brandName === michelinBrandName);
      const michelinTirelineExists = this.michelinTirelineMap.has(michelinBrandName) &&
        this.michelinTirelineMap.get(michelinBrandName)?.includes(michelinTirelineName);
      const competitorBrandExists = this.otherBrands.some((b: { brandName: any; }) => b.brandName === competitorBrandName);
      const competitorTirelineExists = this.otherTirelineMap.has(competitorBrandName) &&
        this.otherTirelineMap.get(competitorBrandName)?.includes(competitorTirelineName);

      if (michelinBrandExists && michelinTirelineExists && competitorBrandExists && competitorTirelineExists) {
        this.dynamicArray[index].errorMessage = "";
      }

      //this is to set the refresh value of the array as per the values on the ui
      this.refreshcompArray(index)
      if (this.hasDunplicates(currentRow)) {
        for (let i = 0; i < elements.length; i++) {
          this.isCompPrioComplete = false;
          elements[i].classList.remove('done');
          elements[i].classList.add('duplicate');
        }
      }
      else if (this.compArray.includes(this.compArray[index])) {
        this.compArray[index] = currentRow;
        this.isCompPrioComplete = true;
        this.pushDatainCompArray(index);
      }

      // After updating this row, check all other rows that still have 'duplicate' class
      // and determine if they are now unique (i.e., original was the only duplicate, now removed)
      this.compArray.forEach((rowValue, j) => {
        if (j !== index && !this.hasDunplicates(rowValue)) {
          const otherElements = dom.querySelectorAll('.con' + j);
          otherElements.forEach(el => {
            if (el.classList.contains('duplicate')) {
              el.classList.remove('duplicate');
              el.classList.add('done');
            }
          });
        }
      });
    }
    if (this.isCompPrioComplete) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add('done');
        elements[i].classList.remove('duplicate');
      }
    }
    this.cdr.detectChanges();
    const elementsLeft = dom.querySelectorAll('.left').length;
    const elementsRight = dom.querySelectorAll('.right').length;
    const elementsDone = dom.querySelectorAll('.done').length;
    const totalCount = (elementsLeft + elementsRight) - 2;

    //calling common method to check for any duplicates
    if (this.checkDuplicates() && elementsDone != 0) {
      this.isCompPrioComplete = false;
    } else {
      if ((totalCount === elementsDone) && elementsDone > 0) {
        this.isCompPrioComplete = true;
      } else {
        this.isCompPrioComplete = false;
      }
    }

  }

  pushDatainCompArray(index: number) {
    if (this.dynamicArray[index] != undefined) {
      const michelinBrand = this.dynamicArray[index].michelinBrand[0]['brandName'];
      const michelinTireline = this.dynamicArray[index].michelinTireline[0]['categoryName'];
      const competitorBrand = this.dynamicArray[index].competitorBrand[0]['brandName'];
      const competitorTireline = this.dynamicArray[index].competitorTireline[0]['categoryName'];
      const priority = this.dynamicArray[index].priority;

      const alreadyExists = this.compPrioFormControls.controls.some((compPrioFormControl: any) =>
        compPrioFormControl.value.michelinBrand === michelinBrand &&
        compPrioFormControl.value.michelinTireline === michelinTireline &&
        compPrioFormControl.value.competitorBrand === competitorBrand &&
        compPrioFormControl.value.competitorTireline === competitorTireline &&
        compPrioFormControl.value.priority === priority
      );

      if (!alreadyExists) {
        this.compPrioFormControls.push(
          this.fb.group({
            michelinBrand,
            michelinTireline,
            competitorBrand,
            competitorTireline,
            priority,
            errorMessage: this.dynamicArray[index].errorMessage
          }));
      }
    }
  }

  /**
   * Process competitor priority rows in batches to prevent browser freezing
   * @param competitorPriorityDtoList List of competitor priority data
   * @param startIndex Starting index for processing
   * @param batchSize Number of rows to process in each batch
   * @returns Promise that resolves when all rows are processed
   */
  private processCompPrioRowsInBatches(
    competitorPriorityDtoList: any[],
    startIndex: number,
    batchSize: number
  ): Promise<void> {
    return new Promise((resolve) => {
      // Initialize progress tracking
      this.isBatchProcessing = true;
      this.batchProcessingTotal = competitorPriorityDtoList.length;
      this.batchProcessingCurrent = 0;
      this.batchProcessingProgress = 0;

      const processBatch = (index: number) => {
        const endIndex = Math.min(index + batchSize, competitorPriorityDtoList.length);

        // Process a batch of rows
        for (let i = index; i < endIndex; i++) {
          const currentRow = competitorPriorityDtoList[i].michelinBrand + '-' +
            competitorPriorityDtoList[i].michelinTireline + '-' +
            competitorPriorityDtoList[i].competitorBrand + '-' +
            competitorPriorityDtoList[i].competitorTireline;

          if (!this.compArray.includes(currentRow)) {
            let michelinBrandArray: { brandId: number, brandName: string }[] =
              [{ brandId: 0, brandName: competitorPriorityDtoList[i].michelinBrand }];
            let michelinTirelineArray: { categoryName: string }[] =
              [{ categoryName: competitorPriorityDtoList[i].michelinTireline }];
            let otherBrandArray: { brandId: number, brandName: string }[] =
              [{ brandId: 0, brandName: competitorPriorityDtoList[i].competitorBrand }];
            let otherTirelineArray: { categoryName: string }[] =
              [{ categoryName: competitorPriorityDtoList[i].competitorTireline }];
            let priorityNumber: number = competitorPriorityDtoList[i].priority;
            let errorMessage = competitorPriorityDtoList[i].errorMessage;

            if (priorityNumber == null || priorityNumber == undefined) {
              priorityNumber = 1;
            }

            this.dynamicArray.push({
              michelinBrand: michelinBrandArray,
              michelinTireline: michelinTirelineArray,
              competitorBrand: otherBrandArray,
              competitorTireline: otherTirelineArray,
              priority: priorityNumber,
              errorMessage: errorMessage
            });

            const currentIndex = this.dynamicArray.length - 1;
            this.compArray[currentIndex] = currentRow;
            this.pushDatainCompArray(currentIndex);
          }
        }

        // Update progress
        this.batchProcessingCurrent = endIndex;
        this.batchProcessingProgress = Math.round((endIndex / competitorPriorityDtoList.length) * 100);

        // Trigger change detection after each batch
        this.cdr.detectChanges();

        // If there are more rows to process, schedule the next batch
        if (endIndex < competitorPriorityDtoList.length) {
          setTimeout(() => processBatch(endIndex), 0);
        } else {
          // All rows processed - hide progress bar
          this.isBatchProcessing = false;
          this.batchProcessingProgress = 100;
          this.cdr.detectChanges();
          resolve();
        }
      };

      // Start processing from the startIndex
      processBatch(startIndex);
    });
  }



  hasDunplicates(currentRow: string) {

    const occurrences = this.compArray.reduce((count, item) => {
      return item === currentRow ? count + 1 : count;
    }, 0);

    return this.compArray.includes(currentRow) && occurrences > 1;
  }
  refreshcompArray(index: number) {

    if (this.dynamicArray[index] != undefined) {
      const currentRow = this.dynamicArray[index].michelinBrand[0]['brandName'] + '-' + this.dynamicArray[index].michelinTireline[0]['categoryName'] + '-' +
        this.dynamicArray[index].competitorBrand[0]['brandName'] + '-' + this.dynamicArray[index].competitorTireline[0]['categoryName'];
      this.compArray[index] = currentRow;
    }
  }

  private rebuildConnectorClasses(): void {
    const duplicateSet = new Set(
      this.getRealTimeIndexForDuplicates().map(i => i - 1) // convert from 1-based to 0-based
    );
    const dom: HTMLElement = this.elementRef.nativeElement;
    this.dynamicArray.forEach((_, idx) => {
      const elements = dom.querySelectorAll('.con' + idx);
      const isDuplicate = duplicateSet.has(idx);
      elements.forEach(el => {
        if (isDuplicate) {
          el.classList.remove('done');
          el.classList.add('duplicate');
        } else {
          el.classList.remove('duplicate');
          el.classList.add('done');
        }
      });
    });
  }

  checkDuplicates() {
    let flag: boolean;
    let duplicates = this.getRealTimeIndexForDuplicates();
    let duplicateCounString = '';
    if(duplicates.length > 10) {
      duplicateCounString = duplicates.slice(0, 10).toString().concat('... and more');
    } else {
      duplicateCounString = duplicates.toString();
    }
    this.duplicateError = 'Rows ' + duplicateCounString + ' are duplicate: Duplicate Prioritisation is not allowed, please make sure that all above rows are unique.';
    
    const i = this.compErrorArray.indexOf(this.duplicateError, 0);

    if (duplicates.length === 0) {
      this.compErrorArray.splice(i, 1);
      flag = false;
    }
    else {
      this.compErrorArray.splice(i, 1);
      this.compErrorArray.push(this.duplicateError);
      flag = true;
    }
    if (duplicates.length > 0) {
      this.isCompPrioComplete = false;
    } else {
      this.isCompPrioComplete = true;
    }
    this.cdr.detectChanges();
    return flag;
  }

  selectBrands(index: number, item: any, brand_type: string) {
    if (!item) return;

    // Clear the respective tireline when a brand is selected
    if (brand_type === 'Michelin') {
      this.dynamicArray[index].michelinTireline = '';
    } else {
      this.dynamicArray[index].competitorTireline = '';
    }

    this.spinnerService.show();
    let brandName = item.brandName;
    let otherMichelinBrand = false;
    // Check if brand tirelines already exist in the map
    let tirelineMap = brand_type === 'Michelin' ? this.michelinTirelineMap : this.otherTirelineMap;
    if(brand_type === 'other' && !tirelineMap.has(brandName)) {
      tirelineMap = this.michelinTirelineMap;
      otherMichelinBrand = true;
    }
    if (tirelineMap.has(brandName)) {
      // Use cached tirelines from the map
      this.tireLines = tirelineMap.get(brandName) || [];
      // Update the filtered array for this specific row
      if (brand_type === 'Michelin') {
        this.filteredMichelinTirelinesPerRow.set(index, this.tireLines);
      } else {
        this.filteredCompetitorTirelinesPerRow.set(index, this.tireLines);
      }
      this.cdr.detectChanges();
      this.spinnerService.hide();
      this.validateCompRow(index);
    } else {
      // Fetch tirelines from API if not in map
      this.pairingStepFormApi
        .getTirelinesValues(brandName, this.getPLCodes(), brand_type)
        .subscribe({
          next: (res) => {
            this.spinnerService.hide();
            const tyreLinesLists = res;
            // Normalize to string[]: API may return plain strings or objects {categoryName: string}
            const normalized: string[] = (tyreLinesLists.result || []).map(
              (t: any) => (typeof t === 'string' ? t : (t.categoryName ?? String(t)))
            );
            this.tireLines = normalized;
            if (brand_type === 'Michelin' || otherMichelinBrand) {
              this.michelinTirelineMap.set(brandName, normalized);
              this.filteredMichelinTirelinesPerRow.set(index, normalized);
            } else {
              this.otherTirelineMap.set(brandName, normalized);
              this.filteredCompetitorTirelinesPerRow.set(index, normalized);
            }
            this.cdr.detectChanges();
            this.validateCompRow(index);
          }, error: (err) => {
            console.error('Error fetching tirelines:', err);
            this.spinnerService.hide();
            this.validateCompRow(index);
          }
        });
    }
  }


  unselectBrands(index: number, type: string) {
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.con' + index);
    if (type === 'Michelin') {
      this.dynamicArray[index].michelinTireline = '';
      const michelinBrandName = this.dynamicArray[index]?.michelinBrand?.[0]?.brandName;
      if (michelinBrandName) {
        this.michelinTirelineMap.set(michelinBrandName, []);
      }
    } else {
      this.dynamicArray[index].competitorTireline = '';
      const competitorBrandName = this.dynamicArray[index]?.competitorBrand?.[0]?.brandName;
      if (competitorBrandName) {
        this.otherTirelineMap.set(competitorBrandName, []);
      }
    }
    for (let i = 0; i < elements.length; i++) {
      this.isCompPrioComplete = false;
      elements[i].classList.remove('done');
      elements[i].classList.remove('duplicate');
    }
    let currentRow = this.compArray[index];
    const i = this.compArray.indexOf(currentRow, 0);
    if (i > -1) {
      this.compArray.splice(i, 1);
    }
    this.compPrioFormControls.removeAt(index);
    this.validateCompRow(index);
  }

  unselectTireline(index: number) {
    let currentRow = this.compArray[index];
    const i = this.compArray.indexOf(currentRow, 0);
    this.compPrioFormControls.removeAt(index);
    this.validateCompRow(index);
  }

  addRowOnClick(additionalRowSize: any, onload: boolean) {
    let rowSize: number = Number(additionalRowSize.value);
    let currentSize = this.dynamicArray.length;
    if (rowSize > 100) {
      alert('Only 100 rows can be added at a time.');
      return false;
    }
    this.spinnerService.show();
    this.addRow(additionalRowSize, onload);

    if (isNaN(rowSize)) {
      rowSize = additionalRowSize;
    }
    this.cdr.detectChanges();
    let totalCount = currentSize + rowSize;
    const dom: HTMLElement = this.elementRef.nativeElement;
    for (let i = currentSize; i < totalCount; i++) {
      const elements = dom.querySelectorAll('.con' + i);
      for (let j = 0; j < elements.length; j++) {
        elements[j].classList.remove('done');
      }
    }
    setTimeout(() => {
      this.spinnerService.hide();
    }, 1000);
    return true;
  }


  onPriorityChange(index: number, value: number) {
    this.dynamicArray[index].priority = value;

    const formGroup = (this.compPrioFormControls as FormArray).at(index) as FormGroup;
    formGroup.reset();
    formGroup.patchValue({
      michelinBrand: this.dynamicArray[index].michelinBrand[0]['brandName'],
      michelinTireline: this.dynamicArray[index].michelinTireline[0]['categoryName'],
      competitorBrand: this.dynamicArray[index].competitorBrand[0]['brandName'],
      competitorTireline: this.dynamicArray[index].competitorTireline[0]['categoryName'],
      priority: this.dynamicArray[index].priority,
      errorMessage: this.dynamicArray[index].errorMessage
    });
  }

  askClearCompPrio() {
    this.currentActionType = this.CLEARCOMPPRIO;
    this.popupMessage = PairingConst.CLEARALL_ROWS_MSG;
    this.isMultiStepFormDirty = true;
    if (this.checkFormDirtyState(false)) {
      this.displayStyle = 'block';
      this.isConfirmationPopupVisibale = true;
    } else {
      this.clearCompPrio(true);
    }
  }

  clearCompPrio(isCompetitorChecked: boolean) {
    if (isCompetitorChecked) {

      this.compPrioFormControls.clear();
      this.dynamicArray = [];
      this.compArray = [];
      this.dynamicArray = [];
      (<FormArray>this.multiStepForm.get('competitorPrioritizationDetails')).clear();
      this.dynamicArray.push({ michelinBrand: "", michelinTireline: "", competitorBrand: "", competitorTireline: "", priority: 1, errorMessage: "" });
      this.isCompPrioComplete = false;
      this.compErrorArray = [];
    }

    this.cdr.detectChanges();

    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      let elementsDone = dom.querySelectorAll('.done').length;
      if (elementsDone > 0) {
        const dom: HTMLElement = this.elementRef.nativeElement;
        let elementsDone = dom.querySelectorAll('.done').length;
        let currentElements = dom.querySelectorAll('.con0');
        for (let i = 0; i < currentElements.length; i++) {
          if (currentElements[i].classList.contains('done')) {
            currentElements[i].classList.remove('done');
            elementsDone = elementsDone - 2;
          }
        }
        this.isCompPrioComplete = false;

      }
    }, 0);
  }

  getCompPrioDetailsFromFile(fileName: string, rowSize?: number) {
    this.spinnerService.show();
    this.pairingStepFormApi.getCompPrioDetailsFromFile(fileName, this.getPLCodes()).subscribe(
      async (response) => {
        if (this.getDraftRecordById) {
          this.getDraftRecordById.competitorPrioritizationDetails = response.result;
          if (rowSize !== undefined) {
            await this.processRowCreation(rowSize, true);
          }
        }
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      },
      async (error) => {
        //console.log(error);

        if (rowSize !== undefined) {
          await this.processRowCreation(rowSize, true);
        }

        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      }
    );
  }

  selectAllRows() {
    this.selectedRowIndices = [];
    for (let i = 0; i < this.dynamicArray.length; i++) {
      this.selectedRowIndices.push(i + 1);
    }

    this.updateCheckboxStates(true);
  }

  private updateCheckboxStates(selectAll: boolean) {
    const checkboxes = document.querySelectorAll('input[name="selectCompRow"]') as NodeListOf<HTMLInputElement>;
    checkboxes.forEach((checkbox) => {
      checkbox.checked = selectAll;
    });
  }

  deselectAllRows() {
    this.selectedRowIndices = [];
    this.updateCheckboxStates(false);
  }

  get areAllRowsSelected(): boolean {
    return this.dynamicArray.length > 0 && this.selectedRowIndices.length === this.dynamicArray.length;
  }

  get areNoRowsSelected(): boolean {
    return this.selectedRowIndices.length === 0;
  }

  // Helper method to check if a row is selected for dragging
  isRowSelected(index: number): boolean {
    return this.selectedRowIndices.includes(index + 1); // Convert 0-based to 1-based
  }

  // Helper method to get the count of selected rows for display
  getSelectedRowCount(): number {
    return this.selectedRowIndices.length;
  }

  // Helper method to provide visual feedback during multiple row drag
  getMultipleDragPreview(): string {
    if (this.selectedRowIndices.length > 1) {
      return `Moving ${this.selectedRowIndices.length} selected rows`;
    }
    return '';
  }

  // Helper method to check if any row has error message
  hasCompPrioErrors(): boolean {
    return this.dynamicArray.some(row => row.errorMessage && row.errorMessage.trim() !== '');
  }

  // Drag start event handler for providing visual feedback
  onDragStart(event: any, index: number) {
    if (this.selectedRowIndices.length > 1 && this.isRowSelected(index)) {
      // Add visual feedback for multiple row drag
      this.isMultipleDragMode = true;
    } else {
      this.isMultipleDragMode = false;
    }
  }

  // Drag end event handler to clean up visual feedback
  onDragEnd(event: any) {
    this.isMultipleDragMode = false;
  }  // Keyboard shortcut handler for row selection
  onKeyDown(event: KeyboardEvent) {
    // Ctrl+A or Cmd+A to select all rows
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      this.selectAllRows();
    }
    // Escape key to deselect all rows
    else if (event.key === 'Escape') {
      this.deselectAllRows();
    }
  }

  onSelectCompRow(index: number, event: any) {
    const isChecked = event.target.checked;
    index = index + 1;

    if (isChecked) {
      if (!this.selectedRowIndices.includes(index)) {
        this.selectedRowIndices.push(index);
      }
    } else {
      const indexPosition = this.selectedRowIndices.indexOf(index);
      if (indexPosition > -1) {
        this.selectedRowIndices.splice(indexPosition, 1);
      }
    }
  }

 
  compPrioOperations(operation: string) {
    this.spinnerService.show();
    if (operation === 'DELETE') {
      if (this.dynamicArray.length == this.selectedRowIndices.length) {
        alert("At least one row must remain. Can't delete all rows.");
        setTimeout(() => {
        this.deselectAllRows();
        this.spinnerService.hide();
      }, 3000);
        return false;
      }
      this.selectedRowIndices.sort((a, b) => b - a);
    } else {
      this.selectedRowIndices.sort((a, b) => a - b);
    }

    const totalSelectedRows = this.selectedRowIndices.length;

    // If more than 100 rows selected, use batch processing with progress bar
    if (totalSelectedRows > 100) {
      // Defer batch processing so the spinner gets a paint cycle before it is hidden by the progress bar
      setTimeout(() => this.processCompPrioOperationsInBatches(operation, this.selectedRowIndices), 50);
    } else {
      // For 100 or fewer rows, use the original approach with spinner
      this.spinnerService.show();

      for (let i = 0; i < this.selectedRowIndices.length; i++) {
        const rowIndex = this.selectedRowIndices[i] - 1;

        if (operation === 'COPY') {
          this.copyRow(rowIndex, true);
        } else if (operation === 'DELETE') {
          this.deleteRow(rowIndex);
        }
      }
      setTimeout(() => {
        this.deselectAllRows();
        this.spinnerService.hide();
      }, 3000);
    }
    return true;
  }

  /**
   * Process competitor prioritization operations (copy/delete) in batches with progress tracking
   * @param operation Type of operation: 'COPY' or 'DELETE'
   * @param selectedIndices Array of selected row indices
   * @returns Promise that resolves when all operations are complete
   */
  private processCompPrioOperationsInBatches(operation: string, selectedIndices: number[]): Promise<void> {
    return new Promise((resolve) => {
      // Initialize progress tracking
      this.isCompPrioOpsProcessing = true;
      this.compPrioOpsTotal = selectedIndices.length;
      this.compPrioOpsCurrent = 0;
      this.compPrioOpsProgress = 0;
      this.compPrioOpsType = operation;

      // Render the progress bar, then hide the spinner
      this.cdr.detectChanges();
      this.spinnerService.hide();

      const batchSize = 50; // Process 50 rows at a time

      const processBatch = (index: number) => {
        const endIndex = Math.min(index + batchSize, selectedIndices.length);

        // Process a batch of operations
        for (let i = index; i < endIndex; i++) {
          const rowIndex = selectedIndices[i] - 1;

          if (operation === 'COPY') {
            this.copyRow(rowIndex, true);
          } else if (operation === 'DELETE') {
            this.deleteRow(rowIndex);
          }
        }

        // Update progress
        this.compPrioOpsCurrent = endIndex;
        this.compPrioOpsProgress = Math.round((endIndex / selectedIndices.length) * 100);

        // Trigger change detection after each batch
        this.cdr.detectChanges();

        // If there are more operations to process, schedule the next batch
        if (endIndex < selectedIndices.length) {
          setTimeout(() => processBatch(endIndex), 50); // Small delay between batches
        } else {
          // All operations completed
          setTimeout(() => {
            this.isCompPrioOpsProcessing = false;
            this.compPrioOpsProgress = 100;
            this.deselectAllRows();
            this.cdr.detectChanges();
            resolve();
          }, 500); // Show 100% for a moment before hiding
        }
      };

      // Start processing from the first index
      processBatch(0);
    });
  }
  

  // Helper method to get real-time index for rows with duplicate detection
  getRealTimeIndexForDuplicates(): number[] {
    const duplicateIndices: number[] = [];
    const seen = new Map<string, number[]>();

    // Build combination directly from dynamicArray (source of truth) to avoid
    // stale compArray entries caused by unsync'd splices and direct index writes.
    this.dynamicArray.forEach((row: any, index: number) => {
      if (!row ||
          !row.michelinBrand?.[0]?.brandName ||
          !row.michelinTireline?.[0]?.categoryName ||
          !row.competitorBrand?.[0]?.brandName ||
          !row.competitorTireline?.[0]?.categoryName) return;

      const value = row.michelinBrand[0].brandName + '-' +
                    row.michelinTireline[0].categoryName + '-' +
                    row.competitorBrand[0].brandName + '-' +
                    row.competitorTireline[0].categoryName;

      if (!seen.has(value)) {
        seen.set(value, []);
      }
      seen.get(value)!.push(index + 1);
    });

    // Collect indices for every value that appears more than once
    seen.forEach((indices) => {
      if (indices.length > 1) {
        indices.forEach(i => duplicateIndices.push(i));
      }
    });

    return duplicateIndices.sort((a, b) => a - b);
  }

  // Helper method to update class names after drag and drop
  updateDuplicateClassNames() {
    const dom: HTMLElement = this.elementRef.nativeElement;

    // Get all form groups with data-row-index
    const formGroups = dom.querySelectorAll('[data-row-index]');

    formGroups.forEach((formGroup: Element, actualIndex: number) => {
      const dataRowIndex = formGroup.getAttribute('data-row-index');
      const oldIndex = dataRowIndex ? parseInt(dataRowIndex) : 0;

      // Update the data-row-index to match the actual position
      formGroup.setAttribute('data-row-index', actualIndex.toString());

      // Find connection elements within this formGroup
      const connectionDiv = formGroup.querySelector('.connection');
      if (connectionDiv) {
        const leftDiv = connectionDiv.querySelector('.left');
        const rightDiv = connectionDiv.querySelector('.right');

        // Remove old con{number} classes
        if (leftDiv) {
          leftDiv.classList.remove('con' + oldIndex);
          leftDiv.classList.add('con' + actualIndex);
        }
        if (rightDiv) {
          rightDiv.classList.remove('con' + oldIndex);
          rightDiv.classList.add('con' + actualIndex);
        }
      }
    });
  }

  // Multiple row drag and drop method for reordering selected competitor prioritization rows
  onDropMultipleCompRows(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex && this.selectedRowIndices.length > 0) {
      // Convert selected row indices from 1-based to 0-based
      const selectedIndices = this.selectedRowIndices.map(index => index - 1).sort((a, b) => a - b);

      // Check if the dragged row is one of the selected rows
      const draggedRowIndex = event.previousIndex;
      if (!selectedIndices.includes(draggedRowIndex)) {
        // If dragged row is not selected, fall back to single row drag
        this.onDropCompRow(event);
        return;
      }

      // Calculate the target insertion point
      let insertIndex = event.currentIndex;

      // Extract selected rows data
      const selectedRows = {
        dynamicArray: selectedIndices.map(index => this.dynamicArray[index]),
        compArray: selectedIndices.map(index => this.compArray[index]),
        formControls: selectedIndices.map(index => this.compPrioFormControls.at(index)),
        michelinTirelines: new Map<string, any[]>(),
        otherTirelines: new Map<string, any[]>()
      };

      // Store tireline map data for selected rows by brand name
      selectedIndices.forEach(index => {
        const michelinBrandName = this.dynamicArray[index]?.michelinBrand?.[0]?.brandName;
        const competitorBrandName = this.dynamicArray[index]?.competitorBrand?.[0]?.brandName;

        if (michelinBrandName && this.michelinTirelineMap.has(michelinBrandName)) {
          selectedRows.michelinTirelines.set(michelinBrandName, this.michelinTirelineMap.get(michelinBrandName)!);
        }
        if (competitorBrandName && this.otherTirelineMap.has(competitorBrandName)) {
          selectedRows.otherTirelines.set(competitorBrandName, this.otherTirelineMap.get(competitorBrandName)!);
        }
      });

      // Remove selected rows from arrays (in reverse order to maintain indices)
      for (let i = selectedIndices.length - 1; i >= 0; i--) {
        const index = selectedIndices[i];
        this.dynamicArray.splice(index, 1);
        this.compArray.splice(index, 1);
        this.compPrioFormControls.removeAt(index);
        // Note: Don't delete from tireline maps as they're keyed by brand name, not index
      }

      // Adjust insertion index if needed
      const numSelectedBefore = selectedIndices.filter(index => index < insertIndex).length;
      insertIndex -= numSelectedBefore;

      // Insert selected rows at the new position
      selectedRows.dynamicArray.forEach((item, i) => {
        this.dynamicArray.splice(insertIndex + i, 0, item);
        this.compArray.splice(insertIndex + i, 0, selectedRows.compArray[i]);
        this.compPrioFormControls.insert(insertIndex + i, selectedRows.formControls[i]);
      });

      // Rebuild tireline maps with new indices
      this.rebuildTirelineMapsAfterMultipleDrop(selectedRows, insertIndex);

      // Update selected row indices to new positions
      this.selectedRowIndices = [];
      for (let i = 0; i < selectedRows.dynamicArray.length; i++) {
        this.selectedRowIndices.push(insertIndex + i + 1); // Convert back to 1-based
      }

      // Update duplicate class names to match new indices
      this.updateDuplicateClassNames();

      // Trigger change detection to update the UI
      this.cdr.detectChanges();

    }
  }

  // Helper method to rebuild tireline maps after multiple row drag and drop
  // Note: Since maps are now keyed by brand name instead of index, no rebuilding is needed
  private rebuildTirelineMapsAfterMultipleDrop(selectedRows: any, insertIndex: number) {
    // Maps are keyed by brand name, not row index, so no rebuilding is needed
    // The brand-based entries remain valid regardless of row reordering
  }

  // Helper method to determine if multiple row drag mode should be used
  shouldUseMultipleDragMode(draggedRowIndex: number): boolean {
    // Use multiple drag mode if:
    // 1. Multiple rows are selected AND
    // 2. The dragged row is one of the selected rows
    return this.selectedRowIndices.length > 1 &&
      this.selectedRowIndices.includes(draggedRowIndex + 1); // Convert to 1-based index
  }

  // Drag and drop method for reordering competitor prioritization rows
  onDropCompRow(event: CdkDragDrop<any[]>) {
    // Check if we should use multiple row drag mode
    if (this.shouldUseMultipleDragMode(event.previousIndex)) {
      this.onDropMultipleCompRows(event);
      return;
    }
    


    if (event.previousIndex !== event.currentIndex) {
      // Move item in the dynamicArray
      moveItemInArray(this.dynamicArray, event.previousIndex, event.currentIndex);

      // Move item in the compArray
      moveItemInArray(this.compArray, event.previousIndex, event.currentIndex);

      // Update the FormArray controls
      const formArray = this.compPrioFormControls;
      const movedControl = formArray.at(event.previousIndex);
      formArray.removeAt(event.previousIndex);
      formArray.insert(event.currentIndex, movedControl);

      // Update tireline maps if they exist
      this.reindexTirelineMapsAfterDrop(event.previousIndex, event.currentIndex);

      // Only clear selections when dragging the actually selected row(s)
      const draggedRowIsSelected = this.selectedRowIndices.includes(event.previousIndex + 1);

      if (draggedRowIsSelected) {
        if (this.selectedRowIndices.length === 1) {
          // Single selected row was dragged - clear selection
          this.deselectAllRows();
        } else {
          // Multiple rows selected and one was dragged - update indices
          // Remove old position and add new position
          const indexPosition = this.selectedRowIndices.indexOf(event.previousIndex + 1);
          if (indexPosition > -1) {
            this.selectedRowIndices.splice(indexPosition, 1);
          }
          this.selectedRowIndices.push(event.currentIndex + 1);

          // Also adjust other selected indices that were affected by the move
          this.selectedRowIndices = this.selectedRowIndices.map(selectedIndex => {
            const zeroBasedSelected = selectedIndex - 1;
            if (event.previousIndex < event.currentIndex) {
              // Moving down: rows between old and new position move up
              if (zeroBasedSelected > event.previousIndex && zeroBasedSelected <= event.currentIndex) {
                return selectedIndex - 1;
              }
            } else {
              // Moving up: rows between new and old position move down  
              if (zeroBasedSelected >= event.currentIndex && zeroBasedSelected < event.previousIndex) {
                return selectedIndex + 1;
              }
            }
            return selectedIndex;
          });
        }
      } else {
        // Dragged row is not selected - just update selected indices to account for the move
        this.selectedRowIndices = this.selectedRowIndices.map(selectedIndex => {
          const zeroBasedSelected = selectedIndex - 1;
          if (event.previousIndex < event.currentIndex) {
            // Moving down: rows between old and new position move up
            if (zeroBasedSelected > event.previousIndex && zeroBasedSelected <= event.currentIndex) {
              return selectedIndex - 1;
            }
          } else {
            // Moving up: rows between new and old position move down
            if (zeroBasedSelected >= event.currentIndex && zeroBasedSelected < event.previousIndex) {
              return selectedIndex + 1;
            }
          }
          return selectedIndex;
        });
      }

      // Update duplicate class names to match new indices
      this.updateDuplicateClassNames();

      // Trigger change detection to update the UI
      this.cdr.detectChanges();

    }
  }

  // Helper method to reindex tireline maps after drag and drop
  // Note: Since maps are now keyed by brand name instead of index, no reindexing is needed
  private reindexTirelineMapsAfterDrop(oldIndex: number, newIndex: number) {
    // Maps are keyed by brand name, not row index, so no reindexing is needed
  }

  goToPerimeter() {
    this.isSubmitedSuccessfully = false;
    this.router.navigateByUrl('/', { replaceUrl: true }).then(() =>
      this.router.navigate(['../pairingAsProduct']));
  }

  goToReports() {
    this.utilService.goToReports();
  }

  /**
   * Optimized method to get michelin tirelines for a specific row
   * Used in template to avoid repeated map lookups
   */
  getMichelinTirelinesForRow(index: number): string[] {
    const brandName = this.dynamicArray[index]?.michelinBrand?.[0]?.brandName;
    if (!brandName) return [];
    return this.michelinTirelineMap.get(brandName) || [];
  }

  /**
   * Optimized method to get other/competitor tirelines for a specific row
   * Used in template to avoid repeated map lookups
   */
  getOtherTirelinesForRow(index: number): string[] {
    const brandName = this.dynamicArray[index]?.competitorBrand?.[0]?.brandName;
    if (!brandName) return [];
    if(this.otherTirelineMap.get(brandName) === undefined) {
      return this.michelinTirelineMap.get(brandName) || [];
    } else {
      return this.otherTirelineMap.get(brandName) || [];
    }   
  }

  /**
   * TrackBy function for ngFor to improve performance
   */
  trackByIndex(index: number, item: any): number {
    return index;
  }

  /**
   * Filter methods for comp prio dropdowns with search
   */
  filterMichelinBrands(searchTerm: string, rowIndex: number): void {
    const term = searchTerm.toLowerCase();
    if (!term) {
      this.filteredMichelinBrandsPerRow.set(rowIndex, this.michelinBrands);
    } else {
      const filtered = this.michelinBrands.filter((brand: any) =>
        brand.brandName?.toLowerCase().includes(term)
      );
      this.filteredMichelinBrandsPerRow.set(rowIndex, filtered);
    }
  }

  getFilteredMichelinBrands(rowIndex: number): any[] {
    return this.filteredMichelinBrandsPerRow.get(rowIndex) || this.michelinBrands;
  }

  filterMichelinTirelines(searchTerm: string, rowIndex: number): void {
    const term = searchTerm.toLowerCase();
    const allTirelines = this.getMichelinTirelinesForRow(rowIndex);
    if (!term) {
      this.filteredMichelinTirelinesPerRow.set(rowIndex, allTirelines);
    } else {
      const filtered = allTirelines.filter((tireline: string) =>
        tireline?.toLowerCase().includes(term)
      );
      this.filteredMichelinTirelinesPerRow.set(rowIndex, filtered);
    }
  }

  getFilteredMichelinTirelines(rowIndex: number): any[] {
    return this.filteredMichelinTirelinesPerRow.get(rowIndex) || this.getMichelinTirelinesForRow(rowIndex);
  }

  filterCompetitorBrands(searchTerm: string, rowIndex: number): void {
    const term = searchTerm.toLowerCase();
    if (!term) {
      this.filteredCompetitorBrandsPerRow.set(rowIndex, this.otherBrands);
    } else {
      const filtered = this.otherBrands.filter((brand: any) =>
        brand.brandName?.toLowerCase().includes(term)
      );
      this.filteredCompetitorBrandsPerRow.set(rowIndex, filtered);
    }
  }

  getFilteredCompetitorBrands(rowIndex: number): any[] {
    return this.filteredCompetitorBrandsPerRow.get(rowIndex) || this.otherBrands;
  }

  filterCompetitorTirelines(searchTerm: string, rowIndex: number): void {
    const term = searchTerm.toLowerCase();
    const allTirelines = this.getOtherTirelinesForRow(rowIndex);
    if (!term) {
      this.filteredCompetitorTirelinesPerRow.set(rowIndex, allTirelines);
    } else {
      const filtered = allTirelines.filter((tireline: string) =>
        tireline?.toLowerCase().includes(term)
      );
      this.filteredCompetitorTirelinesPerRow.set(rowIndex, filtered);
    }
  }

  getFilteredCompetitorTirelines(rowIndex: number): any[] {
    return this.filteredCompetitorTirelinesPerRow.get(rowIndex) || this.getOtherTirelinesForRow(rowIndex);
  }

  // Initialize filtered arrays for a row when dropdown opens
  initializeFilteredArraysForRow(rowIndex: number): void {
    this.filteredMichelinBrandsPerRow.set(rowIndex, this.michelinBrands);
    this.filteredMichelinTirelinesPerRow.set(rowIndex, this.getMichelinTirelinesForRow(rowIndex));
    this.filteredCompetitorBrandsPerRow.set(rowIndex, this.otherBrands);
    this.filteredCompetitorTirelinesPerRow.set(rowIndex, this.getOtherTirelinesForRow(rowIndex));
    this.cdr.detectChanges();
    // Reset virtual scroll viewports to top so options are visible without scrolling
    setTimeout(() => {
      document.querySelectorAll('.cdk-virtual-scroll-viewport').forEach((vp: Element) => {
        (vp as HTMLElement).scrollTop = 0;
      });
    }, 0);
  }

  // Show validation error toast message
  private showValidationError(message: string): void {
    this.isToastMsg = message;
    this.isSuccessToast = false;
    this.isShowErrorMessageWithToast = true;
    
    setTimeout(() => {
      this.isShowErrorMessageWithToast = false;
    }, 5000);
  }

}
